import React, {useEffect, useState} from 'react';

import {
    Table,
    Drawer,
    Form,
    Input,
    DatePicker,
    TimePicker,
    Select,
    AutoComplete,
    InputNumber,
    Button,
    Col,
    Row,
    notification,
    Space,
    Tooltip,
    Upload,
    List, Divider, Dropdown, Card,
    Radio,
    Spin,
    Tag,
    Switch,
} from 'antd';
import 'antd/dist/antd.css';

import moment from "moment";

import {catchErrors, getToken, formatDoseByUnit} from "../../Utils/common";
import axios from "axios";
import TextArea from "antd/es/input/TextArea";
import reqwest from "reqwest";
import {PlusOutlined, PrinterOutlined, UploadOutlined, DeleteOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import { Checkbox } from 'antd';
import config from '../../config'
import examenClinicoSchema from '../../schemas/examen_clinico.json'
import anamnesisSchema from '../../schemas/anamnesis.json'
import admisionPsiquiatricaSchema from '../../schemas/admision_psiquiatrica.json'
import admisionClinicaSchema from '../../schemas/admision_clinica.json'
import evolucionClinicaMensualSchema from '../../schemas/evolucion_clinica_mensual.json'
import admisionNutricionSchema from '../../schemas/admision_nutricion.json'
import evolucionPsiquiatricaMensualSchema from '../../schemas/evolucion_psiquiatrica_mensual.json'
import nutricionSchema from '../../schemas/nutricion.json'

const {Option} = Select;


// Mapeo fijo de colores por tipo (código)
const TYPE_COLORS = {
    // Admisiones
    'APS': 'geekblue', 'APQ': 'geekblue', 'ACL': 'geekblue', 'AMU': 'geekblue', 'AAS': 'geekblue', 'ATO': 'geekblue', 'AKI': 'geekblue', 'ANU': 'geekblue',
    // Evoluciones
    'EPS': 'green', 'EPQ': 'green', 'ENF': 'green', 'EKI': 'green', 'ECM': 'green', 'EPM': 'green', 'HDD': 'green', 'TGR': 'green', 'ETO': 'green', 'EMU': 'green',
    // Evaluaciones/controles/mediciones
    'EXP': 'gold', 'EIE': 'gold', 'ECL': 'gold', 'ANA': 'gold', 'CSM': 'gold', 'CSV': 'gold', 'GLU': 'gold', 'PES': 'gold', 'PCA': 'gold',
    // Médicas / otras disciplinas
    'MCL': 'purple', 'MGR': 'purple',
    'NUT': 'magenta', 'ASO': 'cyan', 'EFM': 'volcano', 'PAE': 'orange',
};

function PatientProgress(props) {
    const [filterType, setFilterType] = useState(undefined);
    const [filterDates, setFilterDates] = useState([]);
    const [filterCreator, setFilterCreator] = useState(undefined);
    const [creatorOptions, setCreatorOptions] = useState([]);
    const {patient_id, professional_id} = props;
    const history = useHistory();
    const [data, setData] = useState([])
    const [mainTableLoading, setMainTableLoading] = useState(false)
    const [saveButtonLoading, setSaveButtonLoading] = useState(false)
    const [deleteButtonLoading, setDeleteButtonLoading] = useState(false)
    const [showMainDrawer, setShowMainDrawer] = useState(false)
    const [totalModule, setTotalModule] = useState(0.00)
    const [totalSubModule, setTotalSubModule] = useState(0.00)
    const [disbleUpload, setDisableUpload] = useState(true)

    // Loading state for Drawer content
    const [drawerLoading, setDrawerLoading] = useState(false)

    // Patient Status for read-only mode
    const [patientStatus, setPatientStatus] = useState(undefined);

    useEffect(() => {
        if (!patient_id) return;
        reqwest({
            url: `${config.api_url}/pacients/${patient_id}/`,
            method: 'get',
            type: 'json',
            headers: { 'Authorization': `Token ${getToken()}` },
        }).then(resp => {
            setPatientStatus(resp.status);
        }).catch(() => {
            setPatientStatus(undefined);
        });
    }, [patient_id]);

    const isReadOnly = (patientStatus !== undefined && patientStatus !== 'A') || props.isReadOnly;

    // Evolution
    const [psicologicalAdmision, setPsicologicalAdmision] = useState(false);
    const [psicologicalEvolution, setPsicologicalEvolution] = useState(false);
    const [psiquitricAdmision, setPsiquitricAdmision] = useState(false);
    const [psiquitricEvolution, setPsiquitricEvolution] = useState(false);
    const [psiquitricExam, setPsiquitricExam] = useState(false);
    const [psiquitricNurse, setPsiquitricNurse] = useState(false);
    const [simpleProcedure, setSimpleProcedure] = useState(false);
    const [groupActivityEvolution, setGroupActivityEvolution] = useState(false);
    const [nurseAdmissionEval, setNurseAdmissionEval] = useState(false);
    const [clinicalExam, setClinicalExam] = useState(false);
    const [anamnesis, setAnamnesis] = useState(false);
    const [sujecionMecanica, setSujecionMecanica] = useState(false);
    const [constantesVitales, setConstantesVitales] = useState(false);
    const [glucemia, setGlucemia] = useState(false);
    const [pesoSemanal, setPesoSemanal] = useState(false);
    const [protocoloCaidas, setProtocoloCaidas] = useState(false);
    const [admisionMusicoterapia, setAdmisionMusicoterapia] = useState(false);
    const [admisionAsisSocial, setAdmisionAsisSocial] = useState(false);
    const [admisionTerapiaOcupacional, setAdmisionTerapiaOcupacional] = useState(false);
    const [admisionKinesiologia, setAdmisionKinesiologia] = useState(false);
    const [pae, setPae] = useState(false);
    const [evolucionKinesiologica, setEvolucionKinesiologica] = useState(false);
    const [admisionClinica, setAdmisionClinica] = useState(false);
    const [admisionNutricion, setAdmisionNutricion] = useState(false);
    const [evolucionClinicaMensual, setEvolucionClinicaMensual] = useState(false);
    const [nutricion, setNutricion] = useState(false);
    const [evolucionPsiquiatricaMensual, setEvolucionPsiquiatricaMensual] = useState(false);
    const [typeOptions, setTypeOptions] = useState([]);
    // Track if the user already selected a type when creating a new record
    const [hasTypeSelected, setHasTypeSelected] = useState(false);

    // EIE: opciones abreviadas para marcas por localización (valores completos para guardar)
    const EIE_TAG_OPTIONS = [
        { label: 'Úlc.', value: 'Úlceras' },
        { label: 'Tat.', value: 'Tatuajes' },
        { label: 'Les.', value: 'Lesiones' },
        { label: 'Cic.', value: 'Cicatrices' },
        { label: 'Hem.', value: 'Hematomas' },
    ];
    // EPM: plantillas remotas
    const [epmTemplates, setEpmTemplates] = useState([]);
    const [epmTemplatesLoading, setEpmTemplatesLoading] = useState(false);

    const fetchEpmTemplates = () => {
        setEpmTemplatesLoading(true);
        reqwest({
            url: `${config.api_url}/patientprogress/templates/?type=EPM&active=true`,
            method: 'get',
            type: 'json',
            headers: { 'Authorization': `Token ${getToken()}` },
        }).then(resp => {
            setEpmTemplates(Array.isArray(resp) ? resp : []);
        }).catch(errorInfo => {
            if (errorInfo.status === 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else {
                const error_detail_txt = catchErrors(errorInfo);
                openErrorNotificacion(error_detail_txt);
            }
        }).always(() => setEpmTemplatesLoading(false));
    };
    // EIE: lista fija y ordenada de localizaciones
    const EIE_LOCATIONS = [
        'Hueso occipital',
        'Escápulas',
        'Apófisis espinosas',
        'Coxis',
        'Crestas ilíacas',
        'Sacro',
        'Isquion',
        'Talones',
        'Planta de pies',
        'Orejas',
        'Hombros',
        'Espinas ilíacas anterosuperiores',
        'Trocánteres',
        'Muslos',
        'Cara interna de rodillas',
        'Cara externa de rodillas',
        'Pantorrillas',
        'Maleolos internos',
        'Maleolos externos',
        'Bordes laterales de pies',
    ];

    // PAE options
    const PAE_AUTONOMIA_OPTIONS = ["Autoválido", "Ayuda parcial para la movilización", "Dependencia total"];
    const PAE_PIEL_OPTIONS = ["Integra", "Eritema leve", "Presencia de heridas superficiales", "Úlcera por presión grado I-II", "Úlcera por presión grado III-IV"];
    const PAE_LENGUAJE_OPTIONS = ["Fluido y coherente", "Lentitud en el habla", "Dificultad moderada para articular palabras", "Lenguaje Fluido e incoherente", "Afasia total"];
    const PAE_AUDICION_OPTIONS = ["Normal", "Leve pérdida auditiva", "Moderada pérdida auditiva", "Usa audifonos", "Pérdida total de la audición"];
    const PAE_DENTICION_OPTIONS = ["Completa y funcional", "Dentadura parcial (prótesis funcional)", "Sin prótesis, con dificultad para masticar", "Ausencia total de dentadura"];
    const PAE_VISION_OPTIONS = ["Visión normal", "Uso de lentes correctores", "Visión limitada con dificultad funcional", "Ceguera parcial", "Ceguera total"];
    const PAE_BRADEN_OPTIONS = ["Bajo riesgo (19-23 puntos)", "Riesgo leve (15-18 puntos)", "Riesgo moderado (13-14 puntos)", "Riesgo alto (10-12 puntos)", "Riesgo muy alto (5-9 puntos)"];
    const PAE_AMBULACION_OPTIONS = ["Ambula de forma independiente", "Ambula con asistencia mínima", "Ambula con ayuda técnica (bastón, andador)", "Ambula, pero puede mantenerse de pie", "Totalmente dependiente para la movilización"];
    const PAE_ALIMENTACION_OPTIONS = ["Independiente para alimentarse", "Necesita supervisión para alimentarse", "Alimentación asistida parcial", "Dependiente para alimentación"];
    const PAE_NANDA_OPTIONS = [
        "00004-Riesgo de infección", "00015-Riesgo de estreñimiento", "00016-Deterioro en la eliminación urinaria",
        "00047-Deterioro de la integridad cutánea", "00048-Deterioro en la dentición", "00051-Deterioro en la comunicación verbal",
        "00052-Deterioro en la interacción social", "00085-Deterioro en la movilidad física", "00088-Deterioro en la ambulación",
        "00108-Déficit de autocuidado (baño/higiene)", "00122-Alteración en la percepción (visual-auditiva-etc)",
        "00131-Déficit de memoria", "00154-Vagabundeo", "00179-Riesgo de glucemia inestable", "00193-Descuido personal",
        "00198-Alteración del patrón del sueño", "00233-Sobrepeso", "00238-Deterioro de la bipedestación",
        "00251-Control emocional inestable", "00267-Riesgo de tensión arterial inestable", "00303-Riesgo de caídas del adulto"
    ];
    const PAE_PLAN_AUTOVALIDO_OPTIONS = ["Mantener independencia y autocuidado", "Mejorar la interacción social", "Mejorar el patrón del sueño", "Promover la estimulación cognitiva", "Fortalecer la confianza en toma de decisiones"];
    const PAE_PLAN_AYUDA_PARCIAL_OPTIONS = ["Reducir el riesgo de caídas", "Mejorar la movilidad con fisioterapia", "Evitar úlceras por presión", "Incrementar autonomía en transferencias", "Asegurar adecuada ingesta nutricional"];
    const PAE_PLAN_DEPENDENCIA_OPTIONS = ["Garantizar integridad cutánea", "Mantener hidratación y nutrición adecuada", "Detección precoz de intercurrencias", "Prevenir infecciones con higiene estricta", "Implementar actividades de estimulación pasiva"];
    const PAE_INTERVENCIONES_OPTIONS = [
        "Supervisar medicación diaria", "Cumplimentar las indicaciones médicas", "Supervisar la higiene", "Control diario de signos vitales",
        "Promover participación en actividades cognitivas", "Fomentar hábitos de higiene y autocuidado", "Realizar cambios posturales cada 4 horas",
        "Asistir en transferencias cama-silla", "Aplicar crema hidratante", "Realizar higiene completa diaria",
        "Cambiar pañales cada 2-3 horas o según necesidad", "Realizar evaluación cutánea y registrar hallazgos",
        "Administrar la medicación por turno", "Control de signos vitales por turno"
    ];


    // Form
    const [actaOnRenovation, setActaOnRenovation] = useState(false)
    const [actaExpired, setActaExpired] = useState(false)


    // Table
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    })
    const [filteredInfo, setFilteredInfo] = useState({})
    const [sortedInfo, setSortedInfo] = useState({})
    const [searchText, setSearchText] = useState('')
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [searchedColumn, setSearchedColumn] = useState('')

    const [patientProgressFiles, setPatientProgressFiles] = useState([])
    const [currentIndex, setCurrentIndex] = useState(null)

    const openSuccessNotificacion = (description = "Se guardaron los datos correctamente") => {
        openNotificationWithIcon("success",
            "Operación correcta",
            description)
    }

    const openErrorNotificacion = (description = "Ah ocurrido un error al intentar guardar el registro") => {
        openNotificationWithIcon("error",
            "Operación no completada",
            description)
    }

    const openNotificationWithIcon = (type, message = "Operación correcta", description = "") => {
        notification[type]({
            message: message,
            description: description,
        });
    };

    // Patients
    const [autocompletePacientsOptions, setAutocompletePacientsOptions] = useState([]);
    const [autocompletePacientSelected, setAutocompletePacientSelected] = useState()

    const fetchPatients = (params) => {
        axios.get(`${config.api_url}/pacients/?search=${params}`, {
            headers: {
                'Authorization': `Token ${getToken()}`
            }
        }).then(response => {
            console.log(response)
            let ops = response.data.results.map((values) => {
                return {
                    value: values.id,
                    label: `${values.name} ${values.last_name} (${values.document})`
                }
            })
            setAutocompletePacientsOptions(ops)
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    setSaveButtonLoading(false);
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt)
                }
            });
    }

    const handlePatientSearch = (value) => {
        fetchPatients(value)
    }

    const onSelectAutocompletePacient = (value, option) => {
        procedureForm.setFieldsValue({pacient: value})
        procedureForm.setFieldsValue({pacient_search: option.label})
    }
    const onChangeAutocompletePacient = (value) => {
        if (!value) {
            procedureForm.setFieldsValue({pacient: ''})
            procedureForm.setFieldsValue({pacient_search: ''})
        }
    }

    // Procedures
    const [procedureForm] = Form.useForm();

    const fetchProcedures = (params = {}) => {

        setMainTableLoading(true);
        console.log(params)

        let url_filter = ''

        if ('filters' in params) {
            let pacient_filtered = false
            let filters_tmp = []
            for (const parameter in params['filters']) {
                console.log('url parameters', params['filters'][parameter])
                if (params['filters'][parameter]) {
                    if (parameter === 'pacient__last_name' && patient_id) {
                        filters_tmp.push(`patient_id=${patient_id}`)
                        pacient_filtered = true
                    } else {
                        filters_tmp.push(`${parameter}=${params['filters'][parameter][0]}`)
                    }
                }
            }
            if (patient_id && !pacient_filtered) {
                filters_tmp.push(`patient_id=${patient_id}`)
            }
            console.log(filters_tmp)
            if (filters_tmp.length) {
                url_filter = `?${filters_tmp.join('&')}`
            }
        } else {
            console.log("NO FILTERS!")
            console.log(professional_id)
            console.log(patient_id)
            if (patient_id) {
                url_filter = `?patient_id=${patient_id}&professional_id=${professional_id}`
            }
            else if (professional_id && !patient_id){
                setMainTableLoading(false);
                return
            }
        }

        // Append custom filters (type, date range and creator)
        if (filterType) {
            url_filter += (url_filter ? '&' : '?') + `type=${encodeURIComponent(filterType)}`;
        }
        if (filterDates && filterDates.length === 2 && filterDates[0] && filterDates[1]) {
            const from = moment(filterDates[0]).format('YYYY-MM-DD');
            const to = moment(filterDates[1]).format('YYYY-MM-DD');
            url_filter += (url_filter ? '&' : '?') + `date_from=${from}&date_to=${to}`;
        }
        if (filterCreator) {
            url_filter += (url_filter ? '&' : '?') + `creator=${encodeURIComponent(filterCreator)}`;
        }

        if ('sortField' in params && params['sortField']) {
            let direction = "";
            if (params.sortOrder === "descend")
                direction = "-";
            let indicator = '?'
            if (url_filter) {
                indicator = '&'
            }
            url_filter = `${url_filter}${indicator}ordering=${direction}${params.sortField}`
        }

        if ('pagination' in params) {
            const limit = params.pagination.pageSize

            let offset = (params.pagination.current - 1) * params.pagination.pageSize
            let indicator = '?'
            if (url_filter) {
                indicator = '&'
            }
            url_filter = `${url_filter}${indicator}limit=${limit}&offset=${offset}`
        }

        console.log('url_filter', url_filter)

        reqwest({
            url: `${config.api_url}/patientprogress${url_filter}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(response => {
            console.log(params)
            const results = response.results || [];
            setData(results);
            setPagination({
                'total': response.count,
                'current': params.pagination.current,
                'pageSize': params.pagination.pageSize
            });
            setMainTableLoading(false);
            // Optional: select an item after loading a page (used for cross-page Next/Prev)
            if (typeof params.selectIndex !== 'undefined' && params.selectIndex !== null) {
                let idx = params.selectIndex;
                if (idx === -1) {
                    idx = Math.max(0, results.length - 1);
                }
                if (idx >= 0 && idx < results.length) {
                    setCurrentIndex(idx);
                    const rec = results[idx];
                    if (rec && rec.id) {
                        fetchProcedure(rec.id);
                    }
                }
            }
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    setSaveButtonLoading(false);
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt)
                }
            });
    }

    // Prefill: ECM diagnóstico y tratamiento desde backend
    const prefillECM = () => {
        if (!patient_id) {
            openErrorNotificacion('Debe seleccionar un paciente para prellenar los datos de ECM.');
            return;
        }
        reqwest({
            url: `${config.api_url}/patientprogress/prefill/?patient_id=${patient_id}&type=ECM`,
            method: 'get',
            type: 'json',
            headers: { 'Authorization': `Token ${getToken()}` },
        }).then(resp => {
            const diag = (resp && resp.data && resp.data.diagnostico) ? resp.data.diagnostico : '';
            const trat = (resp && resp.data && Array.isArray(resp.data.tratamiento_farmacologico)) ? resp.data.tratamiento_farmacologico : [];
            const currentData = procedureForm.getFieldValue('data') || {};
            procedureForm.setFieldsValue({ data: { ...currentData, diagnostico: diag, tratamiento_farmacologico: trat } });
        }).catch(errorInfo => {
            if (errorInfo.status === 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else {
                const error_detail_txt = catchErrors(errorInfo);
                openErrorNotificacion(error_detail_txt);
            }
        });
    }

    // Prefill: EPM diagnóstico y esquema farmacológico desde backend (APQ CIE10 + PSI)
    const prefillEPM = () => {
        if (!patient_id) {
            openErrorNotificacion('Debe seleccionar un paciente para prellenar los datos de EPM.');
            return;
        }
        reqwest({
            url: `${config.api_url}/patientprogress/prefill/?patient_id=${patient_id}&type=EPM`,
            method: 'get',
            type: 'json',
            headers: { 'Authorization': `Token ${getToken()}` },
        }).then(resp => {
            const diag = (resp && resp.data && resp.data.diagnostico) ? resp.data.diagnostico : '';
            const esquema = (resp && resp.data && Array.isArray(resp.data.esquema_farmacologico)) ? resp.data.esquema_farmacologico : [];
            const currentData = procedureForm.getFieldValue('data') || {};
            procedureForm.setFieldsValue({ data: { ...currentData, diagnostico: diag, esquema_farmacologico: esquema } });
        }).catch(errorInfo => {
            if (errorInfo.status === 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else {
                const error_detail_txt = catchErrors(errorInfo);
                openErrorNotificacion(error_detail_txt);
            }
        });
    }

    // Prefill: NUT dieta desde última NUT; si no existe, desde última ANU
    const prefillNUT = () => {
        if (!patient_id) { return; }
        const headers = { 'Authorization': `Token ${getToken()}` };
        const setDieta = (texto) => {
            if (!texto) return;
            const currentData = procedureForm.getFieldValue('data') || {};
            const currentNut = currentData.nutricion || {};
            procedureForm.setFieldsValue({ data: { ...currentData, nutricion: { ...currentNut, dieta: texto } } });
        };
        // 1) Buscar última NUT
        reqwest({
            url: `${config.api_url}/patientprogress/?patient_id=${patient_id}&type=NUT&ordering=-create_date&page=1&page_size=1`,
            method: 'get',
            type: 'json',
            headers,
        }).then(resp => {
            const list = Array.isArray(resp) ? resp : (resp.results || []);
            if (list.length > 0) {
                const item = list[0] || {};
                const d = (item.data && item.data.nutricion && item.data.nutricion.dieta) ? item.data.nutricion.dieta : null;
                if (d) { setDieta(d); return; }
            }
            // 2) Fallback: última ANU
            reqwest({
                url: `${config.api_url}/patientprogress/?patient_id=${patient_id}&type=ANU&ordering=-create_date&page=1&page_size=1`,
                method: 'get',
                type: 'json',
                headers,
            }).then(resp2 => {
                const list2 = Array.isArray(resp2) ? resp2 : (resp2.results || []);
                if (list2.length > 0) {
                    const item2 = list2[0] || {};
                    const d2 = (item2.data && item2.data.evaluacion_nutricional && item2.data.evaluacion_nutricional.dieta) ? item2.data.evaluacion_nutricional.dieta : null;
                    if (d2) { setDieta(d2); }
                }
            }).catch(() => {/* ignore */});
        }).catch(() => {/* ignore */});
    }

    const fetchProcedure = (id) => {
        setDrawerLoading(true)
        axios.get(`${config.api_url}/patientprogress/${id}`,
            {
                headers: {
                    'Authorization': `Token ${getToken()}`,
                }
            }
        ).then(response => {
            //TODO: separate fix into a new funct
            // Fix dates to moment
            response.data.create_date = moment(response.data.create_date)
            if (response.data.start_date)
                response.data.start_date = moment(response.data.start_date)
            if (response.data.end_date)
                response.data.end_date = moment(response.data.end_date)
            if (response.data.next_appointment)
                response.data.next_appointment = moment(response.data.next_appointment)
            console.log(response.data);
            const _type = response.data.type
            if (_type === 'APS') {
                setPsicologicalAdmision(true)
            } else {
                setPsicologicalAdmision(false)
            }
            if (_type === 'APQ') {
                setPsiquitricAdmision(true)
            } else {
                setPsiquitricAdmision(false)
            }
            if (_type === 'EPS') {
                setPsicologicalEvolution(true)
            } else {
                setPsicologicalEvolution(false)
            }
            if (_type === 'EPQ') {
                setPsiquitricEvolution(true)
            } else {
                setPsiquitricEvolution(false)
            }
            if (_type === 'EXP') {
                setPsiquitricExam(true)
            } else {
                setPsiquitricExam(false)
            }
            if (_type === 'ENF') {
                setPsiquitricNurse(true)
            } else {
                setPsiquitricNurse(false)
            }
            if (_type === 'TGR') {
                setGroupActivityEvolution(true);
            } else {
                setGroupActivityEvolution(false);
            }
            if (_type === 'EIE') {
                setNurseAdmissionEval(true);
            } else {
                setNurseAdmissionEval(false);
            }
            if (_type === 'ECL') {
                setClinicalExam(true);
            } else {
                setClinicalExam(false);
            }
            // Al abrir una EPM existente, cargar plantillas
            if (_type === 'EPM') {
                fetchEpmTemplates();
            }
            if (_type === 'EPM') {
                setEvolucionPsiquiatricaMensual(true);
            } else {
                setEvolucionPsiquiatricaMensual(false);
            }
            if (_type === 'ANA') {
                setAnamnesis(true);
            } else {
                setAnamnesis(false);
            }
            if (_type === 'CSM') {
                setSujecionMecanica(true);
            } else {
                setSujecionMecanica(false);
            }
            if (_type === 'CSV') {
                setConstantesVitales(true);
            } else {
                setConstantesVitales(false);
            }
            if (_type === 'GLU') {
                setGlucemia(true);
            } else {
                setGlucemia(false);
            }
            if (_type === 'PES') {
                setPesoSemanal(true);
            } else {
                setPesoSemanal(false);
            }
            if (_type === 'PCA') {
                setProtocoloCaidas(true);
            } else {
                setProtocoloCaidas(false);
            }
            if (_type === 'AMU') {
                setAdmisionMusicoterapia(true);
            } else {
                setAdmisionMusicoterapia(false);
            }
            if (_type === 'AAS') {
                setAdmisionAsisSocial(true);
            } else {
                setAdmisionAsisSocial(false);
            }
            if (_type === 'ATO') {
                setAdmisionTerapiaOcupacional(true);
            } else {
                setAdmisionTerapiaOcupacional(false);
            }
            if (_type === 'AKI') {
                setAdmisionKinesiologia(true);
            } else {
                setAdmisionKinesiologia(false);
            }
            if (_type === 'PAE') {
                setPae(true);
            } else {
                setPae(false);
            }
            if (_type === 'EKI') {
                setEvolucionKinesiologica(true);
            } else {
                setEvolucionKinesiologica(false);
            }
            if (_type === 'ACL') {
                setAdmisionClinica(true);
            } else {
                setAdmisionClinica(false);
            }
            if (_type === 'ECM') {
                setEvolucionClinicaMensual(true);
            } else {
                setEvolucionClinicaMensual(false);
            }
            if (_type === 'NUT'){
                setNutricion(true);
            }else{
                setNutricion(false);
            }
            if (_type === 'ANU'){
                setAdmisionNutricion(true);
            }
            else{
                setAdmisionNutricion(false);
            }
            if (['MCL', 'TGR', 'MGR', 'EIE', 'NUT', 'ASO', 'EFM', 'AMU', 'AAS', 'ATO', 'AKI', 'PAE', 'EKI', 'ACL', 'ECM', 'ETO', 'EMU'].includes(_type)) {
                setSimpleProcedure(true)
            } else {
                setSimpleProcedure(false)
            }
            // Ensure the rest of the form is visible when loading an existing record
            setHasTypeSelected(true)

            // Transform TGR fields
            if (response.data.group_date) {
                response.data.group_date = moment(response.data.group_date);
            }
            if (response.data.group_interaction && typeof response.data.group_interaction === 'string') {
                response.data.group_interaction = response.data.group_interaction.split(',').map(s => s.trim()).filter(Boolean);
            }
            // Transform EIE fields
            if (response.data.eie_fecha) {
                response.data.eie_fecha = moment(response.data.eie_fecha);
            }
            if (response.data.eie_hora) {
                response.data.eie_hora = moment(response.data.eie_hora, ['HH:mm:ss', 'HH:mm']);
            }
            const eieArrayFields = ['eie_antecedentes','eie_audifonos','eie_protesis_dental','eie_dieta','eie_localizaciones'];
            eieArrayFields.forEach(f => {
                if (response.data[f] && typeof response.data[f] === 'string') {
                    response.data[f] = response.data[f].split(',').map(s => s.trim()).filter(Boolean);
                }
            });
            // Parse detalle por localización (JSON -> objeto)
            if (response.data.eie_localizaciones_detalle && typeof response.data.eie_localizaciones_detalle === 'string') {
                try { response.data.eie_localizaciones_detalle = JSON.parse(response.data.eie_localizaciones_detalle) || {}; } catch(e) { response.data.eie_localizaciones_detalle = {}; }
            }
            // Transform ECL fields
            if (response.data.ecl_fecha) {
                response.data.ecl_fecha = moment(response.data.ecl_fecha);
            }
            if (response.data.ecl_patologias && typeof response.data.ecl_patologias === 'string') {
                response.data.ecl_patologias = response.data.ecl_patologias.split(',').map(s => s.trim()).filter(Boolean);
            }
            // PAE fields transform
            const paeArrayFields = [
                'pae_nanda',
                'pae_plan_autovalido', 'pae_plan_ayuda_parcial', 'pae_plan_dependencia',
                'pae_intervenciones'
            ];
            paeArrayFields.forEach(f => {
                if (response.data[f] && typeof response.data[f] === 'string') {
                    response.data[f] = response.data[f].split(',').map(s => s.trim()).filter(Boolean);
                }
            });
            // Transform CSM fields
            if (response.data.csm_hora_inicio) {
                response.data.csm_hora_inicio = moment(response.data.csm_hora_inicio, ['HH:mm:ss', 'HH:mm']);
            }
            if (response.data.csm_tipo_sujecion && typeof response.data.csm_tipo_sujecion === 'string') {
                response.data.csm_tipo_sujecion = response.data.csm_tipo_sujecion.split(',').map(s => s.trim()).filter(Boolean);
            }
            if (response.data.csm_controles && typeof response.data.csm_controles === 'string') {
                try { response.data.csm_controles = JSON.parse(response.data.csm_controles); } catch(e) { /* ignore */ }
            }
            // Normalize CSM controles hora to moment for TimePicker
            if (Array.isArray(response.data.csm_controles)) {
                response.data.csm_controles = response.data.csm_controles.map(it => {
                    const out = { ...it };
                    if (out && out.hora) {
                        if (!moment.isMoment(out.hora)) {
                            const m = moment(out.hora, ['HH:mm','HH:mm:ss'], true);
                            out.hora = m.isValid() ? m : null;
                        }
                    } else {
                        out.hora = null;
                    }
                    return out;
                });
            }

            // Transform CSV fields
            if (response.data.csv_controles && typeof response.data.csv_controles === 'string') {
                try { response.data.csv_controles = JSON.parse(response.data.csv_controles); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.data.csv_controles)) {
                response.data.csv_controles = response.data.csv_controles.map(it => {
                    const out = { ...it };
                    // Backward compatibility: if single 'ta' is provided, split into alta/baja when possible
                    if ((out.ta_alta == null && out.ta_baja == null) && out.ta) {
                        if (typeof out.ta === 'string') {
                            const m = /^(\d{1,3})\s*\/?\s*(\d{1,3})?$/.exec(out.ta.trim());
                            if (m) {
                                if (m[1]) out.ta_alta = Number(m[1]);
                                if (m[2]) out.ta_baja = Number(m[2]);
                            }
                        } else if (typeof out.ta === 'number') {
                            out.ta_alta = out.ta;
                        }
                    }
                    if (out && out.fecha) {
                        if (!moment.isMoment(out.fecha)) {
                            const d = moment(out.fecha, ['YYYY-MM-DD','DD/MM/YYYY'], true);
                            out.fecha = d.isValid() ? d : null;
                        }
                    } else {
                        out.fecha = null;
                    }
                    return out;
                });
            }

            // Transform GLU fields
            if (response.data.glu_registros && typeof response.data.glu_registros === 'string') {
                try { response.data.glu_registros = JSON.parse(response.data.glu_registros); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.data.glu_registros)) {
                response.data.glu_registros = response.data.glu_registros.map(it => {
                    const out = { ...it };
                    if (out && out.fecha_hora) {
                        if (!moment.isMoment(out.fecha_hora)) {
                            const dt = moment(out.fecha_hora, ['YYYY-MM-DDTHH:mm:ss','YYYY-MM-DD HH:mm:ss','DD/MM/YYYY HH:mm'], true);
                            out.fecha_hora = dt.isValid() ? dt : null;
                        }
                    } else {
                        out.fecha_hora = null;
                    }
                    return out;
                });
            }

            // PES: Transform Peso Semanal fields
            if (response.data.pes_registros && typeof response.data.pes_registros === 'string') {
                try { response.data.pes_registros = JSON.parse(response.data.pes_registros); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.data.pes_registros)) {
                response.data.pes_registros = response.data.pes_registros.map(it => {
                    const out = { ...it };
                    if (out && out.fecha) {
                        if (!moment.isMoment(out.fecha)) {
                            const d = moment(out.fecha, ['YYYY-MM-DD','DD/MM/YYYY'], true);
                            out.fecha = d.isValid() ? d : null;
                        }
                    } else {
                        out.fecha = null;
                    }
                    return out;
                });
            }
            // PES: pes_mes_anio to moment or default from create_date
            if (response.data.type === 'PES') {
                if (response.data.pes_mes_anio) {
                    const mmy = moment(response.data.pes_mes_anio, ['MM/YYYY'], true);
                    response.data.pes_mes_anio = mmy.isValid() ? mmy : null;
                } else if (response.data.create_date) {
                    response.data.pes_mes_anio = moment(response.data.create_date).startOf('month');
                }
            }
            // PCA: Protocolo de Caídas transforms
            if (response.data.pca_fecha_hora) {
                const dt = moment(response.data.pca_fecha_hora, ['YYYY-MM-DDTHH:mm:ss','YYYY-MM-DD HH:mm:ss','DD/MM/YYYY HH:mm'], true);
                response.data.pca_fecha_hora = dt.isValid() ? dt : null;
            }
            const pcaArrayFields = ['pca_circunstancias','pca_consecuencias','pca_medicacion_causal','pca_comorbilidades'];
            pcaArrayFields.forEach(f => {
                if (response.data[f] && typeof response.data[f] === 'string') {
                    response.data[f] = response.data[f].split(',').map(s => s.trim()).filter(Boolean);
                }
            });
            // PCA: Lugar de caída - si el valor guardado no está en las opciones, usar "Otro" + helper
            (function(){
                const place = response.data.pca_lugar_caida;
                const opts = ['Pasillo','Baño','Habitación','Cama','Comedor','Espacios comunes','Fuera de la institución'];
                if (place && opts.indexOf(place) === -1) {
                    response.data.pca_lugar_caida_otro = place;
                    response.data.pca_lugar_caida = 'Otro';
                } else {
                    response.data.pca_lugar_caida_otro = '';
                }
            })();

            // AAS: Admisión Asis. Social transforms
            if (response.data.aas_escolaridad && typeof response.data.aas_escolaridad === 'string') {
                try { response.data.aas_escolaridad = JSON.parse(response.data.aas_escolaridad); } catch(e) { /* ignore */ }
            }
            if (response.data.aas_grupo_familiar && typeof response.data.aas_grupo_familiar === 'string') {
                try { response.data.aas_grupo_familiar = JSON.parse(response.data.aas_grupo_familiar); } catch(e) { /* ignore */ }
            }

            // ATO: Admisión Terapia Ocupacional transforms
            if (response.data.ato_historia_ocupacional && typeof response.data.ato_historia_ocupacional === 'string') {
                try { response.data.ato_historia_ocupacional = JSON.parse(response.data.ato_historia_ocupacional); } catch(e) { /* ignore */ }
            }
            if (response.data.ato_valoracion_perceptivo_sensorial && typeof response.data.ato_valoracion_perceptivo_sensorial === 'string') {
                try { response.data.ato_valoracion_perceptivo_sensorial = JSON.parse(response.data.ato_valoracion_perceptivo_sensorial); } catch(e) { /* ignore */ }
            }
            if (response.data.ato_evaluacion_funcional && typeof response.data.ato_evaluacion_funcional === 'string') {
                try { response.data.ato_evaluacion_funcional = JSON.parse(response.data.ato_evaluacion_funcional); } catch(e) { /* ignore */ }
            }
            if (response.data.ato_intereses_tiempo_libre && typeof response.data.ato_intereses_tiempo_libre === 'string') {
                try { response.data.ato_intereses_tiempo_libre = JSON.parse(response.data.ato_intereses_tiempo_libre); } catch(e) { /* ignore */ }
            }

            // APQ, ACL, ECM & EPM: JSON data transforms
            if (['APQ', 'ACL', 'ECM', 'EPM'].includes(response.data.type)) {
                if (response.data.data && typeof response.data.data === 'string') {
                    try { response.data.data = JSON.parse(response.data.data); } catch(e) { /* ignore */ }
                }
                if (!response.data.data) {
                    if (response.data.type === 'APQ') response.data.data = admisionPsiquiatricaSchema;
                    else if (['ACL','ECM','EPM'].includes(response.data.type)) response.data.data = {};
                }
                // Convert date fields to moment (for APQ & ACL)
                if (response.data.data) {
                    if (response.data.data.fecha_reingreso) {
                        const m = moment(response.data.data.fecha_reingreso);
                        response.data.data.fecha_reingreso = m.isValid() ? m : null;
                    }
                    if (response.data.data.datos_administrativos) {
                        if (response.data.data.datos_administrativos.desde) {
                            const m = moment(response.data.data.datos_administrativos.desde);
                            response.data.data.datos_administrativos.desde = m.isValid() ? m : null;
                        }
                        if (response.data.data.datos_administrativos.hasta) {
                            const m = moment(response.data.data.datos_administrativos.hasta);
                            response.data.data.datos_administrativos.hasta = m.isValid() ? m : null;
                        }
                    }
                }
            }

            // Fixed name + last_name for autocomple
            response.data.pacient_search = `${response.data.pacient__name} ${response.data.pacient__last_name}`
            procedureForm.setFieldsValue(response.data);
            console.log("PATIENT PROGRESS FILES")
            console.log(response.data.patientprogressfile_set)
            setPatientProgressFiles(response.data.patientprogressfile_set)

            setDisableUpload(false)

            // Get status
            onStatusChange(response.data.status)
            setDrawerLoading(false)
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    setSaveButtonLoading(false);
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt)
                }
                setDrawerLoading(false)
            });
    }

    // APQ: options for selects
    const APQ_OPTIONS = {
        actitud_y_aspecto: [
            { label: 'Normal', value: 'NORMAL' },
            { label: 'Excitado', value: 'EXCITADO' },
            { label: 'Deprimido', value: 'DEPRIMIDO' },
            { label: 'Ansioso', value: 'ANSIOSO' },
            { label: 'Indiferente', value: 'INDIFERENTE' },
        ],
        sueño: [
            { label: 'Normal', value: 'NORMAL' },
            { label: 'No concilia', value: 'NO CONCILIA' },
            { label: 'Despertar temprano', value: 'DESPERTAR TEMPRANO' },
        ],
        psicomotricidad: [
            { label: 'No deambula', value: 'NO DEAMBULA' },
            { label: 'Usa soporte', value: 'USA SOPORTE' },
            { label: 'Con ayuda', value: 'CON AYUDA' },
            { label: 'Normal', value: 'NORMAL' },
        ],
        atencion: [
            { label: 'Normal', value: 'NORMAL' },
            { label: 'Hipoprosexia', value: 'HIPOPROSEXIA' },
            { label: 'Paraprosexia', value: 'PARAPROSEXIA' },
            { label: 'Hiperprosexia', value: 'HIPERPROSEXIA' },
        ],
        contenido_ideacion: [
            { label: 'Coherente', value: 'COHERENTE' },
            { label: 'Incoherente', value: 'INCOHERENTE' },
        ],
        capital_ideativo: [
            { label: 'Normal', value: 'NORMAL' },
            { label: 'Disminuido', value: 'DISMINUIDO' },
        ],
        juicio: [
            { label: 'Conservado', value: 'CONSERVADO' },
            { label: 'Disminuido', value: 'DISMINUIDO' },
            { label: 'Insuficiente', value: 'INSUFICIENTE' },
            { label: 'Desviado', value: 'DESVIADO' },
            { label: 'Suspendido', value: 'SUSPENDIDO' },
        ],
        salidas: [
            { label: 'Sí', value: 'SI' },
            { label: 'No', value: 'NO' },
        ],
        recibe_visitas: [
            { label: 'Sí', value: 'SI' },
            { label: 'No', value: 'NO' },
        ],
        medicacion_deposito: [
            { label: 'Sí', value: 'SI' },
            { label: 'No', value: 'NO' },
        ],
        supervision: [
            { label: 'Permanente', value: 'PERMANENTE' },
            { label: 'Semipermanente', value: 'SEMIPERMANENTE' },
        ],
        colabora_con_el_examen: [
            { label: 'Indiferente', value: 'INDIFERENTE' },
            { label: 'Hostil', value: 'HOSTIL' },
        ],
        signos_motores: [
            { label: 'Temblor', value: 'TEMBLOR' },
            { label: 'Rigidez', value: 'RIGIDEZ' },
            { label: 'Catatónico', value: 'CATATONICO' },
        ],
        incontinencia: [
            { label: 'Total', value: 'TOTAL' },
            { label: 'Parcial', value: 'PARCIAL' },
        ],
        desorientacion: [
            { label: 'Alopsíquica', value: 'ALOPSIQUICA' },
            { label: 'Autopsíquica', value: 'AUTOPSIQUICA' },
        ],
        conciencia_de_enfermedad: [
            { label: 'Adecuada', value: 'ADECUADA' },
            { label: 'Inadecuada', value: 'INADECUADA' },
        ],
        memoria: [
            { label: 'Leve', value: 'LEVE' },
            { label: 'Moderada', value: 'MODERADA' },
            { label: 'Grave', value: 'GRAVE' },
        ],
        sensopercepcion: [
            { label: 'Cenestopáticas', value: 'CENESTOPATICAS' },
            { label: 'Visuales', value: 'VISUALES' },
            { label: 'Auditivas', value: 'AUDITIVAS' },
        ],
        ideas_patologicas: [
            { label: 'Bien estructuradas', value: 'BIEN ESTRUCTURADAS' },
            { label: 'Mal estructuradas', value: 'MAL ESTRUCTURADAS' },
            { label: 'Persecutorias', value: 'PERSECUTORIAS' },
            { label: 'Místicas', value: 'MISTICAS' },
            { label: 'Hipocondríacas', value: 'HIPOCONDRIACAS' },
            { label: 'Fóbicas', value: 'FOBICAS' },
        ],
        ideas_patologicas_condicionan: [
            { label: 'Sí', value: 'SI' },
            { label: 'No', value: 'NO' },
        ],
        TOC: [
            { label: 'Orden', value: 'ORDEN' },
            { label: 'Ritos', value: 'RITOS' },
            { label: 'Limpieza', value: 'LIMPIEZA' },
            { label: 'Verificar', value: 'VERIFICAR' },
        ],
        excitacion_psicomotriz: [
            { label: 'Frecuente', value: 'FRECUENTE' },
            { label: 'Esporádica', value: 'ESPORADICA' },
        ],
    };

    const createProcedure = (procedure = {}) => {
        // Para EPM: asegurar que tomamos SIEMPRE el contenido actual del formulario
        // (incluye esquema_farmacologico seteado por prefill) antes de serializar
        if (procedure && procedure.type === 'EPM') {
            const formData = procedureForm.getFieldValue('data') || {};
            procedure = { ...procedure, data: formData };
        }

        // Para EPM: enviar 'data' como objeto embebido en un único campo form-url-encoded
        // en lugar de claves planas data[diagnostico]/data[evolucion]
        if (procedure && procedure.type === 'EPM' && procedure.data && typeof procedure.data === 'object') {
            try {
                procedure = { ...procedure, data: JSON.stringify(procedure.data) };
            } catch (e) {
                // si falla stringify, dejamos como estaba (backend tiene normalizador)
            }
        }
        reqwest({
            url: `${config.api_url}/patientprogress/`,
            method: 'post',
            type: 'json',
            data: procedure,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(response => {
            openSuccessNotificacion();
            // Fix dates to moment (guard against null/undefined)
            if (response.create_date) response.create_date = moment(response.create_date);
            if (response.start_date) response.start_date = moment(response.start_date);
            if (response.end_date) response.end_date = moment(response.end_date);
            if (response.next_appointment) response.next_appointment = moment(response.next_appointment);
            // TGR: normalize fields for form controls
            if (response.group_date) response.group_date = moment(response.group_date);
            if (response.group_interaction && typeof response.group_interaction === 'string') {
                response.group_interaction = response.group_interaction.split(',').map(s => s.trim()).filter(Boolean);
            }
            // EIE: normalize fields for form controls
            if (response.eie_fecha) response.eie_fecha = moment(response.eie_fecha);
            if (response.eie_hora) response.eie_hora = moment(response.eie_hora, ['HH:mm:ss','HH:mm']);
            ['eie_antecedentes','eie_audifonos','eie_protesis_dental','eie_dieta','eie_localizaciones'].forEach(f => {
                if (response[f] && typeof response[f] === 'string') {
                    response[f] = response[f].split(',').map(s => s.trim()).filter(Boolean);
                }
            });
            // ECL: normalize fields for form controls
            if (response.ecl_fecha) response.ecl_fecha = moment(response.ecl_fecha);
            if (response.ecl_patologias && typeof response.ecl_patologias === 'string') {
                response.ecl_patologias = response.ecl_patologias.split(',').map(s => s.trim()).filter(Boolean);
            }
            // PAE fields transform
            const paeArrayFields_ = [
                'pae_nanda',
                'pae_plan_autovalido', 'pae_plan_ayuda_parcial', 'pae_plan_dependencia',
                'pae_intervenciones'
            ];
            paeArrayFields_.forEach(f => {
                if (response[f] && typeof response[f] === 'string') {
                    response[f] = response[f].split(',').map(s => s.trim()).filter(Boolean);
                }
            });
            // CSM: normalize fields for form controls
            if (response.csm_hora_inicio) response.csm_hora_inicio = moment(response.csm_hora_inicio, ['HH:mm:ss','HH:mm']);
            if (response.csm_tipo_sujecion && typeof response.csm_tipo_sujecion === 'string') {
                response.csm_tipo_sujecion = response.csm_tipo_sujecion.split(',').map(s => s.trim()).filter(Boolean);
            }
            if (response.csm_controles && typeof response.csm_controles === 'string') {
                try { response.csm_controles = JSON.parse(response.csm_controles); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.csm_controles)) {
                response.csm_controles = response.csm_controles.map(it => {
                    const out = { ...it };
                    if (out && out.hora) {
                        if (!moment.isMoment(out.hora)) {
                            const m = moment(out.hora, ['HH:mm','HH:mm:ss'], true);
                            out.hora = m.isValid() ? m : null;
                        }
                    } else {
                        out.hora = null;
                    }
                    return out;
                });
            }
            // CSV: normalize fields for form controls
            if (response.csv_controles && typeof response.csv_controles === 'string') {
                try { response.csv_controles = JSON.parse(response.csv_controles); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.csv_controles)) {
                response.csv_controles = response.csv_controles.map(it => {
                    const out = { ...it };
                    // Backward compatibility: map single 'ta' string/number to 'ta_alta'/'ta_baja'
                    if ((out.ta_alta == null && out.ta_baja == null) && out.ta) {
                        if (typeof out.ta === 'string') {
                            const m = /^(\d{1,3})\s*\/?\s*(\d{1,3})?$/.exec(out.ta.trim());
                            if (m) {
                                if (m[1]) out.ta_alta = Number(m[1]);
                                if (m[2]) out.ta_baja = Number(m[2]);
                            }
                        } else if (typeof out.ta === 'number') {
                            out.ta_alta = out.ta;
                        }
                    }
                    if (out && out.fecha) {
                        if (!moment.isMoment(out.fecha)) {
                            const d = moment(out.fecha, ['YYYY-MM-DD','DD/MM/YYYY'], true);
                            out.fecha = d.isValid() ? d : null;
                        }
                    } else {
                        out.fecha = null;
                    }
                    return out;
                });
            }
            // GLU: normalize fields for form controls
            if (response.glu_registros && typeof response.glu_registros === 'string') {
                try { response.glu_registros = JSON.parse(response.glu_registros); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.glu_registros)) {
                response.glu_registros = response.glu_registros.map(it => {
                    const out = { ...it };
                    if (out && out.fecha_hora) {
                        if (!moment.isMoment(out.fecha_hora)) {
                            const dt = moment(out.fecha_hora, ['YYYY-MM-DDTHH:mm:ss','YYYY-MM-DD HH:mm:ss','DD/MM/YYYY HH:mm'], true);
                            out.fecha_hora = dt.isValid() ? dt : null;
                        }
                    } else {
                        out.fecha_hora = null;
                    }
                    return out;
                });
            }
            // PES: Transform Peso Semanal fields
            if (response.pes_registros && typeof response.pes_registros === 'string') {
                try { response.pes_registros = JSON.parse(response.pes_registros); } catch(e) { /* ignore */ }
            }
            if (Array.isArray(response.pes_registros)) {
                response.pes_registros = response.pes_registros.map(it => {
                    const out = { ...it };
                    if (out && out.fecha) {
                        if (!moment.isMoment(out.fecha)) {
                            const d = moment(out.fecha, ['YYYY-MM-DD','DD/MM/YYYY'], true);
                            out.fecha = d.isValid() ? d : null;
                        }
                    } else {
                        out.fecha = null;
                    }
                    return out;
                });
            }
            // PES: pes_mes_anio to moment or default from create_date
            if (response.type === 'PES') {
                if (response.pes_mes_anio) {
                    const mmy = moment(response.pes_mes_anio, ['MM/YYYY'], true);
                    response.pes_mes_anio = mmy.isValid() ? mmy : null;
                } else if (response.create_date) {
                    response.pes_mes_anio = moment(response.create_date).startOf('month');
                }
            }

            // AAS: normalize fields for form controls
            if (response.aas_escolaridad && typeof response.aas_escolaridad === 'string') {
                try { response.aas_escolaridad = JSON.parse(response.aas_escolaridad); } catch(e) { /* ignore */ }
            }
            if (response.aas_grupo_familiar && typeof response.aas_grupo_familiar === 'string') {
                try { response.aas_grupo_familiar = JSON.parse(response.aas_grupo_familiar); } catch(e) { /* ignore */ }
            }
            // PCA: Protocolo de Caídas transforms
            if (response.pca_fecha_hora) {
                const dt = moment(response.pca_fecha_hora, ['YYYY-MM-DDTHH:mm:ss','YYYY-MM-DD HH:mm:ss','DD/MM/YYYY HH:mm'], true);
                response.pca_fecha_hora = dt.isValid() ? dt : null;
            }
            const pcaArrayFields2 = ['pca_circunstancias','pca_consecuencias','pca_medicacion_causal','pca_comorbilidades'];
            pcaArrayFields2.forEach(f => {
                if (response[f] && typeof response[f] === 'string') {
                    response[f] = response[f].split(',').map(s => s.trim()).filter(Boolean);
                }
            });

            // AAS: normalize fields for form controls
            if (response.aas_escolaridad && typeof response.aas_escolaridad === 'string') {
                try { response.aas_escolaridad = JSON.parse(response.aas_escolaridad); } catch(e) { /* ignore */ }
            }
            if (response.aas_grupo_familiar && typeof response.aas_grupo_familiar === 'string') {
                try { response.aas_grupo_familiar = JSON.parse(response.aas_grupo_familiar); } catch(e) { /* ignore */ }
            }

            // ATO: normalize fields for form controls
            if (response.ato_historia_ocupacional && typeof response.ato_historia_ocupacional === 'string') {
                try { response.ato_historia_ocupacional = JSON.parse(response.ato_historia_ocupacional); } catch(e) { /* ignore */ }
            }
            if (response.ato_valoracion_perceptivo_sensorial && typeof response.ato_valoracion_perceptivo_sensorial === 'string') {
                try { response.ato_valoracion_perceptivo_sensorial = JSON.parse(response.ato_valoracion_perceptivo_sensorial); } catch(e) { /* ignore */ }
            }
            if (response.ato_evaluacion_funcional && typeof response.ato_evaluacion_funcional === 'string') {
                try { response.ato_evaluacion_funcional = JSON.parse(response.ato_evaluacion_funcional); } catch(e) { /* ignore */ }
            }
            if (response.ato_intereses_tiempo_libre && typeof response.ato_intereses_tiempo_libre === 'string') {
                try { response.ato_intereses_tiempo_libre = JSON.parse(response.ato_intereses_tiempo_libre); } catch(e) { /* ignore */ }
            }

            // PCA: Lugar de caída - si el valor guardado no está en las opciones, usar "Otro" + helper
            (function(){
                const place2 = response.pca_lugar_caida;
                const opts2 = ['Pasillo','Baño','Habitación','Cama','Comedor','Espacios comunes','Fuera de la institución'];
                if (place2 && opts2.indexOf(place2) === -1) {
                    response.pca_lugar_caida_otro = place2;
                    response.pca_lugar_caida = 'Otro';
                } else {
                    response.pca_lugar_caida_otro = '';
                }
            })();

            // APQ, ACL, ECM, ANU, NUT & EPM: JSON data transforms
            if (['APQ', 'ACL', 'ECM', 'ANU', 'NUT', 'EPM'].includes(response.type)) {
                if (response.data && typeof response.data === 'string') {
                    try { response.data = JSON.parse(response.data); } catch(e) { /* ignore */ }
                }
                if (!response.data) {
                    if (response.type === 'APQ') response.data = {}; // admisionPsiquiatricaSchema is just schema
                    else if (['ACL','ECM','ANU','NUT','EPM'].includes(response.type)) response.data = {};
                }
                // Convert date fields to moment (for APQ & ACL)
                if (response.data) {
                    if (response.data.fecha_reingreso) {
                        const m = moment(response.data.fecha_reingreso);
                        response.data.fecha_reingreso = m.isValid() ? m : null;
                    }
                    if (response.data.datos_administrativos) {
                        if (response.data.datos_administrativos.desde) {
                            const m = moment(response.data.datos_administrativos.desde);
                            response.data.datos_administrativos.desde = m.isValid() ? m : null;
                        }
                        if (response.data.datos_administrativos.hasta) {
                            const m = moment(response.data.datos_administrativos.hasta);
                            response.data.datos_administrativos.hasta = m.isValid() ? m : null;
                        }
                    }
                }
            }

            // Fixed name + last_name for autocomple
            response.pacient_search = `${response.pacient__name} ${response.pacient__last_name}`
            // Al abrir un registro existente, setear flags de tipo para renderizar la UI correspondiente
            try {
                const selected = response.type;
                setPsicologicalAdmision(selected === 'APS');
                setPsiquitricAdmision(selected === 'APQ');
                setPsicologicalEvolution(selected === 'EPS');
                setPsiquitricEvolution(selected === 'EPQ');
                setPsiquitricExam(selected === 'EXP');
                setPsiquitricNurse(selected === 'ENF');
                setGroupActivityEvolution(selected === 'TGR');
                setNurseAdmissionEval(selected === 'EIE');
                setClinicalExam(selected === 'ECL');
                setAnamnesis(selected === 'ANA');
                setSujecionMecanica(selected === 'CSM');
                setConstantesVitales(selected === 'CSV');
                setGlucemia(selected === 'GLU');
                setPesoSemanal(selected === 'PES');
                setProtocoloCaidas(selected === 'PCA');
                setAdmisionMusicoterapia(selected === 'AMU');
                setAdmisionAsisSocial(selected === 'AAS');
                setAdmisionTerapiaOcupacional(selected === 'ATO');
                setAdmisionKinesiologia(selected === 'AKI');
                setAdmisionNutricion(selected === 'ANU');
                setNutricion(selected === 'NUT');
                setPae(selected === 'PAE');
                setEvolucionKinesiologica(selected === 'EKI');
                setAdmisionClinica(selected === 'ACL');
                setEvolucionClinicaMensual(selected === 'ECM');
                setEvolucionPsiquiatricaMensual(selected === 'EPM');
                setSimpleProcedure(['ASO','EFM','MGR','HDD', 'ETO', 'EMU'].includes(selected));
            } catch (e) { /* noop */ }
            procedureForm.setFieldsValue(response)
            setDisableUpload(false)
            setSaveButtonLoading(false)
            // Detener spinner del Drawer una vez cargado el registro
            setDrawerLoading(false)
            // Refrescar la tabla principal tras crear un nuevo registro (manteniendo filtros/orden/paginación)
            try {
                fetchProcedures({
                    pagination: pagination,
                    sortField: sortedInfo.field,
                    sortOrder: sortedInfo.order,
                    filters: filteredInfo
                })
            } catch (e) { /* noop */ }
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    setSaveButtonLoading(false);
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt)
                }
                // Asegurar detener el spinner ante errores
                setDrawerLoading(false)
            });
    }

    const updateProcedure = (procedure = {}) => {
        // console.log("Update procedure!")
        console.log(procedure.next_appointment)
        // procedure.next_appointment = moment(procedure.next_appointment).format("YYYY-MM-DDT00:00:00")
        // Para EPM: asegurar que tomamos SIEMPRE el contenido actual del formulario
        // (incluye esquema_farmacologico seteado por prefill) antes de serializar
        if (procedure && procedure.type === 'EPM') {
            const formData = procedureForm.getFieldValue('data') || {};
            procedure = { ...procedure, data: formData };
        }

        // Para EPM: enviar 'data' como objeto embebido en un único campo form-url-encoded
        if (procedure && procedure.type === 'EPM' && procedure.data && typeof procedure.data === 'object') {
            try {
                procedure = { ...procedure, data: JSON.stringify(procedure.data) };
            } catch (e) {
                // fallback: continuar con estructura por defecto
            }
        }
        reqwest({
            url: `${config.api_url}/patientprogress/${procedure.id}/`,
            method: 'patch',
            type: 'json',
            data: procedure,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(response => {
            openNotificationWithIcon('success',
                'Operación correcta',
                'Se ah actualizado correctamente')
            setSaveButtonLoading(false)
            fetchProcedures({
                pagination: pagination,
                sortField: sortedInfo.field,
                sortOrder: sortedInfo.order,
                filters: filteredInfo
            })
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    setSaveButtonLoading(false);
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt)
                }
            });
    }

    const deleteProcedure = (procedure = {}) => {
        reqwest({
            url: `${config.api_url}/patientprogress/${procedure.id}`,
            method: 'delete',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(response => {
            openSuccessNotificacion("Se anuló el registro correctamente")
            closeDrawer()
            setDeleteButtonLoading(false)
            fetchProcedures({
                pagination: pagination,
                sortField: sortedInfo.field,
                sortOrder: sortedInfo.order,
                filters: filteredInfo
            })
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt);
                }
            });
    }

    const deletePatientProgressFile = (procedure = {}) => {
        reqwest({
            url: `${config.api_url}/patientprogressfile/${procedure.id}/`,
            method: 'delete',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(response => {
            openSuccessNotificacion("Se ah eliminado el registro correctamente")
            fetchProcedure(procedureForm.getFieldValue('id'))
            fetchProcedures({
                pagination: pagination,
                sortField: sortedInfo.field,
                sortOrder: sortedInfo.order,
                filters: filteredInfo
            })
        }).catch(
            errorInfo => {
                if (errorInfo.status === 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    const error_detail_txt = catchErrors(errorInfo);
                    openErrorNotificacion(error_detail_txt);
                }
            });
    }

    useEffect(() => {
        fetchProcedures({'pagination': pagination})
    }, []);

    // Load PatientProgress types (codes + labels) from backend
    useEffect(() => {
        const url = patient_id
            ? `${config.api_url}/patientprogress/types/?patient_id=${patient_id}`
            : `${config.api_url}/patientprogress/types/`;

        reqwest({
            url: url,
            method: 'get',
            type: 'json',
            headers: { 'Authorization': `Token ${getToken()}` },
        }).then(resp => {
            const list = Array.isArray(resp) ? resp : (resp.results || []);
            // Filtro dinámico: exclude specific types if needed, but not common ones
            const sorted = [...list]
                .filter(item => !['HDD', 'EPQ', 'MGR'].includes(item.code))
                .sort((a, b) => (a.label || '').localeCompare((b.label || ''), 'es', { sensitivity: 'base' }));
            setTypeOptions(sorted);
        }).catch(() => {
            // fallback: keep existing hardcoded if request fails
            const fallback = [
                { code: 'APS', label: 'Admisión Psicológica' },
                { code: 'APQ', label: 'Admisión Psiquiátrica' },
                { code: 'EPS', label: 'Evolución Psicológica' },
                { code: 'EXP', label: 'Examen Psiquiátrico' },
                { code: 'ENF', label: 'Evolución Enfermería' },
                { code: 'EIE', label: 'Eval. Ingreso Enfermería' },
                { code: 'CSM', label: 'Control Sujeción Mecánica (Sujeciones)' },
                { code: 'CSV', label: 'Constantes Vitales' },
                { code: 'GLU', label: 'Glucemia' },
                { code: 'PES', label: 'Peso Semanal' },
                { code: 'PCA', label: 'Protocolo de Caídas' },
                { code: 'MCL', label: 'Medicina Clínica' },
                { code: 'TGR', label: 'Evolución Actividades Grupales (Talleres)' },
                { code: 'NUT', label: 'Nutrición' },
                { code: 'ASO', label: 'Evolución Trabajo Social' },
                { code: 'EFM', label: 'Entrevista familiar' },
                { code: 'AMU', label: 'Admisión de Musicoterapia' },
                { code: 'AAS', label: 'Admisión de Trabajo Social' },
                { code: 'ATO', label: 'Admisión de Terapia Ocupacional' },
                { code: 'AKI', label: 'Admisión de Kinesiología' },
                { code: 'ANU', label: 'Admisión de Nutrición' },
                { code: 'ACL', label: 'Admisión de Clínica' },
                { code: 'ECM', label: 'Evolución Clínica Mensual' },
                { code: 'EPM', label: 'Evolución Psiquiátrica' },
            ];
            const sortedFallback = fallback.sort((a, b) => (a.label || '').localeCompare((b.label || ''), 'es', { sensitivity: 'base' }));
            setTypeOptions(sortedFallback);
        });
    }, [patient_id]);

    // Set Spanish locale for month names
    useEffect(() => {
        try { moment.locale('es'); } catch (e) { /* ignore */ }
    }, []);

    useEffect(() => {
        // Load creator options when patient_id changes or on mount
        if (!patient_id) { setCreatorOptions([]); return; }
        reqwest({
            url: `${config.api_url}/patientprogress/creators/?patient_id=${patient_id}`,
            method: 'get',
            type: 'json',
            headers: { 'Authorization': `Token ${getToken()}` },
        }).then(resp => {
            const list = Array.isArray(resp) ? resp : (resp.results || []);
            setCreatorOptions(list);
        }).catch(() => {
            // Keep options empty on error
            setCreatorOptions([]);
        });
    }, [patient_id]);

    const showDrawer = (id = null) => {
        procedureForm.resetFields();
        // If opening an existing record, start spinner before showing the drawer
        if (id) {
            setDrawerLoading(true);
        } else {
            setDrawerLoading(false);
        }
        setShowMainDrawer(true)
        // Calculate index within current page data for navigation
        if (id) {
            const idx = data.findIndex(item => item.id === id);
            if (idx !== -1) {
                setCurrentIndex(idx);
            } else {
                setCurrentIndex(null);
            }
            fetchProcedure(id)
        } else {
            setCurrentIndex(null);
            procedureForm.resetFields();
            setPatientProgressFiles([])
            if (patient_id) {
                procedureForm.setFieldsValue({patient: patient_id})
            }
            // Inicializar detalle por localización EIE
            procedureForm.setFieldsValue({ eie_localizaciones_detalle: {} });
            // Reset all type-dependent flags and hide other fields until a type is chosen
            setPsicologicalAdmision(false);
            setPsiquitricAdmision(false);
            setPsicologicalEvolution(false);
            setPsiquitricEvolution(false);
            setPsiquitricExam(false);
            setPsiquitricNurse(false);
            setGroupActivityEvolution(false);
            setNurseAdmissionEval(false);
            setClinicalExam(false);
            setAnamnesis(false);
            setSujecionMecanica(false);
            setConstantesVitales(false);
            setGlucemia(false);
            setPesoSemanal(false);
            setProtocoloCaidas(false);
            setAdmisionMusicoterapia(false);
            setAdmisionAsisSocial(false);
            setAdmisionTerapiaOcupacional(false);
            setAdmisionKinesiologia(false);
            setSimpleProcedure(false);
            setPae(false);
            setEvolucionKinesiologica(false);
            setAdmisionClinica(false);
            setHasTypeSelected(false);
            // Ensure spinner is not shown for new record
            setDrawerLoading(false)
        }
    }

    const printHistoriaClinica = (patient_id, ids = []) => {
        console.log(`Printing ${patient_id}`, ids)
        const idsQuery = Array.isArray(ids) && ids.length > 0 ? `&ids=${ids.join(',')}` : '';
        fetch(`${config.api_url}/patientprogress/print_to_file/?patient_id=${patient_id}${idsQuery}`, {
            method: 'get',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(async (response) => {
                // If not OK (e.g., 403 PermissionDenied), try to extract a meaningful error and throw
                if (!response.ok) {
                    try {
                        const contentType = response.headers.get('content-type') || '';
                        if (contentType.includes('application/json')) {
                            const data = await response.json();
                            const msg = data.detail || data.error || Object.values(data)[0] || `Error ${response.status}`;
                            throw new Error(msg);
                        } else {
                            const text = await response.text();
                            const msg = (text && text.length < 500) ? text : `Error ${response.status}`;
                            throw new Error(msg);
                        }
                    } catch (e) {
                        // Fallback to generic error with status if parsing fails
                        const statusText = response.statusText || '';
                        throw new Error(`Error ${response.status} ${statusText}`.trim());
                    }
                }
                return response.blob();
            })
            .then(blob => {
                const filename = `historia_clinica_${patient_id}`
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); // Append to DOM for Firefox compatibility
                a.click();
                a.remove();
                // Optional: revoke after a tick to free memory
                setTimeout(() => window.URL.revokeObjectURL(url), 1000);
            })
            .catch((error) => {
                const error_detail_txt = (error && error.message) ? error.message : 'No se pudo imprimir la historia clínica.';
                openErrorNotificacion(error_detail_txt);
            });
    }

    const showCreateDrawer = () => {
        showDrawer(0)
        setDisableUpload(true)

        // init totals
        sum_module_cost()
        sum_submodule_cost()
  }

    const closeDrawer = () => {
        setShowMainDrawer(false);
        try {
            // Resetear formulario y flags de tipo para evitar que persistan campos al reabrir
            if (procedureForm) {
                procedureForm.resetFields();
            }
            setPsicologicalAdmision(false);
            setPsiquitricAdmision(false);
            setPsicologicalEvolution(false);
            setPsiquitricEvolution(false);
            setPsiquitricExam(false);
            setPsiquitricNurse(false);
            setGroupActivityEvolution(false);
            setNurseAdmissionEval(false);
            setClinicalExam(false);
            setAnamnesis(false);
            setSujecionMecanica(false);
            setConstantesVitales(false);
            setGlucemia(false);
            setPesoSemanal(false);
            setProtocoloCaidas(false);
            setAdmisionMusicoterapia(false);
            setAdmisionAsisSocial(false);
            setAdmisionTerapiaOcupacional(false);
            setAdmisionKinesiologia(false);
            setAdmisionNutricion(false);
            setNutricion(false);
            setPae(false);
            setEvolucionKinesiologica(false);
            setAdmisionClinica(false);
            setEvolucionClinicaMensual(false);
            setEvolucionPsiquiatricaMensual(false);
            setSimpleProcedure(false);
            setHasTypeSelected(false);
        } catch (e) {
            // noop
        }
    }

    const sum_module_cost = () => {
        const total = parseFloat(procedureForm.getFieldValue('module_cost'))
            + parseFloat(procedureForm.getFieldValue('takecare_cost'))
            + parseFloat(procedureForm.getFieldValue('insumo_cost'))
            + parseFloat(procedureForm.getFieldValue('cama_cost'))
            + parseFloat(procedureForm.getFieldValue('colchon_cost'))
            + parseFloat(procedureForm.getFieldValue('silla_cost'))
        setTotalModule(total)
    }

    const sum_submodule_cost = () => {
        const total = parseFloat(procedureForm.getFieldValue('ps_cost'))
            + parseFloat(procedureForm.getFieldValue('to_cost'))
            + parseFloat(procedureForm.getFieldValue('fono_cost'))
            + parseFloat(procedureForm.getFieldValue('nutricion_cost'))
            + parseFloat(procedureForm.getFieldValue('asistencia_cost'))
        setTotalSubModule(total)
    }

    const onSaveProcedure = () => {
        if (isReadOnly) return;
        procedureForm.validateFields()
            .then(
                values => {
                    let procedure = procedureForm.getFieldsValue()
                    if (procedure.start_date)
                        procedure.start_date = moment(procedure.start_date).format('YYYY-MM-DD')
                    if (procedure.end_date)
                        procedure.end_date = moment(procedure.end_date).format('YYYY-MM-DD')
                    if (procedure.next_appointment)
                        procedure.next_appointment = moment(procedure.next_appointment).format('YYYY-MM-DD')
                    // TGR fields transformation
                    if (procedure.group_date)
                        procedure.group_date = moment(procedure.group_date).format('YYYY-MM-DD')
                    if (Array.isArray(procedure.group_interaction))
                        procedure.group_interaction = procedure.group_interaction.join(', ')
                    // EIE fields transformation
                    if (procedure.eie_fecha)
                        procedure.eie_fecha = moment(procedure.eie_fecha).format('YYYY-MM-DD')
                    if (procedure.eie_hora)
                        procedure.eie_hora = moment(procedure.eie_hora).format('HH:mm:ss')
                    const _eieArrays = ['eie_antecedentes','eie_audifonos','eie_protesis_dental','eie_dieta','eie_localizaciones']
                    _eieArrays.forEach(f => {
                        if (Array.isArray(procedure[f])) {
                            procedure[f] = procedure[f].join(', ')
                        }
                    })
                    // Serializar detalle por localización si viene como objeto
                    if (procedure.eie_localizaciones_detalle && typeof procedure.eie_localizaciones_detalle === 'object') {
                        try { procedure.eie_localizaciones_detalle = JSON.stringify(procedure.eie_localizaciones_detalle); } catch(e) { /* ignore */ }
                    }
                    // ECL fields transformation
                    if (procedure.ecl_fecha)
                        procedure.ecl_fecha = moment(procedure.ecl_fecha).format('YYYY-MM-DD')
                    if (Array.isArray(procedure.ecl_patologias))
                        procedure.ecl_patologias = procedure.ecl_patologias.join(', ')
                    // PAE fields transformation
                    const _paeArrays = [
                        'pae_nanda',
                        'pae_plan_autovalido', 'pae_plan_ayuda_parcial', 'pae_plan_dependencia',
                        'pae_intervenciones'
                    ];
                    _paeArrays.forEach(f => {
                        if (Array.isArray(procedure[f])) {
                            procedure[f] = procedure[f].join(', ')
                        }
                    })
                    // CSM fields transformation
                    if (procedure.csm_hora_inicio)
                        procedure.csm_hora_inicio = moment(procedure.csm_hora_inicio).format('HH:mm:ss')
                    if (Array.isArray(procedure.csm_tipo_sujecion))
                        procedure.csm_tipo_sujecion = procedure.csm_tipo_sujecion.join(', ')
                    if (Array.isArray(procedure.csm_controles)) {
                        // Ensure 'hora' is serialized as HH:mm string
                        const controlesOut = procedure.csm_controles.map(it => {
                            const out = { ...it };
                            if (out && out.hora) {
                                if (moment.isMoment(out.hora)) out.hora = out.hora.format('HH:mm');
                                else {
                                    const m = moment(out.hora, ['HH:mm','HH:mm:ss'], true);
                                    out.hora = m.isValid() ? m.format('HH:mm') : '';
                                }
                            }
                            return out;
                        });
                        procedure.csm_controles = JSON.stringify(controlesOut);
                    }
                    // CSV fields transformation
                    if (Array.isArray(procedure.csv_controles)) {
                        const csvOut = procedure.csv_controles.map(it => {
                            const out = { ...it };
                            if (out && out.fecha) {
                                if (moment.isMoment(out.fecha)) out.fecha = out.fecha.format('YYYY-MM-DD');
                                else {
                                    const d = moment(out.fecha, ['YYYY-MM-DD','DD/MM/YYYY'], true);
                                    out.fecha = d.isValid() ? d.format('YYYY-MM-DD') : '';
                                }
                            }
                            // Ensure legacy 'ta' string for backward compatibility in consumers/prints
                            if ((out.ta_alta != null || out.ta_baja != null)) {
                                const a = (out.ta_alta != null && out.ta_alta !== '') ? out.ta_alta : '';
                                const b = (out.ta_baja != null && out.ta_baja !== '') ? out.ta_baja : '';
                                if (a !== '' || b !== '') {
                                    out.ta = `${a}/${b}`.replace(/^\//, '').replace(/\/$/, '');
                                }
                            }
                            return out;
                        });
                        procedure.csv_controles = JSON.stringify(csvOut);
                    }
                    // GLU fields transformation
                    if (Array.isArray(procedure.glu_registros)) {
                        const gluOut = procedure.glu_registros.map(it => {
                            const out = { ...it };
                            if (out && out.fecha_hora) {
                                if (moment.isMoment(out.fecha_hora)) out.fecha_hora = out.fecha_hora.format('YYYY-MM-DD HH:mm:ss');
                                else {
                                    const dt = moment(out.fecha_hora, ['YYYY-MM-DDTHH:mm:ss','YYYY-MM-DD HH:mm:ss','DD/MM/YYYY HH:mm'], true);
                                    out.fecha_hora = dt.isValid() ? dt.format('YYYY-MM-DD HH:mm:ss') : '';
                                }
                            }
                            return out;
                        });
                        procedure.glu_registros = JSON.stringify(gluOut);
                    }
                    // ACL fields transformation
                    if (procedure.type === 'ACL' && procedure.data) {
                        // Transform date fields in data
                        if (procedure.data.datos_administrativos) {
                            if (procedure.data.datos_administrativos.desde)
                                procedure.data.datos_administrativos.desde = moment(procedure.data.datos_administrativos.desde).format('YYYY-MM-DD');
                            if (procedure.data.datos_administrativos.hasta)
                                procedure.data.datos_administrativos.hasta = moment(procedure.data.datos_administrativos.hasta).format('YYYY-MM-DD');
                        }
                        // Normalize tension_arterial: removed auto-completion logic as format must be num/num
                        if (procedure.data.aparato_cardiovascular && procedure.data.aparato_cardiovascular.tension_arterial) {
                            procedure.data.aparato_cardiovascular.tension_arterial = procedure.data.aparato_cardiovascular.tension_arterial.trim();
                        }
                    }
                    // PES fields transformation
                    if (Array.isArray(procedure.pes_registros)) {
                        const pesOut = procedure.pes_registros.map(it => {
                            const out = { ...it };
                            if (out && out.fecha) {
                                if (moment.isMoment(out.fecha)) out.fecha = out.fecha.format('YYYY-MM-DD');
                                else {
                                    const d = moment(out.fecha, ['YYYY-MM-DD','DD/MM/YYYY'], true);
                                    out.fecha = d.isValid() ? d.format('YYYY-MM-DD') : '';
                                }
                            }
                            return out;
                        });
                        procedure.pes_registros = JSON.stringify(pesOut);
                    }
                    if (procedure.pes_mes_anio) {
                        if (moment.isMoment(procedure.pes_mes_anio)) {
                            procedure.pes_mes_anio = procedure.pes_mes_anio.format('MM/YYYY');
                        }
                    }
                    // PCA fields transformation
                    if (procedure.pca_fecha_hora) {
                        // Use ISO-like format with 'T' to ensure DRF DateTimeField parses it reliably
                        procedure.pca_fecha_hora = moment(procedure.pca_fecha_hora).format('YYYY-MM-DDTHH:mm:ss');
                    }
                    const _pcaArrays = ['pca_circunstancias','pca_consecuencias','pca_medicacion_causal','pca_comorbilidades'];
                    _pcaArrays.forEach(f => {
                        if (Array.isArray(procedure[f])) {
                            procedure[f] = procedure[f].join(', ');
                        }
                    });
                    // PCA: Lugar de caída - si es "Otro", persistir el texto personalizado en pca_lugar_caida
                    if (procedure.pca_lugar_caida === 'Otro') {
                        procedure.pca_lugar_caida = (procedure.pca_lugar_caida_otro || '').trim();
                    }
                    // Eliminar helper del formulario si existe
                    if ('pca_lugar_caida_otro' in procedure) {
                        delete procedure.pca_lugar_caida_otro;
                    }

                    // ECM: asegurar que el tratamiento_farmacologico esté presente en los datos
                    if (procedure.type === 'ECM') {
                        try {
                            const trat = procedureForm.getFieldValue(['data', 'tratamiento_farmacologico']);
                            if (typeof trat !== 'undefined') {
                                procedure.data = procedure.data || {};
                                procedure.data.tratamiento_farmacologico = trat;
                            }
                        } catch (e) { /* ignore */ }
                    }

                    // AAS fields transformation
                    if (procedure.type === 'AAS') {
                        if (procedure.aas_escolaridad && typeof procedure.aas_escolaridad === 'object') {
                            try { procedure.aas_escolaridad = JSON.stringify(procedure.aas_escolaridad); } catch(e) { /* ignore */ }
                        }
                        // Default to empty array if no family members added, then stringify
                        const grupoFamiliar = Array.isArray(procedure.aas_grupo_familiar) ? procedure.aas_grupo_familiar : [];
                        try { procedure.aas_grupo_familiar = JSON.stringify(grupoFamiliar); } catch(e) { /* ignore */ }
                    }

                    // ATO fields transformation
                    if (procedure.ato_historia_ocupacional && typeof procedure.ato_historia_ocupacional === 'object') {
                        try { procedure.ato_historia_ocupacional = JSON.stringify(procedure.ato_historia_ocupacional); } catch(e) { /* ignore */ }
                    }
                    if (procedure.ato_valoracion_perceptivo_sensorial && typeof procedure.ato_valoracion_perceptivo_sensorial === 'object') {
                        try { procedure.ato_valoracion_perceptivo_sensorial = JSON.stringify(procedure.ato_valoracion_perceptivo_sensorial); } catch(e) { /* ignore */ }
                    }
                    if (procedure.ato_evaluacion_funcional && typeof procedure.ato_evaluacion_funcional === 'object') {
                        try { procedure.ato_evaluacion_funcional = JSON.stringify(procedure.ato_evaluacion_funcional); } catch(e) { /* ignore */ }
                    }
                    if (procedure.ato_intereses_tiempo_libre && typeof procedure.ato_intereses_tiempo_libre === 'object') {
                        try { procedure.ato_intereses_tiempo_libre = JSON.stringify(procedure.ato_intereses_tiempo_libre); } catch(e) { /* ignore */ }
                    }

                    if (['APQ', 'ACL', 'ECM', 'ANU', 'NUT'].includes(procedure.type) && procedure.data) {
                        // Create a shallow copy of procedure.data to avoid modifying the original object
                        // that Ant Design's Form might still be using/watching.
                        const dataCopy = { ...procedure.data };

                        // Convert fecha_reingreso moment to string before serializing (for APQ)
                        if (dataCopy.fecha_reingreso && moment.isMoment(dataCopy.fecha_reingreso)) {
                            dataCopy.fecha_reingreso = dataCopy.fecha_reingreso.format('YYYY-MM-DD HH:mm:ss');
                        }

                        // Ensure all other potentially nested moment objects are also handled
                        // (though currently fecha_reingreso is the only known one in APQ data)

                        try {
                            procedure.data = JSON.stringify(dataCopy);
                        } catch(e) {
                            console.error(`Error serializing ${procedure.type} data`, e);
                        }
                    }

                    if (procedure.id) {
                        setSaveButtonLoading(true)
                        updateProcedure(procedure)
                    } else {
                        setSaveButtonLoading(true)
                        createProcedure(procedure)

                    }
                }
            ).catch(
            errorInfo => {
                console.log(errorInfo);
            }
        )
    }

    const onDeleteProcedure = () => {
        if (isReadOnly) return;
        setDeleteButtonLoading(true)
        deleteProcedure(procedureForm.getFieldsValue())
    }

    const goToIndex = (newIndex) => {
        if (newIndex == null) return;
        if (newIndex < 0 || newIndex >= data.length) return;
        setCurrentIndex(newIndex);
        const rec = data[newIndex];
        if (rec && rec.id) {
            fetchProcedure(rec.id);
        }
    }

    const goPrev = () => {
        if (currentIndex == null) return;
        // If not the first item in current page, just move index
        if (currentIndex > 0) {
            goToIndex(currentIndex - 1);
            return;
        }
        // If first item and there is a previous page, load it and select last item
        const hasPrevPage = (pagination.current || 1) > 1;
        if (hasPrevPage) {
            const prevPage = (pagination.current || 1) - 1;
            fetchProcedures({
                pagination: { current: prevPage, pageSize: pagination.pageSize },
                sortField: sortedInfo.field,
                sortOrder: sortedInfo.order,
                filters: filteredInfo,
                selectIndex: -1, // select last item of previous page
            });
        }
    }

    const goNext = () => {
        if (currentIndex == null) return;
        // If not the last item in current page, just move index
        if (currentIndex < (data.length - 1)) {
            goToIndex(currentIndex + 1);
            return;
        }
        // If last item and there is a next page, load it and select first item
        const total = pagination.total || 0;
        const pageSize = pagination.pageSize || data.length || 10;
        const current = pagination.current || 1;
        const lastPage = Math.max(1, Math.ceil(total / pageSize));
        if (current < lastPage) {
            const nextPage = current + 1;
            fetchProcedures({
                pagination: { current: nextPage, pageSize },
                sortField: sortedInfo.field,
                sortOrder: sortedInfo.order,
                filters: filteredInfo,
                selectIndex: 0, // first item of next page
            });
        }
    }

    const onDeletePatientProgressFile = (item,) => {
        deletePatientProgressFile(item)

    }

    const handleProcedureSearch = (selectedKeys, confirm, dataIndex) => {
        console.log('Search', dataIndex)
        console.log(filteredInfo)
        confirm();
        setSearchText(selectedKeys[0])
        setSearchedColumn(dataIndex)
    }

    const handleProcedureFiltersReset = (clearFilters = null) => {
        //clearFilters();
        setFilteredInfo((prevState) => {
            const newState = {}
            for (const _state in prevState) {
                newState[_state] = null
            }
            return newState
        })
        fetchProcedures({
            pagination: pagination,
            sortField: sortedInfo.field,
            sortOrder: sortedInfo.order,
        })
        setSearchText('')
    }

    const handleTableChange = (pagination, filters, sorter) => {
        console.log("Table changed!")
        console.log("Pagination on table change ", pagination)
        console.log("Filters on table change ", filters)
        console.log("Sort on table change ", sorter)
        setFilteredInfo(filters)
        setSortedInfo(sorter)

        if (professional_id && !patient_id){
            console.log("No id provided")
            return
        }

        fetchProcedures({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            filters: filters
        })
    }

    const handleOnFilter = (value, record) => {
        console.log('filter changed ', value, record)
        console.log('filter info', filteredInfo)
    }

    // Validations
    const onStatusChange = (status) => {
        if (status === "R") {
            setActaOnRenovation(true)
        } else {
            setActaOnRenovation(false)
        }
        if (status === "E") {
            setActaExpired(true)
        }
    }

    const handleDownloadFile = (id, filename) => {
        fetch(`${config.api_url}/patientprogress/download?id=${id}`,
            {
                method: 'get',
                headers: {
                    'Authorization': `Token ${getToken()}`,
                }
            })
            .then(response => response.blob())
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again
            })
            .catch((error) => {
                                                const error_detail_txt = (error && (error.message || error.detail)) ? (error.message || error.detail) : 'Ocurrió un error';
                                                openErrorNotificacion(error_detail_txt);
                                            })
    }


    const onChangeUploadFile = ({file, fileList, event}) => {
        console.log("CHANGED UPLOAD")
        console.log(data)
    }

    const uploadFile = (options) => {
        const {onSuccess, onError, file, onProgress} = options;
        console.log("UPLOAD")
        console.log(file)
        var formData = new FormData();
        var imagefile = file.name;
        formData.append("image", file);
        formData.append("patient_progress_id", procedureForm.getFieldValue('id'));
        axios.post(`${config.api_url}/patientprogress/upload/`, formData, {
            headers: {
                'Authorization': `Token ${getToken()}`,
                'Content-Type': 'multipart/form-data'
            }
        }).then(data => {
            console.log("Success")
            onSuccess("Ok")
            fetchProcedure(procedureForm.getFieldValue('id'))

            fetchProcedures({
                pagination: pagination,
                sortField: sortedInfo.field,
                sortOrder: sortedInfo.order,
                filters: filteredInfo
            })
        }).catch(
             function(error){
                if (error.response) {
                    const errorInfo = error.response
                    if (errorInfo.status === 401) {
                        sessionStorage.removeItem('token');
                        sessionStorage.removeItem('user');
                        history.push('/login');
                    } else {
                        setSaveButtonLoading(false);
                        const error_detail_txt = catchErrors(errorInfo);
                        onError({error_detail_txt})
                        openErrorNotificacion(error_detail_txt)
                    }
                }
            });
    }

    return (
        <>
            <Card
                title="Historia Clínica"
                extra={
                  <div>
                    <Button type="default" icon={<PrinterOutlined />} style={{ marginRight: 8 }} onClick={() => printHistoriaClinica(patient_id, selectedRowKeys)} disabled={!patient_id}>
                      {selectedRowKeys && selectedRowKeys.length > 0 ? `Imprimir (${selectedRowKeys.length})` : 'Imprimir todas'}
                    </Button>
                    <Button type="primary" onClick={showCreateDrawer} disabled={!patient_id || isReadOnly}>
                      Nuevo registro
                    </Button>
                  </div>
                }
              >
                <div style={{ marginBottom: 12 }}>
                  <Row gutter={8} align="middle">
                    <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: 8 }}>
                      <Select
                           allowClear
                           showSearch
                           placeholder="Tipo de especialidad"
                           style={{ width: '100%' }}
                           value={filterType}
                           onChange={(val) => {
                           setFilterType(val);
                           }}
                           filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        >
                           {(typeOptions || []).map(t => (
                             <Option key={t.code} value={t.code} label={t.label}>
                               <Tag color={TYPE_COLORS[t.code] || 'default'}>{t.label}</Tag>
                             </Option>
                           ))}
                        </Select>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: 8 }}>
                      <Select
                        allowClear
                        placeholder="Creador"
                        style={{ width: '100%' }}
                        value={filterCreator}
                        onChange={(val) => {
                          setFilterCreator(val);
                        }}
                        dropdownMatchSelectWidth={false}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      >
                        {(creatorOptions || []).map(opt => (
                          <Option key={String(opt.id)} value={String(opt.id)}>{opt.username}</Option>
                        ))}
                      </Select>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8} style={{ marginBottom: 8 }}>
                      <DatePicker.RangePicker
                        style={{ width: '100%' }}
                        format="DD/MM/YYYY"
                        value={filterDates}
                        onChange={(vals) => {
                          setFilterDates(vals || []);
                        }}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={4} style={{ marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Space>
                        <Button
                          onClick={() => fetchProcedures({ pagination: { current: 1, pageSize: pagination.pageSize }, sortField: sortedInfo.field, sortOrder: sortedInfo.order, filters: filteredInfo })}
                        >
                          Filtrar
                        </Button>
                        <Button
                          onClick={() => {
                            setFilterType(undefined);
                            setFilterDates([]);
                            setFilterCreator(undefined);
                            fetchProcedures({ pagination: { current: 1, pageSize: pagination.pageSize }, sortField: sortedInfo.field, sortOrder: sortedInfo.order, filters: filteredInfo });
                          }}
                        >
                          Limpiar
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                </div>
                <Table
                    size="small"
                    rowSelection={{
                      columnWidth: "2%",
                      selectedRowKeys,
                      onChange: (keys) => setSelectedRowKeys(keys),
                    }}
                    columns={[
                    {
                        title: 'Tipo',
                        dataIndex: 'type_choice',
                        sorter: true,
                        width: '10%',
                        render: (text, record) => {
                          const code = record.type;
                          const color = TYPE_COLORS[code] || 'default';
                          return <Tag color={color}>{text}</Tag>;
                        }
                    },
                    {
                        title: 'Archivos',
                        render: (text, record, index) => {
                            return record.patientprogressfile_set.length
                        },
                        sorter: true,
                        width: '10%',
                    },
                    {
                        title: 'Creador',
                        dataIndex: 'username',
                        sorter: true,
                        width: '10%',
                    },
                    {
                        title: 'Fecha Creación',
                        dataIndex: 'create_date',
                        render: (text, record, index) => {
                            return moment(text).format('DD-MM-YYYY')
                        },
                        sorter: true,
                        width: '10%',
                    },
                    {
                        title: 'Fecha Actualización',
                        dataIndex: 'update_date',
                        render: (text, record, index) => {
                            return moment(text).format('DD-MM-YYYY')
                        },
                        sorter: true,
                        width: '10%',
                    },
                    {
                        title: 'Anulada',
                        dataIndex: 'annulled',
                        width: '8%',
                        render: (val) => val ? <Tag color="red">Sí</Tag> : <Tag color="green">No</Tag>,
                    }
                ]}
                rowKey={record => record.id}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            showDrawer(record.id)
                        },
                    }
                }}
                dataSource={data}
                pagination={pagination}
                loading={{ spinning: mainTableLoading, tip: 'Cargando...' }}
                onChange={handleTableChange}
            />
              </Card>
            <Drawer
                title="Historia Clínica"
                width={"60%"}
                visible={showMainDrawer}
                onClose={closeDrawer}
                footer={
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div>
                            {procedureForm.getFieldValue('id') && (
                                <Button type={"danger"} onClick={onDeleteProcedure}
                                        loading={deleteButtonLoading} disabled={procedureForm.getFieldValue('annulled') === true || isReadOnly}>
                                    Anular
                                </Button>
                            )}
                        </div>
                        <div>
                            <Button onClick={closeDrawer} style={{marginRight: 8}}>
                                Cancelar
                            </Button>
                            <Button type={"primary"} onClick={onSaveProcedure} loading={saveButtonLoading} disabled={procedureForm.getFieldValue('annulled') === true || isReadOnly}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                }
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <Button onClick={goPrev} disabled={currentIndex == null || ((pagination.current || 1) === 1 && currentIndex <= 0)}>Anterior</Button>
                    <div />
                    <Button onClick={goNext} disabled={currentIndex == null || ((((pagination.current || 1) * (pagination.pageSize || data.length || 10)) >= (pagination.total || 0)) && currentIndex >= (data.length - 1))}>Siguiente</Button>
                </div>
                {procedureForm && procedureForm.getFieldValue('annulled') === true && (
                    <div style={{ marginBottom: 8 }}>
                        <Tag color="red">Historia clínica anulada</Tag>
                    </div>
                )}
                <Spin spinning={drawerLoading} tip="Cargando...">
                <Form
                    form={procedureForm}
                    layout={"vertical"}
                    hideRequiredMark
                    disabled={isReadOnly}
                    onValuesChange={(changedValues, allValues) => {
                        // Activar banderas de secciones cuando cambia el tipo desde el form (incluye setFieldsValue al abrir un registro)
                        if (Object.prototype.hasOwnProperty.call(changedValues, 'type')) {
                            const selected = changedValues.type;
                            try {
                                setPsicologicalAdmision(selected === 'APS');
                                setPsiquitricAdmision(selected === 'APQ');
                                setPsicologicalEvolution(selected === 'EPS');
                                setPsiquitricEvolution(selected === 'EPQ');
                                setPsiquitricExam(selected === 'EXP');
                                setPsiquitricNurse(selected === 'ENF');
                                setGroupActivityEvolution(selected === 'TGR');
                                setNurseAdmissionEval(selected === 'EIE');
                                setClinicalExam(selected === 'ECL');
                                setAnamnesis(selected === 'ANA');
                                setSujecionMecanica(selected === 'CSM');
                                setConstantesVitales(selected === 'CSV');
                                setGlucemia(selected === 'GLU');
                                setPesoSemanal(selected === 'PES');
                                setProtocoloCaidas(selected === 'PCA');
                                setAdmisionMusicoterapia(selected === 'AMU');
                                setAdmisionAsisSocial(selected === 'AAS');
                                setAdmisionTerapiaOcupacional(selected === 'ATO');
                                setAdmisionKinesiologia(selected === 'AKI');
                                setAdmisionNutricion(selected === 'ANU');
                                setNutricion(selected === 'NUT');
                                setPae(selected === 'PAE');
                                setEvolucionKinesiologica(selected === 'EKI');
                                setAdmisionClinica(selected === 'ACL');
                                setEvolucionClinicaMensual(selected === 'ECM');
                                setEvolucionPsiquiatricaMensual(selected === 'EPM');
                                setSimpleProcedure(['ASO','EFM','MGR','HDD', 'ETO', 'EMU'].includes(selected));
                            } catch (e) { /* noop */ }
                        }
                        // Logic for exclusive switches in APQ
                        if (changedValues.data && changedValues.data.type === undefined) {
                            // Check if it's one of the hybrid fields
                            const hybridFields = [
                                { path: ['examen_psiquiatrico', 'colabora_con_el_examen'], options: ['si', 'no'], trigger: 'no' },
                                { path: ['examen_psiquiatrico', 'signos_motores'], options: ['si', 'no'], trigger: 'si' },
                                { path: ['examen_psiquiatrico', 'incontinencia'], options: ['si', 'no'], trigger: 'si' },
                                { path: ['area_cognitiva', 'desorientacion'], options: ['si', 'no'], trigger: 'si' },
                                { path: ['area_cognitiva', 'conciencia_de_enfermedad'], options: ['si', 'no'], trigger: 'si' },
                                { path: ['area_cognitiva', 'memoria'], options: ['normal', 'alterada'], trigger: 'alterada' },
                                { path: ['area_cognitiva', 'sensopercepcion'], options: ['no', 'si'], trigger: 'si' },
                                { path: ['area_cognitiva', 'ideas_patologicas'], options: ['si', 'no'], trigger: 'si' },
                                { path: ['area_volitiva', 'TOC'], options: ['si', 'no'], trigger: 'si' },
                                { path: ['area_timica', 'excitacion_psicomotriz'], options: ['si', 'no'], trigger: 'si' }
                            ];

                            hybridFields.forEach(field => {
                                const section = field.path[0];
                                const subSection = field.path[1];

                                if (changedValues.data[section] && changedValues.data[section][subSection]) {
                                    const changed = changedValues.data[section][subSection];
                                    const currentValues = allValues.data[section][subSection];

                                    field.options.forEach(opt => {
                                        if (changed[opt] === true) {
                                            // Set others to false
                                            const update = {};
                                            field.options.forEach(otherOpt => {
                                                if (otherOpt !== opt) {
                                                    update[otherOpt] = false;
                                                }
                                            });
                                            // Reset detail if the new selection is not the trigger
                                            if (opt !== field.trigger) {
                                                update.detalle = "";
                                                if (subSection === 'ideas_patologicas') {
                                                    update.condicionan_conducta = "";
                                                }
                                                if (subSection === 'sensopercepcion') {
                                                    update.otras = "";
                                                }
                                            }

                                            procedureForm.setFieldsValue({
                                                data: {
                                                    ...allValues.data,
                                                    [section]: {
                                                        ...allValues.data[section],
                                                        [subSection]: {
                                                            ...currentValues,
                                                            ...update
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }

                        // APQ: Clear Reingreso fields if disabled
                        if (changedValues.data && changedValues.data.reingreso === false) {
                            procedureForm.setFieldsValue({
                                data: {
                                    ...allValues.data,
                                    fecha_reingreso: null,
                                    motivo_derivacion: ""
                                }
                            });
                        }

                        if (changedValues.aki_tinetti_equilibrio !== undefined || changedValues.aki_tinetti_marcha !== undefined) {
                            const equilibrio = allValues.aki_tinetti_equilibrio || 0;
                            const marcha = allValues.aki_tinetti_marcha || 0;
                            const total = equilibrio + marcha;
                            let clasificacion = '';
                            if (total < 19) {
                                clasificacion = 'Alto riesgo de caída (<19)';
                            } else if (total <= 24) {
                                clasificacion = 'Riesgo de caída (19-24)';
                            } else {
                                clasificacion = 'Bajo riesgo de caída (25-28)';
                            }
                            procedureForm.setFieldsValue({
                                aki_tinetti_total: total,
                                aki_clasificacion_riesgo: clasificacion
                            });
                        }
                    }}
                >
                    <Form.Item
                        name="id"
                        label="id"
                        hidden
                    >
                        <Input hidden/>
                    </Form.Item>
                    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.id !== currentValues.id}>
                        {({ getFieldValue }) => (
                            <Form.Item
                                name="type"
                                label="Tipo"
                            >
                                <Select
                                    disabled={!!getFieldValue('id')}
                                    allowClear
                                    placeholder="Tipo"
                                    showSearch
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    showArrow={false}
                                    onChange={(value) => {
                                        if (!value) {
                                            setPsicologicalAdmision(false);
                                            setPsiquitricAdmision(false);
                                            setPsicologicalEvolution(false);
                                            setPsiquitricEvolution(false);
                                            setPsiquitricExam(false);
                                            setPsiquitricNurse(false);
                                            setGroupActivityEvolution(false);
                                            setNurseAdmissionEval(false);
                                            setClinicalExam(false);
                                            setAnamnesis(false);
                                            setSujecionMecanica(false);
                                            setConstantesVitales(false);
                                            setGlucemia(false);
                                            setPesoSemanal(false);
                                            setProtocoloCaidas(false);
                                            setAdmisionMusicoterapia(false);
                                            setAdmisionAsisSocial(false);
                                            setAdmisionTerapiaOcupacional(false);
                                            setAdmisionKinesiologia(false);
                                            setAdmisionNutricion(false);
                                            setNutricion(false);
                                            setPae(false);
                                            setEvolucionKinesiologica(false);
                                            setAdmisionClinica(false);
                                            setEvolucionClinicaMensual(false);
                                            setSimpleProcedure(false);
                                            setHasTypeSelected(false);
                                        }
                                    }}
                                    onSelect={(selected) => {
                                        setPsicologicalAdmision(selected === 'APS');
                                        setPsiquitricAdmision(selected === 'APQ');
                                        setPsicologicalEvolution(selected === 'EPS');
                                        setPsiquitricEvolution(selected === 'EPQ');
                                        setPsiquitricExam(selected === 'EXP');
                                        setPsiquitricNurse(selected === 'ENF');
                                        setGroupActivityEvolution(selected === 'TGR');
                                        setNurseAdmissionEval(selected === 'EIE');
                                        setClinicalExam(selected === 'ECL');
                                        setAnamnesis(selected === 'ANA');
                                        setSujecionMecanica(selected === 'CSM');
                                        setConstantesVitales(selected === 'CSV');
                                        setGlucemia(selected === 'GLU');
                                        setPesoSemanal(selected === 'PES');
                                        setProtocoloCaidas(selected === 'PCA');
                                        setAdmisionMusicoterapia(selected === 'AMU');
                                        setAdmisionAsisSocial(selected === 'AAS');
                                        setAdmisionTerapiaOcupacional(selected === 'ATO');
                                        setAdmisionKinesiologia(selected === 'AKI');
                                        setAdmisionNutricion(selected === 'ANU');
                                        setNutricion(selected === 'NUT');
                                        setPae(selected === 'PAE');
                                        setEvolucionKinesiologica(selected === 'EKI');
                                        setAdmisionClinica(selected === 'ACL');
                                        setEvolucionClinicaMensual(selected === 'ECM');
                                        setEvolucionPsiquiatricaMensual(selected === 'EPM');
                                        if (selected === 'EPM') {
                                            fetchEpmTemplates();
                                        }
                                        // Prefill diagnóstico para ECM usando última ACL
                                        if (selected === 'ECM' && patient_id) {
                                            prefillECM();
                                        }
                                        // Prefill diagnóstico para EPM usando última APQ
                                        if (selected === 'EPM' && patient_id) {
                                            prefillEPM();
                                        }
                                        // Prefill dieta para NUT usando última NUT o ANU
                                        if (selected === 'NUT' && patient_id) {
                                            console.log("PREFILL NUT!!!")
                                            console.log(patient_id)
                                            prefillNUT();
                                        }
                                        // Auto-init Mes y Año for PES
                                        if (selected === 'PES') {
                                            const currentMesAnio = procedureForm.getFieldValue('pes_mes_anio');
                                            if (!currentMesAnio) {
                                                procedureForm.setFieldsValue({ pes_mes_anio: moment() });
                                            }
                                        }
                                        // Default Turno for TGR if empty
                                        if (selected === 'TGR') {
                                            const currentShift = procedureForm.getFieldValue('shift');
                                            if (!currentShift) {
                                                procedureForm.setFieldsValue({ shift: 'TARDE' });
                                            }
                                        }
                                        // Simple single-field procedures
                                        if (['MCL', 'MTR', 'PTR', 'TGR', 'MGR', 'EIE', 'NUT', 'ASO', 'EFM', 'AMU', 'AAS', 'ATO', 'AKI', 'ANU', 'PAE', 'EKI', 'ACL', 'ECM', 'EPM', 'ETO', 'EMU'].includes(selected)) {
                                            setSimpleProcedure(true);
                                        } else {
                                            setSimpleProcedure(false);
                                        }
                                        setHasTypeSelected(true);
                                    }}
                                >
                                    {(typeOptions || []).map(t => (
                                        <Option key={t.code} value={t.code} label={t.label}>
                                            <Tag color={TYPE_COLORS[t.code] || 'default'}>{t.label}</Tag>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </Form.Item>
                    {/*                    <Form.Item*/}
                    {/*    name="type2"*/}
                    {/*    label="Tipo de Terapia"*/}
                    {/*>*/}
                    {/*    <Select*/}
                    {/*        allowClear*/}
                    {/*        placeholder="Tipo"*/}
                    {/*        showArrow={false}*/}
                    {/*      >*/}
                    {/*        <Option value=""></Option>*/}
                    {/*        <Option value="APS">Musico terapia</Option>*/}
                    {/*        <Option value="APQ">Educ. Fisica</Option>*/}
                    {/*        <Option value="EPS">Terapia ocupacional</Option>*/}
                    {/*        <Option value="EPQ">Nutricion</Option>*/}
                    {/*    </Select>*/}
                    {/*</Form.Item>*/}
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="title"*/}
                    {/*            label="Título"*/}
                    {/*        >*/}
                    {/*            <Input/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="motive"
                                label="Motivo"
                                style={psicologicalAdmision ? {
                                    display: "inline",
                                    marginRight: 8
                                } : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/* --- Admisión Psiquiátrica (APQ) Nueva Estructura --- */}
                    {psiquitricAdmision && (
                        <>
                            <Row gutter={[16, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        name={['data', 'reingreso']}
                                        valuePropName="checked"
                                        label="Reingreso"
                                    >
                                        <Switch />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => prevValues.data?.reingreso !== currentValues.data?.reingreso}
                            >
                                {({ getFieldValue }) => {
                                    const reingreso = getFieldValue(['data', 'reingreso']);
                                    if (reingreso) {
                                        return (
                                            <Row gutter={[16, 8]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={['data', 'fecha_reingreso']}
                                                        label="Fecha de reingreso"
                                                    >
                                                        <DatePicker showTime format="DD-MM-YYYY HH:mm" style={{ width: '100%' }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={['data', 'motivo_derivacion']}
                                                        label="Motivo de derivación"
                                                    >
                                                        <TextArea rows={2} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        );
                                    }
                                    return null;
                                }}
                            </Form.Item>

                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Antecedentes</Divider>
                                </Col>
                            </Row>
                            <Row gutter={[16, 8]}>
                                {Object.keys(admisionPsiquiatricaSchema.antecedentes).map(key => {
                                    if (key === 'otro') return null;
                                    const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                    return (
                                        <Col span={6} key={key}>
                                            <Form.Item
                                                name={['data', 'antecedentes', key]}
                                                valuePropName="checked"
                                                label={label}
                                            >
                                                <Switch />
                                            </Form.Item>
                                        </Col>
                                    );
                                })}
                            </Row>
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        name={['data', 'antecedentes', 'otro']}
                                        label="Otro"
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* --- Examen Psiquiátrico --- */}
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Examen Psiquiátrico</Divider>
                                </Col>
                            </Row>
                            {Object.keys(admisionPsiquiatricaSchema.examen_psiquiatrico).map(sectionKey => {
                                const sectionValue = admisionPsiquiatricaSchema.examen_psiquiatrico[sectionKey];
                                if (typeof sectionValue === 'string') {
                                    return (
                                        <Col span={8} key={sectionKey}>
                                            <Form.Item
                                                name={['data', 'examen_psiquiatrico', sectionKey]}
                                                label={sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1).replace(/_/g, ' ')}
                                            >
                                                <Select placeholder="Seleccionar...">
                                                    {(APQ_OPTIONS[sectionKey] || []).map(opt => (
                                                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    );
                                }
                                return (
                                    <div key={sectionKey} style={{ marginBottom: 16, width: '100%' }}>
                                        <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1).replace(/_/g, ' ')}</div>
                                        <Row gutter={[16, 8]}>
                                    {Object.keys(sectionValue).map(key => {
                                        if (key === 'detalle' || key === 'condicionan_conducta') return null;
                                        const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                        return (
                                            <Col span={6} key={key}>
                                                <Form.Item
                                                    name={['data', 'examen_psiquiatrico', sectionKey, key]}
                                                    valuePropName="checked"
                                                    label={label}
                                                >
                                                    <Switch onChange={() => {
                                                        // Forzar actualización si es un campo trigger
                                                        const triggerMap = {
                                                            colabora_con_el_examen: 'no',
                                                            signos_motores: 'si',
                                                            incontinencia: 'si'
                                                        };
                                                        if (key === triggerMap[sectionKey]) {
                                                            procedureForm.setFieldsValue({
                                                                data: {
                                                                    ...procedureForm.getFieldValue('data')
                                                                }
                                                            });
                                                        }
                                                    }} />
                                                </Form.Item>
                                            </Col>
                                        );
                                    })}
                                        </Row>
                                        {/* Dropdown condicional para detalle */}
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => prevValues.data?.examen_psiquiatrico?.[sectionKey] !== currentValues.data?.examen_psiquiatrico?.[sectionKey]}
                                        >
                                            {({ getFieldValue }) => {
                                                const currentVal = getFieldValue(['data', 'examen_psiquiatrico', sectionKey]);
                                                const triggerMap = {
                                                    colabora_con_el_examen: 'no',
                                                    signos_motores: 'si',
                                                    incontinencia: 'si'
                                                };
                                                const trigger = triggerMap[sectionKey];
                                                if (currentVal && currentVal[trigger]) {
                                                    return (
                                                        <Row gutter={[16, 8]} style={{marginTop: 8}}>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    name={['data', 'examen_psiquiatrico', sectionKey, 'detalle']}
                                                                    label="DETALLE"
                                                                >
                                                                    <Select placeholder="Seleccionar...">
                                                                        {(APQ_OPTIONS[sectionKey] || []).map(opt => (
                                                                            <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    );
                                                }
                                                return null;
                                            }}
                                        </Form.Item>
                                    </div>
                                );
                            })}

                            {/* --- Area Cognitiva --- */}
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Área Cognitiva</Divider>
                                </Col>
                            </Row>
                            {Object.keys(admisionPsiquiatricaSchema.area_cognitiva).map(sectionKey => {
                                const sectionValue = admisionPsiquiatricaSchema.area_cognitiva[sectionKey];
                                if (typeof sectionValue === 'string') {
                                    return (
                                        <Col span={8} key={sectionKey}>
                                            <Form.Item
                                                name={['data', 'area_cognitiva', sectionKey]}
                                                label={sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1).replace(/_/g, ' ')}
                                            >
                                                <Select placeholder="Seleccionar...">
                                                    {(APQ_OPTIONS[sectionKey] || []).map(opt => (
                                                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    );
                                }
                                if (typeof sectionValue === 'object') {
                                    return (
                                        <div key={sectionKey} style={{ marginBottom: 16, width: '100%' }}>
                                            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1).replace(/_/g, ' ')}</div>
                                            <Row gutter={[16, 8]}>
                                                {Object.keys(sectionValue).map(key => {
                                                    if (key === 'detalle' || key === 'condicionan_conducta' || key === 'otras') return null;
                                                    const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                                    return (
                                                        <Col span={6} key={key}>
                                                            <Form.Item
                                                                name={['data', 'area_cognitiva', sectionKey, key]}
                                                                valuePropName="checked"
                                                                label={label}
                                                            >
                                                                <Switch onChange={() => {
                                                                    const triggerMap = {
                                                                        desorientacion: 'si',
                                                                        conciencia_de_enfermedad: 'si',
                                                                        memoria: 'alterada',
                                                                        sensopercepcion: 'si',
                                                                        ideas_patologicas: 'si'
                                                                    };
                                                                    if (key === triggerMap[sectionKey]) {
                                                                        procedureForm.setFieldsValue({
                                                                            data: { ...procedureForm.getFieldValue('data') }
                                                                        });
                                                                    }
                                                                }} />
                                                            </Form.Item>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                            {/* Dropdown condicional para detalle */}
                                            <Form.Item
                                                noStyle
                                                shouldUpdate={(prevValues, currentValues) => prevValues.data?.area_cognitiva?.[sectionKey] !== currentValues.data?.area_cognitiva?.[sectionKey]}
                                            >
                                                {({ getFieldValue }) => {
                                                    const currentVal = getFieldValue(['data', 'area_cognitiva', sectionKey]);
                                                    const triggerMap = {
                                                        desorientacion: 'si',
                                                        conciencia_de_enfermedad: 'si',
                                                        memoria: 'alterada',
                                                        sensopercepcion: 'si',
                                                        ideas_patologicas: 'si'
                                                    };
                                                    const trigger = triggerMap[sectionKey];
                                                    if (currentVal && currentVal[trigger]) {
                                                        return (
                                                            <>
                                                                {sectionKey !== 'sensopercepcion' && (
                                                                <Row gutter={[16, 8]} style={{marginTop: 8}}>
                                                                    <Col span={12}>
                                                                        <Form.Item
                                                                            name={['data', 'area_cognitiva', sectionKey, 'detalle']}
                                                                            label="Detalle"
                                                                        >
                                                                            <Select placeholder="Seleccionar...">
                                                                                {(APQ_OPTIONS[sectionKey] || []).map(opt => (
                                                                                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                                    )}
                                                                {sectionKey === 'sensopercepcion' && (
                                                                <Row gutter={[16, 8]} style={{marginTop: 8}}>
                                                                    <Col span={12}>
                                                                        <Form.Item
                                                                            name={['data', 'area_cognitiva', sectionKey, 'alucinaciones']}
                                                                            label="Alucinaciones"
                                                                        >
                                                                            <Select placeholder="Seleccionar...">
                                                                                {(APQ_OPTIONS[sectionKey] || []).map(opt => (
                                                                                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                               )}
                                                                {sectionKey === 'ideas_patologicas' && (
                                                                    <Row gutter={[16, 8]}>
                                                                        <Col span={12}>
                                                                            <Form.Item
                                                                                name={['data', 'area_cognitiva', sectionKey, 'condicionan_conducta']}
                                                                                label="Condicionan Conducta"
                                                                            >
                                                                                <Select placeholder="Seleccionar...">
                                                                                    {(APQ_OPTIONS.ideas_patologicas_condicionan || []).map(opt => (
                                                                                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                                {sectionKey === 'sensopercepcion' && (
                                                                    <Row gutter={[16, 8]}>
                                                                        <Col span={12}>
                                                                            <Form.Item
                                                                                name={['data', 'area_cognitiva', sectionKey, 'otras']}
                                                                                label="Otras"
                                                                            >
                                                                                <Input />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                            </>
                                                        );
                                                    }
                                                    return null;
                                                }}
                                            </Form.Item>
                                        </div>
                                    );
                                }
                                return null;
                            })}

                            {/* --- Area Volitiva --- */}
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Área Volitiva</Divider>
                                </Col>
                            </Row>
                            <Row gutter={[16, 8]}>
                                {Object.keys(admisionPsiquiatricaSchema.area_volitiva).map(key => {
                                    if (typeof admisionPsiquiatricaSchema.area_volitiva[key] === 'boolean') {
                                        const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                        return (
                                            <Col span={6} key={key}>
                                                <Form.Item
                                                    name={['data', 'area_volitiva', key]}
                                                    valuePropName="checked"
                                                    label={label}
                                                >
                                                    <Switch />
                                                </Form.Item>
                                            </Col>
                                        );
                                    }
                                    return null;
                                })}
                            </Row>
                            <div style={{ marginTop: 16 }}>
                                <div style={{ fontWeight: 'bold', marginBottom: 8 }}>TOC</div>
                                <Row gutter={[16, 8]}>
                                    {Object.keys(admisionPsiquiatricaSchema.area_volitiva.TOC).map(key => {
                                        if (key === 'detalle') return null;
                                        const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                        return (
                                            <Col span={6} key={key}>
                                                <Form.Item
                                                    name={['data', 'area_volitiva', 'TOC', key]}
                                                    valuePropName="checked"
                                                    label={label}
                                                >
                                                    <Switch onChange={() => {
                                                        if (key === 'si') {
                                                            procedureForm.setFieldsValue({
                                                                data: { ...procedureForm.getFieldValue('data') }
                                                            });
                                                        }
                                                    }} />
                                                </Form.Item>
                                            </Col>
                                        );
                                    })}
                                </Row>
                                {/* Dropdown condicional para detalle */}
                                <Form.Item
                                    noStyle
                                    shouldUpdate={(prevValues, currentValues) => prevValues.data?.area_volitiva?.TOC !== currentValues.data?.area_volitiva?.TOC}
                                >
                                    {({ getFieldValue }) => {
                                        const currentVal = getFieldValue(['data', 'area_volitiva', 'TOC']);
                                        if (currentVal && currentVal.si) {
                                            return (
                                                <Row gutter={[16, 8]} style={{marginTop: 8}}>
                                                    <Col span={12}>
                                                        <Form.Item
                                                            name={['data', 'area_volitiva', 'TOC', 'detalle']}
                                                            label="DETALLE"
                                                        >
                                                            <Select placeholder="Seleccionar...">
                                                                {(APQ_OPTIONS.TOC || []).map(opt => (
                                                                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            );
                                        }
                                        return null;
                                    }}
                                </Form.Item>
                            </div>

                            {/* --- Area Timica --- */}
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Área Tímica</Divider>
                                </Col>
                            </Row>
                            <Row gutter={[16, 8]}>
                                {Object.keys(admisionPsiquiatricaSchema.area_timica).map(key => {
                                    if (typeof admisionPsiquiatricaSchema.area_timica[key] === 'boolean') {
                                        const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                        return (
                                            <Col span={6} key={key}>
                                                <Form.Item
                                                    name={['data', 'area_timica', key]}
                                                    valuePropName="checked"
                                                    label={label}
                                                >
                                                    <Switch />
                                                </Form.Item>
                                            </Col>
                                        );
                                    }
                                    return null;
                                })}
                            </Row>
                            <div style={{ marginTop: 16 }}>
                                <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Excitación Psicomotriz</div>
                                <Row gutter={[16, 8]}>
                                    {Object.keys(admisionPsiquiatricaSchema.area_timica.excitacion_psicomotriz).map(key => {
                                        if (key === 'detalle') return null;
                                        const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                        return (
                                            <Col span={6} key={key}>
                                                <Form.Item
                                                    name={['data', 'area_timica', 'excitacion_psicomotriz', key]}
                                                    valuePropName="checked"
                                                    label={label}
                                                >
                                                    <Switch onChange={() => {
                                                        if (key === 'si') {
                                                            procedureForm.setFieldsValue({
                                                                data: { ...procedureForm.getFieldValue('data') }
                                                            });
                                                        }
                                                    }} />
                                                </Form.Item>
                                            </Col>
                                        );
                                    })}
                                </Row>
                                {/* Dropdown condicional para detalle */}
                                <Form.Item
                                    noStyle
                                    shouldUpdate={(prevValues, currentValues) => prevValues.data?.area_timica?.excitacion_psicomotriz !== currentValues.data?.area_timica?.excitacion_psicomotriz}
                                >
                                    {({ getFieldValue }) => {
                                        const currentVal = getFieldValue(['data', 'area_timica', 'excitacion_psicomotriz']);
                                        if (currentVal && currentVal.si) {
                                            return (
                                                <Row gutter={[16, 8]} style={{marginTop: 8}}>
                                                    <Col span={12}>
                                                        <Form.Item
                                                            name={['data', 'area_timica', 'excitacion_psicomotriz', 'detalle']}
                                                            label="DETALLE"
                                                        >
                                                            <Select placeholder="Seleccionar...">
                                                                {(APQ_OPTIONS.excitacion_psicomotriz || []).map(opt => (
                                                                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            );
                                        }
                                        return null;
                                    }}
                                </Form.Item>
                            </div>

                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        name={['data', 'diagnostico_presuntivo_CIE10']}
                                        label="Diagnóstico Presuntivo CIE10"
                                    >
                                        <TextArea rows={2} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* --- Indicaciones --- */}
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Indicaciones</Divider>
                                </Col>
                            </Row>
                            {Object.keys(admisionPsiquiatricaSchema.indicaciones).map(sectionKey => {
                                const sectionValue = admisionPsiquiatricaSchema.indicaciones[sectionKey];
                                if (typeof sectionValue === 'string') {
                                    return (
                                        <Col span={8} key={sectionKey}>
                                            <Form.Item
                                                name={['data', 'indicaciones', sectionKey]}
                                                label={sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1).replace(/_/g, ' ')}
                                            >
                                                <Select placeholder="Seleccionar...">
                                                    {(APQ_OPTIONS[sectionKey] || []).map(opt => (
                                                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    );
                                }
                                return (
                                    <div key={sectionKey} style={{ marginBottom: 16, width: '100%' }}>
                                        <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1).replace(/_/g, ' ')}</div>
                                        <Row gutter={[16, 8]}>
                                            {Object.keys(sectionValue).map(key => {
                                                const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
                                                return (
                                                    <Col span={6} key={key}>
                                                        <Form.Item
                                                            name={['data', 'indicaciones', sectionKey, key]}
                                                            valuePropName="checked"
                                                            label={label}
                                                        >
                                                            <Switch />
                                                        </Form.Item>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </div>
                                );
                            })}
                        </>
                    )}

                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricAdmision ? {display: "none"} : {display: "none"}}>
                            <Divider orientation="left">Antecedentes Clínicos y Psiquiátricos</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="convulsiones"
                                label="Convulsiones"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="cadera"
                                label="Fr. De Cadera"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="acv"
                                label="ACV"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="basilur"
                                label="Sin V. Busilur"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="parkinson"
                                label="Parkinson"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="neurolepticos"
                                label="Sint. Neurolepticos"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="prostatismo"
                                label="Prostatismo"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="glaucoma"
                                label="Glaucoma"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="dbi"
                                label="DBI"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="suicidio"
                                label="Tent. de Suicidio"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="hipertension"
                                label="Hipertension Orostatica"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="hta"
                                label="HTA"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="cardiopatia"
                                label="Cardiopatía"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="etilismo"
                                label="Etilismo"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="internacion"
                                label="Internacion Psiquiatrica"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="resumen"
                                label="Trae resumen"
                                style={{display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="personal_antecedents"
                                label={psicologicalAdmision ? "Antecedentes Personales (Escolaridad y Laboral)" : "Antecedentes Personales y Familiares"}
                                style={psicologicalAdmision || psiquitricAdmision ? {
                                    display: "inline",
                                    marginRight: 8
                                } : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="concurre"
                                label="Concurre"
                                style={psiquitricAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="solo/acompañado"
                                    showArrow={false}
                                >
                                    <Option value="SOL">Solo</Option>
                                    <Option value="ACO">Acompañado</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="compromiso"
                                label="Compromiso Familiar"
                                style={psiquitricAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="conciencia"
                                label="Conciencia de enfermedad"
                                style={psiquitricAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="tipo_familia"
                                label="Tipo de familia"
                                style={psiquitricAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="tipo de familia"
                                    showArrow={false}
                                >
                                    <Option value="CO">Continente</Option>
                                    <Option value="EX">Expulsiva</Option>
                                    <Option value="PA">Paranoide</Option>
                                    <Option value="QU">Querellante</Option>
                                    <Option value="AB">Abandonica</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="origin_family_history"
                                label="Historial Familiar de origen"
                                style={psicologicalAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="current_family_history"
                                label="Historial Familiar actual"
                                style={psicologicalAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="sintoms"
                                label="Sintomas actuales"
                                style={
                                    psicologicalEvolution || psiquitricEvolution ? {
                                        display: "inline",
                                        marginRight: 8
                                    } : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="diagnosis"
                                label="Diagnóstico Presuntivo"
                                style={psicologicalAdmision ? {
                                    display: "inline",
                                    marginRight: 8
                                } : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="objectives"
                                label="Objetivos Terapeuticos"
                                style={psicologicalAdmision ? {
                                    display: "inline",
                                    marginRight: 8
                                } : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="evolution"*/}
                    {/*            label="Evolución"*/}
                    {/*            style={psicologicalEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}*/}
                    {/*        >*/}
                    {/*            <Select*/}
                    {/*                allowClear*/}
                    {/*                placeholder="favorable/desfavorable"*/}
                    {/*                showArrow={false}*/}
                    {/*            >*/}
                    {/*                <Option value=""></Option>*/}
                    {/*                <Option value="F">Favorable</Option>*/}
                    {/*                <Option value="D">Desfavorable</Option>*/}
                    {/*            </Select>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="tematica"*/}
                    {/*            label="Temática desarrollada"*/}
                    {/*            style={psicologicalEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}*/}
                    {/*        >*/}
                    {/*            <TextArea/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="pronostico"*/}
                    {/*            label="Pronóstico"*/}
                    {/*            style={psicologicalEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}*/}
                    {/*        >*/}
                    {/*            <TextArea/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="medication_type"
                                label="Tipo de medicación"
                                style={psiquitricEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="rasgos_de_familia"
                                label="Rasgos a destacar de la familia"
                                style={psiquitricAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="side_effects"
                                label="Efectos adversos"
                                style={psiquitricEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="plan"
                                label="Plan Terapeutico"
                                style={psicologicalAdmision ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="shift"
                                label="Turno"
                                style={(psiquitricNurse || groupActivityEvolution) ? {display: "inline", marginRight: 8} : {display: "none"}}
                                rules={(psiquitricNurse || groupActivityEvolution) ? [{ required: true, message: 'Seleccione el turno' }] : []}
                            >
                                <Select allowClear placeholder="Seleccione turno">
                                    <Option value="MANANA">Mañana</Option>
                                    <Option value="TARDE">Tarde</Option>
                                    <Option value="NOCHE">Noche</Option>
                                    <Option value="SADOFE_1">SADOFE-Turno Mañana</Option>
                                    <Option value="SADOFE_2">SADOFE-Turno Tarde</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="enf_piso"
                                label="Piso"
                                style={psiquitricNurse ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select allowClear showSearch placeholder="Seleccione piso"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
                                >
                                    <Option value="PB">PB</Option>
                                    <Option value="1">1</Option>
                                    <Option value="2">2</Option>
                                    <Option value="3">3</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/* TGR: Evolución de Actividades Grupales */}
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_activity"
                                label="Actividad Grupal"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="Seleccione actividad"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    <Option value="Gimnasia">Gimnasia</Option>
                                    <Option value="Gimnasia Aeróbica">Gimnasia Aeróbica</Option>
                                    <Option value="Arte Terapia">Arte Terapia</Option>
                                    <Option value="Musicoterapia">Musicoterapia</Option>
                                    <Option value="Dinámicas Grupales">Dinámicas Grupales</Option>
                                    <Option value="Terapia de Grupo">Terapia de Grupo</Option>
                                    <Option value="Terapia Ocupacional">Terapia Ocupacional</Option>
                                    <Option value="Estimulación Cognitiva">Estimulación Cognitiva</Option>
                                    <Option value="Actualidad/Noticias">Actualidad/Noticias</Option>
                                    <Option value="Taller Literario">Taller Literario</Option>
                                    <Option value="Postura y Elongación">Postura y Elongación</Option>
                                    <Option value="Elongación y Relajación">Elongación y Relajación</Option>
                                    <Option value="Movimiento Articular">Movimiento Articular</Option>
                                    <Option value="Gestión de Emociones">Gestión de Emociones</Option>
                                    <Option value="Cine Debate">Cine Debate</Option>
                                    <Option value="Asamblea">Asamblea</Option>
                                    <Option value="Teatro">Teatro</Option>
                                    <Option value="Recreación">Recreación</Option>
                                    <Option value="Recreación Deportiva">Recreación Deportiva</Option>
                                    <Option value="Psicomotricidad">Psicomotricidad</Option>
                                    <Option value="Medio Ambiente">Medio Ambiente</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_date"
                                label="Día"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <DatePicker format={"DD/MM/YYYY"}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_objective"
                                label="Objetivo de la Actividad"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_attitude_instruction"
                                label="Actitud frente a la consigna"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Radio.Group>
                                    <Radio value="Cumple">Cumple</Radio>
                                    <Radio value="No cumple">No cumple</Radio>
                                    <Radio value="Cumple con dificultad">Cumple con dificultad</Radio>
                                    <Radio value="Cumple con apoyo">Cumple con apoyo</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_attitude_activity"
                                label="Actitud frente a la actividad"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Radio.Group>
                                    <Radio value="Activa">Activa</Radio>
                                    <Radio value="Pasiva">Pasiva</Radio>
                                    <Radio value="Indiferente">Indiferente</Radio>
                                    <Radio value="Colaboradora">Colaboradora</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_interaction"
                                label="Interacción grupal"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Checkbox.Group
                                    options={["Adecuada","Extrovertida","Pasiva","Explosiva","Insegura","Retraída","Hostil","Positiva","Activa","Desconfiada","Dependiente","Agresiva","Ausente","Actuadora","Seductora"]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_communication"
                                label="Comunicación"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Radio.Group>
                                    <Radio value="Adecuada">Adecuada</Radio>
                                    <Radio value="Ausente">Ausente</Radio>
                                    <Radio value="Pobre">Pobre</Radio>
                                    <Radio value="Con dificultad">Con dificultad</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_aportes"
                                label="Capacidad de brindar aportes (ideas, soluciones, fantasías)"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Radio.Group>
                                    <Radio value="Adecuada">Adecuada</Radio>
                                    <Radio value="Ausente">Ausente</Radio>
                                    <Radio value="Pobre">Pobre</Radio>
                                    <Radio value="Con dificultad">Con dificultad</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="group_execution"
                                label="Ejecución de materiales"
                                style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Radio.Group>
                                    <Radio value="Adecuadamente">Adecuadamente</Radio>
                                    <Radio value="Con apoyo">Con apoyo</Radio>
                                    <Radio value="Nulo">Nulo</Radio>
                                    <Radio value="Con dificultad">Con dificultad</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="group_observations"*/}
                    {/*            label="Observaciones"*/}
                    {/*            style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}*/}
                    {/*        >*/}
                    {/*            <TextArea/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="group_signature"*/}
                    {/*            label="Firma y Sello del Tallerista"*/}
                    {/*            style={groupActivityEvolution ? {display: "inline", marginRight: 8} : {display: "none"}}*/}
                    {/*        >*/}
                    {/*            <Input/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    {/* ECL: Exámen Clínico (dynamic from JSON) */}
                    {clinicalExam && (
                        <div>
                            {Array.isArray(examenClinicoSchema.sections) && examenClinicoSchema.sections.map((section, sidx) => (
                                <div key={`ecl-sec-${sidx}`}>
                                    <Row gutter={[8,8]}>
                                        <Col span={24}>
                                            <Divider orientation="left">{section.title}</Divider>
                                        </Col>
                                    </Row>
                                    <Row gutter={[8,8]}>
                                        {(section.fields || []).map((field, fidx) => {
                                            const name = `ecl_${field.id}`;
                                            const label = field.label || field.id;
                                            const type = field.type || 'text';
                                            let control = null;
                                            if (type === 'text') control = <Input/>;
                                            else if (type === 'textarea') control = <TextArea/>;
                                            else if (type === 'date') control = <DatePicker format={"DD/MM/YYYY"}/>;
                                            else if (type === 'checkbox') control = <Checkbox.Group options={field.options || []}/>;
                                            else if (type === 'radio') control = <Radio.Group options={(field.options || []).map(o => ({ label: o, value: o }))}/>;
                                            else control = <Input/>;
                                            return (
                                                <Col span={24} key={`ecl-field-${sidx}-${fidx}`}>
                                                    <Form.Item name={name} label={label}>
                                                        {control}
                                                    </Form.Item>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* NUT: Nutrición (evolución) */}
                    {nutricion && (
                        <div>
                            {Object.entries(nutricionSchema.properties).map(([sectionKey, sectionValue]) => {
                                if (sectionValue.type === 'object') {
                                    return (
                                        <div key={sectionKey}>
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Divider orientation="left">{sectionValue.title}</Divider>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 8]}>
                                                {Object.entries(sectionValue.properties).map(([fieldKey, fieldValue]) => {
                                                    const isTextarea = fieldKey === 'dieta' || fieldValue.type === 'textarea';
                                                    return (
                                                        <Col span={12} key={fieldKey}>
                                                            <Form.Item
                                                                name={['data', sectionKey, fieldKey]}
                                                                label={fieldValue.title}
                                                            >
                                                                {fieldValue.enum ? (
                                                                    <Select placeholder="Seleccionar...">
                                                                        {(fieldValue.enum || []).map(opt => (
                                                                            <Option key={opt} value={opt}>{opt}</Option>
                                                                        ))}
                                                                    </Select>
                                                                ) : fieldValue.type === 'number' ? (
                                                                    <InputNumber style={{ width: '100%' }} step={0.1} />
                                                                ) : isTextarea ? (
                                                                    <TextArea rows={4} />
                                                                ) : (
                                                                    <Input />
                                                                )}
                                                            </Form.Item>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                        </div>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    )}

                    {/* ANA: Anamnesis (dynamic from JSON) */}
                    {anamnesis && (
                        <div>
                            {Array.isArray(anamnesisSchema.sections) && anamnesisSchema.sections.map((section, sidx) => (
                                <div key={`ana-sec-${sidx}`}>
                                    <Row gutter={[8,8]}>
                                        <Col span={24}>
                                            <Divider orientation="left">{section.title}</Divider>
                                        </Col>
                                    </Row>
                                    <Row gutter={[8,8]}>
                                        {(section.fields || []).map((field, fidx) => {
                                            const name = `ana_${field.id}`;
                                            const label = field.label || field.id;
                                            const type = field.type || 'text';
                                            let control = null;
                                            if (type === 'text') control = <Input/>;
                                            else if (type === 'textarea') control = <TextArea/>;
                                            else if (type === 'date') control = <DatePicker format={"DD/MM/YYYY"}/>;
                                            else if (type === 'checkbox') control = <Checkbox.Group options={field.options || []}/>;
                                            else if (type === 'radio') control = <Radio.Group options={(field.options || []).map(o => ({ label: o, value: o }))}/>;
                                            else control = <Input/>;
                                            return (
                                                <Col span={24} key={`ana-field-${sidx}-${fidx}`}>
                                                    <Form.Item name={name} label={label}>
                                                        {control}
                                                    </Form.Item>
                                                    {field.type === 'radio' && field.extra && (
                                                        <Form.Item name={`${name}_extra`} label={field.extra}>
                                                            <Input/>
                                                        </Form.Item>
                                                    )}
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* ACL: Admisión Clínica */}
                    {admisionClinica && (
                        <div>
                            {Object.entries(admisionClinicaSchema.properties).map(([sectionKey, sectionValue]) => {
                                if (sectionValue.type === 'object') {
                                    return (
                                        <div key={sectionKey}>
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Divider orientation="left">{sectionValue.title}</Divider>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 8]}>
                                                {Object.entries(sectionValue.properties).map(([fieldKey, fieldValue]) => {
                                                    if (fieldValue.type === 'object') {
                                                        // Manejo de sub-objetos como 'torax' dentro de 'examen_fisico'
                                                        return (
                                                            <Col span={24} key={fieldKey}>
                                                                <div style={{ fontWeight: 'bold', marginBottom: 8, marginTop: 8 }}>{fieldValue.title}</div>
                                                                <Row gutter={[16, 8]}>
                                                                    {Object.entries(fieldValue.properties).map(([subFieldKey, subFieldValue]) => {
                                                                        // Check visibility for sub-fields (like mamas_otros, simetria_otros)
                                                                        if (subFieldKey.endsWith('_otros')) {
                                                                            const parentKey = subFieldKey.replace('_otros', '');
                                                                            return (
                                                                                <Form.Item noStyle dependencies={[['data', sectionKey, fieldKey, parentKey]]} key={subFieldKey}>
                                                                                    {({ getFieldValue }) => {
                                                                                        const parentValue = getFieldValue(['data', sectionKey, fieldKey, parentKey]);
                                                                                        const needsOther = (parentValue === 'Otros' || parentValue === 'Otras' || parentValue === 'Otro' || parentValue === 'No conservada' || parentValue === 'Sí');
                                                                                        if (!needsOther) return null;
                                                                                        return (
                                                                                            <Col span={12}>
                                                                                                <Form.Item
                                                                                                    name={['data', sectionKey, fieldKey, subFieldKey]}
                                                                                                    label={subFieldValue.title}
                                                                                                >
                                                                                                    {subFieldValue.enum ? (
                                                                                                        <Select placeholder="Seleccionar...">
                                                                                                            {subFieldValue.enum.map(opt => (
                                                                                                                <Option key={opt} value={opt}>{opt}</Option>
                                                                                                            ))}
                                                                                                        </Select>
                                                                                                    ) : subFieldValue.type === 'number' ? (
                                                                                                        <InputNumber style={{ width: '100%' }} />
                                                                                                    ) : <Input />}
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                        );
                                                                                    }}
                                                                                </Form.Item>
                                                                            );
                                                                        }
                                                                        return (
                                                                            <Col span={12} key={subFieldKey}>
                                                                                <Form.Item
                                                                                    name={['data', sectionKey, fieldKey, subFieldKey]}
                                                                                    label={subFieldValue.title}
                                                                                >
                                                                                    {subFieldValue.enum ? (
                                                                                        <Select placeholder="Seleccionar...">
                                                                                            {subFieldValue.enum.map(opt => (
                                                                                                <Option key={opt} value={opt}>{opt}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    ) : subFieldValue.type === 'number' ? (
                                                                                        <InputNumber style={{ width: '100%' }} />
                                                                                    ) : <Input />}
                                                                                </Form.Item>
                                                                            </Col>
                                                                        );
                                                                    })}
                                                                </Row>
                                                            </Col>
                                                        );
                                                    }

                                                    // Check visibility for fields (like alergias_otros, piel_otros, etc.)
                                                    if (fieldKey.endsWith('_otros')) {
                                                        const parentKey = fieldKey.replace('_otros', '');
                                                        return (
                                                            <Form.Item noStyle dependencies={[['data', sectionKey, parentKey]]} key={fieldKey}>
                                                                {({ getFieldValue }) => {
                                                                    const parentValue = getFieldValue(['data', sectionKey, parentKey]);
                                                                    const needsOther = (parentValue === 'Otros' || parentValue === 'Otras' || parentValue === 'Otro' || parentValue === 'No conservada' || parentValue === 'Sí' || parentValue === 'Incontinente' || parentValue === 'Doloroso' || parentValue === 'Distendido');
                                                                    if (!needsOther) return null;
                                                                    return (
                                                                        <Col span={12}>
                                                                            <Form.Item
                                                                                name={['data', sectionKey, fieldKey]}
                                                                                label={fieldValue.title}
                                                                            >
                                                                                {fieldValue.enum ? (
                                                                                    <Select placeholder="Seleccionar...">
                                                                                        {fieldValue.enum.map(opt => (
                                                                                            <Option key={opt} value={opt}>{opt}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                ) : fieldValue.format === 'date' ? (
                                                                                    <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                                                                                ) : fieldValue.type === 'number' ? (
                                                                                    <InputNumber style={{ width: '100%' }} />
                                                                                ) : fieldValue.maxLength && fieldValue.maxLength > 100 ? (
                                                                                    <TextArea rows={4} />
                                                                                ) : <Input />}
                                                                            </Form.Item>
                                                                        </Col>
                                                                    );
                                                                }}
                                                            </Form.Item>
                                                        );
                                                    }
                                                    // Specialized side selection for points_ureterales and puno_percusion_lumbar
                                                    if (fieldKey.endsWith('_lado')) {
                                                        const parentKey = fieldKey.replace('_lado', '');
                                                        return (
                                                            <Form.Item noStyle dependencies={[['data', sectionKey, parentKey]]} key={fieldKey}>
                                                                {({ getFieldValue }) => {
                                                                    const parentValue = getFieldValue(['data', sectionKey, parentKey]);
                                                                    const needsSide = (parentValue === 'Positivos' || parentValue === 'Positiva');
                                                                    if (!needsSide) return null;
                                                                    return (
                                                                        <Col span={12}>
                                                                            <Form.Item
                                                                                name={['data', sectionKey, fieldKey]}
                                                                                label={fieldValue.title}
                                                                            >
                                                                                {fieldValue.enum ? (
                                                                                    <Select placeholder="Seleccionar...">
                                                                                        {fieldValue.enum.map(opt => (
                                                                                            <Option key={opt} value={opt}>{opt}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                ) : fieldValue.format === 'date' ? (
                                                                                    <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                                                                                ) : fieldValue.type === 'number' ? (
                                                                                    <InputNumber style={{ width: '100%' }} />
                                                                                ) : fieldValue.maxLength && fieldValue.maxLength > 100 ? (
                                                                                    <TextArea rows={4} />
                                                                                ) : <Input />}
                                                                            </Form.Item>
                                                                        </Col>
                                                                    );
                                                                }}
                                                            </Form.Item>
                                                        );
                                                    }

                                                    const isTensionArterial = fieldKey === 'tension_arterial' && sectionKey === 'aparato_cardiovascular';
                                                    return (
                                                        <Col span={12} key={fieldKey}>
                                                            <Form.Item
                                                                name={['data', sectionKey, fieldKey]}
                                                                label={fieldValue.title}
                                                                rules={isTensionArterial ? [
                                                                    {
                                                                        pattern: new RegExp(fieldValue.pattern),
                                                                        message: 'Formato inválido (máx. 3 cifras por número). Use Sistólica/Diastólica (ej: 120/80)'
                                                                    }
                                                                ] : []}
                                                                extra={isTensionArterial ? fieldValue.description : null}
                                                            >
                                                                {fieldValue.enum ? (
                                                                    <Select placeholder="Seleccionar...">
                                                                        {fieldValue.enum.map(opt => (
                                                                            <Option key={opt} value={opt}>{opt}</Option>
                                                                        ))}
                                                                    </Select>
                                                                ) : fieldValue.format === 'date' ? (
                                                                    <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                                                                ) : fieldValue.type === 'number' ? (
                                                                    <InputNumber style={{ width: '100%' }} />
                                                                ) : fieldValue.maxLength && fieldValue.maxLength > 100 ? (
                                                                    <TextArea rows={4} />
                                                                ) : <Input />}
                                                            </Form.Item>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div key={sectionKey}>
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Divider orientation="left">{sectionValue.title}</Divider>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 8]}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={['data', sectionKey]}
                                                        label={sectionValue.title}
                                                    >
                                                        <TextArea rows={4} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    )}

                    {/* ANU: Admisión Nutrición */}
                    {admisionNutricion && (
                        <div>
                            {Object.entries(admisionNutricionSchema.properties).map(([sectionKey, sectionValue]) => {
                                if (sectionValue.type === 'object') {
                                    return (
                                        <div key={sectionKey}>
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Divider orientation="left">{sectionValue.title}</Divider>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 8]}>
                                                {Object.entries(sectionValue.properties).map(([fieldKey, fieldValue]) => {
                                                    const isTextarea = fieldKey === 'dieta' || fieldValue.type === 'textarea';
                                                    return (
                                                        <Col span={12} key={fieldKey}>
                                                            <Form.Item
                                                                name={['data', sectionKey, fieldKey]}
                                                                label={fieldValue.title}
                                                            >
                                                                {fieldValue.enum ? (
                                                                    <Select placeholder="Seleccionar...">
                                                                        {(fieldValue.enum || []).map(opt => (
                                                                            <Option key={opt} value={opt}>{opt}</Option>
                                                                        ))}
                                                                    </Select>
                                                                ) : fieldValue.type === 'number' ? (
                                                                    <InputNumber style={{ width: '100%' }} step={0.1} />
                                                                ) : isTextarea ? (
                                                                    <TextArea rows={4} />
                                                                ) : (
                                                                    <Input />
                                                                )}
                                                            </Form.Item>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                        </div>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    )}

                    {/* ECM: Evolución Clínica Mensual (dynamic from JSON) */}
                    {evolucionClinicaMensual && (
                        <div>
                            {Object.entries(evolucionClinicaMensualSchema.properties).map(([sectionKey, sectionValue]) => {
                                if (sectionValue.type === 'object') {
                                    return (
                                        <div key={sectionKey}>
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Divider orientation="left">{sectionValue.title}</Divider>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 8]}>
                                                {Object.entries(sectionValue.properties).map(([fieldKey, fieldValue]) => (
                                                    <Col span={12} key={fieldKey}>
                                                        {/* Mostrar "detalle" solo si el resultado es "Otros"/"Otro" y requerir mínimo 5 caracteres */}
                                                        {fieldKey === 'detalle' ? (
                                                            <Form.Item noStyle dependencies={[['data', sectionKey, 'resultado']]}>
                                                                {({ getFieldValue }) => {
                                                                    const parentValue = getFieldValue(['data', sectionKey, 'resultado']);
                                                                    if (parentValue !== 'Otros' && parentValue !== 'Otro') return null;
                                                                    return (
                                                                        <Form.Item
                                                                            name={['data', sectionKey, fieldKey]}
                                                                            label={fieldValue.title}
                                                                            rules={[{ required: true, message: 'Detalle es obligatorio.' }, { min: 5, message: 'Detalle debe tener al menos 5 caracteres.' }]}
                                                                        >
                                                                            <Input/>
                                                                        </Form.Item>
                                                                    );
                                                                }}
                                                            </Form.Item>
                                                        ) : (
                                                            <Form.Item
                                                                name={['data', sectionKey, fieldKey]}
                                                                label={fieldValue.title}
                                                                rules={(() => {
                                                                    // Reglas específicas por campo cuando aplica
                                                                    if (sectionKey === 'examen_fisico') {
                                                                        if (fieldKey === 'sat') return [{ pattern: /^[0-9]{2}$/, message: 'Ingrese sólo 2 dígitos (ej.: 96). La unidad (%) se muestra en el título.' }];
                                                                        if (fieldKey === 'ta') return [{ pattern: /^[0-9]{2,3}\/[0-9]{2,3}$/, message: 'Formato inválido. Use 120/80.' }];
                                                                        if (fieldKey === 'fc') return [{ pattern: /^[0-9]{2,3}$/, message: 'Ingrese 2 o 3 dígitos (ej.: 60, 75, 120).' }];
                                                                        if (fieldKey === 'temperatura') return [{ pattern: /^[0-9]{2},[0-9]$/, message: 'Formato inválido. Use coma: 36,7.' }];
                                                                        if (fieldKey === 'hgt') return [{ pattern: /^[0-9]{2,3}$/, message: 'Ingrese 2 o 3 dígitos (ej.: 120). La unidad (mg%) se muestra en el título.' }];
                                                                    }
                                                                    // Reglas para localización obligatoria si resultado positivo
                                                                    if ((sectionKey === 'puntos_ureterales' && fieldKey === 'localizacion')) {
                                                                        return [({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const res = getFieldValue(['data', 'puntos_ureterales', 'resultado']);
                                                                                if (res === 'Positivos' && !value) return Promise.reject(new Error('Seleccione la localización.'));
                                                                                return Promise.resolve();
                                                                            }
                                                                        })];
                                                                    }
                                                                    if ((sectionKey === 'ppr' && fieldKey === 'localizacion')) {
                                                                        return [({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const res = getFieldValue(['data', 'ppr', 'resultado']);
                                                                                if (res === 'Positivo' && !value) return Promise.reject(new Error('Seleccione la localización.'));
                                                                                return Promise.resolve();
                                                                            }
                                                                        })];
                                                                    }
                                                                    return [];
                                                                })()}
                                                            >
                                                                {fieldValue.enum ? (
                                                                    <Select
                                                                        placeholder="Seleccionar..."
                                                                        onChange={(val) => {
                                                                            // Limpiar campos condicionados cuando ya no aplican
                                                                            if (fieldKey === 'resultado' && (sectionKey === 'sistema_digestivo' || sectionKey === 'sistema_genitourinario')) {
                                                                                if (val !== 'Otros' && val !== 'Otro') {
                                                                                    const d = procedureForm.getFieldValue('data') || {};
                                                                                    if (d[sectionKey] && d[sectionKey].detalle) {
                                                                                        const next = { ...d, [sectionKey]: { ...d[sectionKey], detalle: undefined } };
                                                                                        procedureForm.setFieldsValue({ data: next });
                                                                                    }
                                                                                }
                                                                            }
                                                                            if (fieldKey === 'resultado' && sectionKey === 'puntos_ureterales') {
                                                                                if (val !== 'Positivos') {
                                                                                    const d = procedureForm.getFieldValue('data') || {};
                                                                                    const next = { ...d, puntos_ureterales: { ...(d.puntos_ureterales || {}), localizacion: undefined } };
                                                                                    procedureForm.setFieldsValue({ data: next });
                                                                                }
                                                                            }
                                                                            if (fieldKey === 'resultado' && sectionKey === 'ppr') {
                                                                                if (val !== 'Positivo') {
                                                                                    const d = procedureForm.getFieldValue('data') || {};
                                                                                    const next = { ...d, ppr: { ...(d.ppr || {}), localizacion: undefined } };
                                                                                    procedureForm.setFieldsValue({ data: next });
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {fieldValue.enum.map(opt => (
                                                                            <Option key={opt} value={opt}>{opt}</Option>
                                                                        ))}
                                                                    </Select>
                                                                ) : (
                                                                    <Input/>
                                                                )}
                                                            </Form.Item>
                                                        )}
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    );
                                }
                                // Campos simples al nivel raíz como "diagnostico", "indicaciones", "tratamiento_farmacologico", "otros" y "comentarios"
                                return (
                                    <Row gutter={[16,8]} key={sectionKey}>
                                        {sectionKey === 'diagnostico' ? (
                                            <>
                                                <Col span={20}>
                                                    <Form.Item name={['data', 'diagnostico']} label={sectionValue.title}>
                                                        <TextArea rows={3} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Button onClick={prefillECM} style={{ marginTop: 6 }}>Actualizar diagnóstico</Button>
                                                </Col>
                                            </>
                                        ) : sectionKey === 'indicaciones' ? (
                                            <Col span={24}>
                                                <Form.Item name={['data', 'indicaciones']} label={sectionValue.title}>
                                                    <TextArea rows={4} />
                                                </Form.Item>
                                            </Col>
                                        ) : sectionKey === 'tratamiento_farmacologico' ? (
                                            <>
                                                <Col span={24}>
                                                    <Form.Item shouldUpdate noStyle>
                                                        {() => {
                                                            const rows = procedureForm.getFieldValue(['data', 'tratamiento_farmacologico']) || [];
                                                            const columns = [
                                                                { title: 'Medicamento', dataIndex: 'medicamento', key: 'medicamento', width: 260, onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }) },
                                                                { title: 'Presentación', dataIndex: 'presentacion', key: 'presentacion', width: 200, onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }) },
                                                                { title: 'Dosis', dataIndex: 'dosis', key: 'dosis', width: 80, render: (val) => (val != null && val !== '') ? formatDoseByUnit(val, null) : '-' },
                                                                { title: 'Momento', dataIndex: 'momento', key: 'momento' },
                                                            ];
                                                            return (
                                                                <div style={{ width: '100%' }}>
                                                                    <div style={{ marginBottom: 8, fontWeight: 500 }}>{sectionValue.title}</div>
                                                                    <Table
                                                                        size="small"
                                                                        pagination={false}
                                                                        columns={columns}
                                                                        dataSource={(rows || []).map((r, idx) => ({ key: idx, ...r }))}
                                                                        locale={{ emptyText: 'Sin esquema clínico activo' }}
                                                                    />
                                                                </div>
                                                            );
                                                        }}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24} style={{ marginTop: 8 }}>
                                                    <Button onClick={prefillECM}>Actualizar tratamiento</Button>
                                                </Col>
                                            </>
                                        ) : (
                                            <Col span={24}>
                                                <Form.Item name={['data', sectionKey]} label={sectionValue.title}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>
                                );
                            })}
                        </div>
                    )}

                    {/* EPM: Evolución Psiquiátrica (simple desde JSON + esquema farmacológico + plantillas) */}
                    {evolucionPsiquiatricaMensual && (
                        <div>
                            {Object.entries(evolucionPsiquiatricaMensualSchema.properties).map(([sectionKey, sectionValue]) => (
                                <Row gutter={[16,8]} key={`epm-${sectionKey}`}>
                                    {sectionKey === 'diagnostico' ? (
                                        <>
                                            <Col span={20}>
                                                <Form.Item name={["data", "diagnostico"]} label={sectionValue.title}>
                                                    <TextArea rows={3} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                                                <Button onClick={prefillEPM} style={{ marginTop: 6 }}>Actualizar diagnóstico</Button>
                                            </Col>
                                        </>
                                    ) : sectionKey === 'evolucion' ? (
                                         <>
                                             {(epmTemplates || []).length > 0 && (
                                                 <Col span={24}>
                                                     <Form.Item label="Insertar plantilla de evolución">
                                                         <Select
                                                             placeholder={epmTemplatesLoading ? 'Cargando…' : 'Seleccionar plantilla...'}
                                                             loading={epmTemplatesLoading}
                                                             onChange={(templateId) => {
                                                                 const d = procedureForm.getFieldValue('data') || {};
                                                                 const current = d.evolucion || '';
                                                                 const sep = current ? (current.endsWith('\n') ? '' : '\n') : '';
                                                                 const tpl = (epmTemplates || []).find(t => t.id === templateId);
                                                                 const body = tpl && tpl.body ? tpl.body : '';
                                                                 procedureForm.setFieldsValue({ data: { ...d, evolucion: `${current}${sep}${body}` } });
                                                             }}
                                                             allowClear
                                                         >
                                                             {(epmTemplates || []).map((t) => (
                                                                 <Option key={`epm-tpl-${t.id}`} value={t.id}>
                                                                     {t.title}
                                                                 </Option>
                                                             ))}
                                                         </Select>
                                                     </Form.Item>
                                                 </Col>
                                             )}
                                             <Col span={24}>
                                                <Form.Item name={["data", "evolucion"]} label={sectionValue.title}>
                                                    <TextArea rows={6} />
                                                </Form.Item>
                                            </Col>
                                        </>
                                    ) : sectionKey === 'esquema_farmacologico' ? (
                                        <>
                                            <Col span={24}>
                                                <Form.Item shouldUpdate noStyle>
                                                    {() => {
                                                        const rows = procedureForm.getFieldValue(['data', 'esquema_farmacologico']) || [];
                                                        const columns = [
                                                            { title: 'Medicamento', dataIndex: 'medicamento', key: 'medicamento', width: 260, onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }) },
                                                            { title: 'Presentación', dataIndex: 'presentacion', key: 'presentacion', width: 200, onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }) },
                                                            { title: 'Dosis', dataIndex: 'dosis', key: 'dosis', width: 80, render: (val) => (val != null && val !== '') ? formatDoseByUnit(val, null) : '-' },
                                                            { title: 'Momento', dataIndex: 'momento', key: 'momento' },
                                                        ];
                                                        return (
                                                            <div style={{ width: '100%' }}>
                                                                <div style={{ marginBottom: 8, fontWeight: 500 }}>{sectionValue.title}</div>
                                                                <Table
                                                                    size="small"
                                                                    pagination={false}
                                                                    columns={columns}
                                                                    dataSource={(rows || []).map((r, idx) => ({ key: idx, ...r }))}
                                                                    locale={{ emptyText: 'Sin esquema psiquiátrico activo' }}
                                                                />
                                                            </div>
                                                        );
                                                    }}
                                                </Form.Item>
                                            </Col>
                                            <Col span={24} style={{ marginTop: 8 }}>
                                                <Button onClick={prefillEPM}>Actualizar esquema</Button>
                                            </Col>
                                        </>
                                    ) : (
                                        <Col span={24}>
                                            <Form.Item name={["data", sectionKey]} label={sectionValue.title}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                    )}
                                </Row>
                            ))}
                        </div>
                    )}

                    {/* CSM: Control de Sujeción Mecánica */}
                    {sujecionMecanica && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Control de Sujeción Mecánica</Divider>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={12}>
                                    <Form.Item name="csm_hora_inicio" label="Hora de inicio">
                                        <TimePicker format={"HH:mm"} style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="csm_indicado_medico" label="Indicado por médico">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item name="csm_tipo_sujecion" label="Tipo de sujeción">
                                        <Checkbox.Group options={["Tronco-Cama","Inmovilización de tronco s/llili","Inmovilización de MMSS","Inmovilización de MMII"]} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/*<Row gutter={[8,8]}>*/}
                            {/*    <Col span={24}>*/}
                            {/*        <Divider orientation="left">Constantes Vitales</Divider>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                            {/*<Row gutter={[8,8]}>*/}
                            {/*    <Col span={8}><Form.Item name="csm_ta" label="Tensión arterial (T.A.)"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_fc" label="Frecuencia cardíaca (F.C.)"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_fr" label="Frecuencia respiratoria (F.R.)"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_sat" label="Saturación O₂ (SAT)"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_temperatura" label="Temperatura corporal"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_decubito" label="Decúbito 45°"><Radio.Group options={[{label:'Sí',value:'Sí'},{label:'No',value:'No'}]} /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_diuresis" label="Diuresis"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_catarsis" label="Catarsis"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={8}><Form.Item name="csm_rotaciones" label="Rotaciones"><Radio.Group options={[{label:'Sí',value:'Sí'},{label:'No',value:'No'}]} /></Form.Item></Col>*/}
                            {/*    <Col span={12}><Form.Item name="csm_lesiones" label="Lesiones"><Input /></Form.Item></Col>*/}
                            {/*    <Col span={12}><Form.Item name="csm_observaciones" label="Observaciones"><TextArea /></Form.Item></Col>*/}
                            {/*</Row>*/}

                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Control cada 30 minutos</Divider>
                                </Col>
                            </Row>
                            <Form.List name="csm_controles">
                                {(fields, { add, remove }) => (
                                    <div>
                                        {fields.length === 0 && (
                                            <Card size="small" style={{ marginBottom: 8 }}>
                                                <em>No hay controles cargados.</em>
                                            </Card>
                                        )}
                                        {fields.map((field, idx) => (
                                            <Card
                                                key={field.key}
                                                size="small"
                                                title={`Control ${idx + 1}`}
                                                extra={<Button danger onClick={() => remove(field.name)}>Eliminar</Button>}
                                                style={{ marginBottom: 12 }}
                                            >
                                                <Row gutter={[8,8]}>
                                                    <Col xs={24} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'hora']} label="Hora" rules={[{ required: true, message: 'Ingrese la hora' }]}>
                                                            <TimePicker format={"HH:mm"} style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item label="T.A. (S/D)">
                                                            <Input.Group compact>
                                                                <Form.Item name={[field.name, 'ta_s']} noStyle>
                                                                    <InputNumber style={{ width: '50%' }} placeholder="Sist." />
                                                                </Form.Item>
                                                                <Form.Item name={[field.name, 'ta_d']} noStyle>
                                                                    <InputNumber style={{ width: '50%' }} placeholder="Diast." />
                                                                </Form.Item>
                                                            </Input.Group>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'fc']} label="F.C.">
                                                            <InputNumber style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'fr']} label="F.R.">
                                                            <InputNumber style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'sat']} label="SAT">
                                                            <InputNumber style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'temperatura']} label="Temp.">
                                                            <InputNumber style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'cabecera']} label="Cab. 45">
                                                            <Select options={[{ label: 'Sí', value: 'Sí' }, { label: 'No', value: 'No' }]} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'diuresis']} label="Diuresis">
                                                            <Select options={[{ label: 'Sí', value: 'Sí' }, { label: 'No', value: 'No' }]} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'catarsis']} label="Catarsis">
                                                            <Select options={[{ label: 'Sí', value: 'Sí' }, { label: 'No', value: 'No' }]} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'rotaciones']} label="Rotaciones">
                                                            <Select options={[{ label: 'Sí', value: 'Sí' }, { label: 'No', value: 'No' }]} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6}>
                                                        <Form.Item name={[field.name, 'lesiones']} label="Lesiones">
                                                            <Select options={[{ label: 'Sí', value: 'Sí' }, { label: 'No', value: 'No' }]} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Form.Item name={[field.name, 'notas']} label="Notas">
                                                            <TextArea rows={2} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        ))}
                                        <Button
                                            type="dashed"
                                            onClick={() => {
                                                const current = procedureForm.getFieldValue('csm_controles') || [];
                                                let next = moment();
                                                if (current && current.length > 0) {
                                                    const last = current[current.length - 1];
                                                    let m = null;
                                                    if (last && last.hora) {
                                                        if (moment.isMoment(last.hora)) m = last.hora.clone();
                                                        else m = moment(last.hora, ['HH:mm','HH:mm:ss'], true);
                                                    }
                                                    if (m && m.isValid()) next = m.add(30, 'minutes');
                                                }
                                                add({ hora: next });
                                            }}
                                            style={{ width: '100%', marginTop: 8 }}
                                        >
                                            Agregar control
                                        </Button>
                                    </div>
                                )}
                            </Form.List>
                        </div>
                    )}

                    {/* CSV: Constantes Vitales */}
                    {constantesVitales && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Control de Constantes Vitales</Divider>
                                </Col>
                            </Row>
                            <Form.List name="csv_controles">
                                {(fields, { add, remove }) => {
                                    const columns = [
                                        {
                                            title: 'Fecha',
                                            key: 'fecha',
                                            width: 160,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'fecha']} rules={[{ required: true, message: 'Ingrese la fecha' }]} style={{ marginBottom: 0 }}>
                                                    <DatePicker format={"DD/MM/YYYY"} style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Turno',
                                            key: 'turno',
                                            width: 130,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'turno']} rules={[{ required: true, message: 'Seleccione turno' }]} style={{ marginBottom: 0 }}>
                                                    <Select options={[
                                                        { label: 'Mañana', value: 'Mañana' },
                                                        { label: 'Tarde', value: 'Tarde' },
                                                        { label: 'Noche', value: 'Noche' },
                                                        { label: 'SADOFE-Turno Mañana', value: 'SADOFE-Turno Mañana' },
                                                        { label: 'SADOFE-Turno Tarde', value: 'SADOFE-Turno Tarde' }
                                                    ]} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'T.A. (A/B)',
                                            key: 'ta_ab',
                                            width: 160,
                                            render: (_, field) => (
                                                <Form.Item label={false} style={{ marginBottom: 0 }}>
                                                    <Input.Group compact>
                                                        <Form.Item name={[field.name, 'ta_alta']} noStyle rules={[{ required: true, message: 'Ingrese T.A. alta' }]}>
                                                            <InputNumber style={{ width: '50%' }} placeholder="Alta" />
                                                        </Form.Item>
                                                        <Form.Item name={[field.name, 'ta_baja']} noStyle rules={[{ required: true, message: 'Ingrese T.A. baja' }]}>
                                                            <InputNumber style={{ width: '50%' }} placeholder="Baja" />
                                                        </Form.Item>
                                                    </Input.Group>
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'F.C.',
                                            key: 'fc',
                                            width: 120,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'fc']} rules={[{ required: true, message: 'Ingrese F.C.' }]} style={{ marginBottom: 0 }}>
                                                    <InputNumber />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Temp.',
                                            key: 'temperatura',
                                            width: 120,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'temperatura']} rules={[{ required: true, message: 'Ingrese temperatura' }]} style={{ marginBottom: 0 }}>
                                                    <InputNumber />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'SpO₂',
                                            key: 'spo2',
                                            width: 120,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'spo2']} rules={[{ required: true, message: 'Ingrese SpO₂' }]} style={{ marginBottom: 0 }}>
                                                    <InputNumber />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Acciones',
                                            key: 'acciones',
                                            fixed: 'right',
                                            width: 100,
                                            render: (_, field) => (
                                                <Button danger onClick={() => remove(field.name)}>Eliminar</Button>
                                            )
                                        },
                                    ];
                                    const data = fields.map(f => ({ key: f.key, ...f }));
                                    return (
                                        <div>
                                            <Table
                                                size="small"
                                                pagination={false}
                                                dataSource={data}
                                                columns={columns}
                                                scroll={{ x: true }}
                                            />
                                            <Button
                                                type="dashed"
                                                onClick={() => {
                                                    add({ fecha: moment() });
                                                }}
                                                style={{ width: '100%', marginTop: 8 }}
                                            >
                                                Agregar registro
                                            </Button>
                                        </div>
                                    );
                                }}
                            </Form.List>
                        </div>
                    )}

                    {/* GLU: Glucemia */}
                    {glucemia && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Registro de Seguimiento de Glucemias</Divider>
                                </Col>
                            </Row>
                            {/*<Row gutter={[8,8]}>*/}
                            {/*    <Col span={24}>*/}
                            {/*        <Form.Item name="glu_paciente" label="Nombre y apellido">*/}
                            {/*            <Input />*/}
                            {/*        </Form.Item>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                            <Row gutter={[8,8]} style={{ marginBottom: 16 }}>
                                <Col span={24}>
                                    <div style={{ border: '1px solid #d9d9d9', borderRadius: 4, padding: '8px 16px', background: '#fffbe6' }}>
                                        <strong>Corrección de Insulina Corriente (Ins. Cte.)</strong>
                                        <table style={{ marginTop: 8, borderCollapse: 'collapse', width: '100%' }}>
                                            <thead>
                                                <tr style={{ background: '#fff1b8' }}>
                                                    <th style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>HGT (mg/dL)</th>
                                                    <th style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>Insulina Corriente</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>160 – 200</td><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>2 UI</td></tr>
                                                <tr><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>201 – 250</td><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>4 UI</td></tr>
                                                <tr><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>251 – 300</td><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>6 UI</td></tr>
                                                <tr><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>301 – 350</td><td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center' }}>8 UI</td></tr>
                                                <tr style={{ background: '#fff1f0' }}>
                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center', fontWeight: 'bold' }}>Más de 350</td>
                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px 12px', textAlign: 'center', fontWeight: 'bold', color: '#cf1322' }}>10 UI — SOLICITAR EMERGENCIA</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                            <Form.List name="glu_registros">
                                {(fields, { add, remove }) => {
                                    const columns = [
                                        {
                                            title: 'Fecha y hora',
                                            key: 'fecha_hora',
                                            width: 220,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'fecha_hora']} rules={[{ required: true, message: 'Ingrese fecha y hora' }]} style={{ marginBottom: 0 }}>
                                                    <DatePicker showTime format={"DD/MM/YYYY HH:mm"} style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'HGT (mg/dL)',
                                            key: 'hgt',
                                            width: 140,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'hgt']} rules={[{ required: true, message: 'Ingrese HGT' }]} style={{ marginBottom: 0 }}>
                                                    <InputNumber style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Insulina NPH (UI)',
                                            key: 'insulina_nph',
                                            width: 170,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'insulina_nph']} style={{ marginBottom: 0 }}>
                                                    <InputNumber style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Insulina Corriente (UI)',
                                            key: 'insulina_corriente',
                                            width: 190,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'insulina_corriente']} style={{ marginBottom: 0 }}>
                                                    <InputNumber style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Acciones',
                                            key: 'acciones',
                                            fixed: 'right',
                                            width: 100,
                                            render: (_, field) => (
                                                <Button danger onClick={() => remove(field.name)}>Eliminar</Button>
                                            )
                                        },
                                    ];
                                    const data = fields.map(f => ({ key: f.key, ...f }));
                                    return (
                                        <div>
                                            <Table
                                                size="small"
                                                pagination={false}
                                                dataSource={data}
                                                columns={columns}
                                                scroll={{ x: true }}
                                            />
                                            <Button
                                                type="dashed"
                                                onClick={() => {
                                                    add({ fecha_hora: moment() });
                                                }}
                                                style={{ width: '100%', marginTop: 8 }}
                                            >
                                                Agregar registro
                                            </Button>
                                        </div>
                                    );
                                }}
                            </Form.List>
                        </div>
                    )}

                    {/* PCA: Protocolo de Caídas */}
                    {protocoloCaidas && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Planilla de Protocolo de Caídas</Divider>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={12}>
                                    <Form.Item name="pca_fecha_hora" label="Fecha y Hora">
                                        <DatePicker showTime format={"DD/MM/YYYY HH:mm"} style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="pca_lugar_caida" label="Lugar de la caída">
                                        <Select options={[
                                            { label: 'Pasillo', value: 'Pasillo' },
                                            { label: 'Baño', value: 'Baño' },
                                            { label: 'Habitación', value: 'Habitación' },
                                            { label: 'Cama', value: 'Cama' },
                                            { label: 'Comedor', value: 'Comedor' },
                                            { label: 'Espacios comunes', value: 'Espacios comunes' },
                                            { label: 'Fuera de la institución', value: 'Fuera de la institución' },
                                            { label: 'Otro', value: 'Otro' },
                                        ]} />
                                    </Form.Item>
                                    <Form.Item noStyle shouldUpdate={(prev, cur) => prev.pca_lugar_caida !== cur.pca_lugar_caida}>
                                        {() => (
                                            procedureForm.getFieldValue('pca_lugar_caida') === 'Otro' ? (
                                                <Form.Item name="pca_lugar_caida_otro" label="Lugar (otro)">
                                                    <Input />
                                                </Form.Item>
                                            ) : null
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Form.Item name="pca_circunstancias" label="Circunstancias de la caída">
                                        <Checkbox.Group options={[
                                            'Pasajes',
                                            'Fallas de mantenimiento',
                                            'Falla contención física',
                                            'Falla de ayuda marcha',
                                            'Falla en el calzado',
                                            'Discapacidad visual/auditiva',
                                            'Enfermedad de base',
                                            'Otro'
                                        ]} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Form.Item name="pca_consecuencias" label="Consecuencias">
                                        <Checkbox.Group options={[
                                            'Hematoma',
                                            'Edema',
                                            'Pérdida de la conciencia',
                                            'Sangrado',
                                            'Rubor',
                                            'Dolor'
                                        ]} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Form.Item name="pca_localizacion" label="Localización en el cuerpo (esquema gráfico)">
                                        <TextArea />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={12}>
                                    <Form.Item name="pca_derivacion" label="¿Hubo derivación?">
                                        <Select options={[{ label: 'Sí', value: true }, { label: 'No', value: false }]} />
                                    </Form.Item>
                                    <Form.Item noStyle shouldUpdate={(prev, cur) => prev.pca_derivacion !== cur.pca_derivacion}>
                                        {() => (
                                            procedureForm.getFieldValue('pca_derivacion') === true ? (
                                                <Form.Item name="pca_derivacion_destino" label="Destino de derivación">
                                                    <Input />
                                                </Form.Item>
                                            ) : null
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="pca_aviso_flia" label="¿Se avisó a la familia?">
                                        <Select options={[{ label: 'Sí', value: true }, { label: 'No', value: false }]} />
                                    </Form.Item>
                                    <Form.Item noStyle shouldUpdate={(prev, cur) => prev.pca_aviso_flia !== cur.pca_aviso_flia}>
                                        {() => (
                                            procedureForm.getFieldValue('pca_aviso_flia') === true ? (
                                                <Form.Item name="pca_aviso_flia_con_quien" label="¿Con quién de la familia?">
                                                    <Input />
                                                </Form.Item>
                                            ) : null
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            {/*<Row gutter={[8,8]}>*/}
                            {/*    <Col span={24}>*/}
                            {/*        <Form.Item name="pca_medicacion_causal" label="Posible medicación causal">*/}
                            {/*            <Checkbox.Group options={[*/}
                            {/*                'Neurolépticos',*/}
                            {/*                'Antipsicóticos',*/}
                            {/*                'Benzodiacepinas',*/}
                            {/*                'Antihipertensivos',*/}
                            {/*                'Diuréticos',*/}
                            {/*                'Hipnóticos',*/}
                            {/*                'Alfa bloqueantes',*/}
                            {/*                'Betabloqueantes',*/}
                            {/*                'Anticonvulsivantes',*/}
                            {/*                'Automedicación reciente'*/}
                            {/*            ]} />*/}
                            {/*        </Form.Item>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Form.Item name="pca_comorbilidades" label="Comorbilidades">
                                        <Checkbox.Group options={[
                                            'Cardiovasculares',
                                            'Neurológicas',
                                            'Oncológicas',
                                            'Artrosis severa',
                                            'Trastornos visuales',
                                            'Trastornos auditivos',
                                            'Incontinencia',
                                            'Anemia',
                                            'DBT',
                                            'EPOC',
                                            'Anticoagulación'
                                        ]} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    )}

                    {/* AMU: Admisión Musicoterapia */}
                    {admisionMusicoterapia && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Admisión Musicoterapia</Divider>
                                </Col>
                            </Row>

                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Card size="small" title="Relación con la música" style={{ marginBottom: 16 }}>
                                        <Row gutter={[8,8]}>
                                            <Col span={12}>
                                                <Form.Item name="amu_estilo_musical_favorito" label="Estilo musical favorito">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="amu_artista_grupo_favorito" label="Artista o grupo favorito">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[8,8]}>
                                            <Col span={24}>
                                                <Form.Item name="amu_canciones_favoritas" label="Canciones favoritas">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[8,8]}>
                                            <Col span={24}>
                                                <Form.Item name="amu_conocimientos_musicales" label="Conocimientos musicales">
                                                    <TextArea rows={2} />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[8,8]}>
                                            <Col span={24}>
                                                <Form.Item name="amu_funciones_motoras_vinculo_objetos_sonoros" label="Funciones motoras y vínculo con objetos sonoros">
                                                    <TextArea rows={2} />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>

                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Card size="small" title="Relación personal" style={{ marginBottom: 16 }}>
                                        <Row gutter={[8,8]}>
                                            <Col span={12}>
                                                <Form.Item name="amu_conexion_con_la_realidad" label="Conexión con la realidad">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="amu_manejo_discurso_verbal" label="Manejo de discurso verbal">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[8,8]}>
                                            <Col span={12}>
                                                <Form.Item name="amu_manejo_discurso_musical" label="Manejo de discurso musical">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="amu_manejo_discurso_corporal" label="Manejo del discurso corporal">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>

                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Card size="small" title="Relación interpersonal" style={{ marginBottom: 16 }}>
                                        <Row gutter={[8,8]}>
                                            <Col span={24}>
                                                <Form.Item name="amu_relacion_vincular_pares" label="Relación vincular con sus pares">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[8,8]}>
                                            <Col span={12}>
                                                <Form.Item name="amu_participacion" label="Participación">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="amu_posicionamiento_grupo_adaptacion" label="Posicionamiento en el grupo y adaptación a la dinámica vincular">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    )}

                    {/* AAS: Admisión Asistente Social */}
                    {admisionAsisSocial && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Admisión Asistente Social</Divider>
                                </Col>
                            </Row>

                            <Card size="small" title="Datos Personales y Educación" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name="aas_estado_civil" label="Estado Civil">
                                            <Select options={[
                                                { label: 'Soltero', value: 'soltero' },
                                                { label: 'Casado', value: 'casado' },
                                                { label: 'Divorciado', value: 'divorciado' },
                                                { label: 'Otro', value: 'otro' },
                                            ]} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['aas_escolaridad', 'nivel']} label="Nivel de Escolaridad">
                                            <Select options={[
                                                { label: 'Primaria', value: 'primaria' },
                                                { label: 'Secundaria', value: 'secundaria' },
                                                { label: 'Terciario', value: 'terciario' },
                                                { label: 'Universitario', value: 'universitario' },
                                            ]} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['aas_escolaridad', 'estado']} label="Estado de Escolaridad">
                                            <Select options={[
                                                { label: 'En curso', value: 'en_curso' },
                                                { label: 'Finalizado', value: 'finalizado' },
                                            ]} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="aas_vivienda_propia" label="Vivienda Propia" valuePropName="checked">
                                            <Switch checkedChildren="Si" unCheckedChildren="No" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aas_antecedentes_laborales" label="Antecedentes Laborales">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Previsión y Legal" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={6}>
                                        <Form.Item name="aas_jubilado" label="Jubilado" valuePropName="checked">
                                            <Switch checkedChildren="Si" unCheckedChildren="No" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item name="aas_pensionado" label="Pensionado" valuePropName="checked">
                                            <Switch checkedChildren="Si" unCheckedChildren="No" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item name="aas_pensionado_por_invalidez" label="Pens. por Invalidez" valuePropName="checked">
                                            <Switch checkedChildren="Si" unCheckedChildren="No" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item name="aas_cud" label="CUD" valuePropName="checked">
                                            <Switch checkedChildren="Si" unCheckedChildren="No" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item name="aas_intervencion_judicial" label="Interv. Judicial" valuePropName="checked">
                                            <Switch checkedChildren="Si" unCheckedChildren="No" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.aas_cud !== currentValues.aas_cud}>
                                    {({ getFieldValue }) => (
                                        getFieldValue('aas_cud') ? (
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Form.Item name="aas_cud_numero" label="Número de CUD">
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        ) : null
                                    )}
                                </Form.Item>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name="aas_monto_haber_previsional" label="Monto Haber Previsional">
                                            <InputNumber min={0} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="aas_otro_ingreso" label="Otro Ingreso">
                                            <InputNumber min={0} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name="aas_capacidad_administrar_dinero" label="Capacidad Administrar Dinero">
                                            <Select options={[
                                                { label: 'Autónoma', value: 'autonoma' },
                                                { label: 'Parcial', value: 'parcial' },
                                                { label: 'Nula', value: 'nula' },
                                            ]} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="aas_apoderado_o_representante_legal" label="Apoderado o Rep. Legal">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Grupo Familiar o Convivientes" style={{ marginBottom: 16 }}>
                                <Form.List name="aas_grupo_familiar">
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (
                                                <div key={key} style={{ marginBottom: 16, borderBottom: '1px solid #f0f0f0', paddingBottom: 16 }}>
                                                    <Row gutter={[8,8]}>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'nombre_apellido']}
                                                                label="Nombre y Apellido"
                                                                rules={[{ required: true, message: 'Requerido' }]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'vinculo']}
                                                                label="Vínculo"
                                                                rules={[{ required: true, message: 'Requerido' }]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={[8,8]}>
                                                        <Col span={8}>
                                                            <Form.Item {...restField} name={[name, 'nacionalidad']} label="Nacionalidad">
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item {...restField} name={[name, 'estado_civil']} label="Estado Civil">
                                                                <Select options={[
                                                                    { label: 'Soltero', value: 'soltero' },
                                                                    { label: 'Casado', value: 'casado' },
                                                                    { label: 'Divorciado', value: 'divorciado' },
                                                                    { label: 'Otro', value: 'otro' },
                                                                ]} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item {...restField} name={[name, 'edad']} label="Edad">
                                                                <InputNumber min={0} style={{ width: '100%' }} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={[8,8]}>
                                                        <Col span={12}>
                                                            <Form.Item {...restField} name={[name, 'instruccion']} label="Instrucción">
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item {...restField} name={[name, 'ocupacion']} label="Ocupación">
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Button danger onClick={() => remove(name)} icon={<DeleteOutlined />}>
                                                        Eliminar Miembro
                                                    </Button>
                                                </div>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                    Añadir Miembro del Grupo Familiar
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Card>

                            <Card size="small" title="Información Adicional" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aas_quien_visita_al_residente" label="¿Quién visita al residente?">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aas_sintesis_historia_de_vida" label="Síntesis historia de vida">
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aas_resena_del_caso_y_motivo_de_internacion" label="Reseña del caso y motivo de internación">
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    )}

                    {/* ATO: Admisión Terapia Ocupacional */}
                    {admisionTerapiaOcupacional && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Admisión Terapia Ocupacional</Divider>
                                </Col>
                            </Row>

                            <Card size="small" title="Información General" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={16}>
                                        <Form.Item name="ato_diagnostico_psiquiatrico_principal" label="Diagnóstico psiquiátrico principal" rules={[{ required: true }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item name="ato_lateralidad" label="Lateralidad" rules={[{ required: true }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Historia Ocupacional" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['ato_historia_ocupacional', 'escolaridad']} label="Escolaridad">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['ato_historia_ocupacional', 'laboral']} label="Laboral">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Valoración Perceptivo / Sensorial" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['ato_valoracion_perceptivo_sensorial', 'vision']} label="Visión">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['ato_valoracion_perceptivo_sensorial', 'audicion']} label="Audición">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Row gutter={[8,8]}>
                                <Col span={12}>
                                    <Card size="small" title="Valoración Física" style={{ height: '100%' }}>
                                        <Form.Item name="ato_valoracion_fisica" noStyle>
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card size="small" title="Valoración Cognitiva" style={{ height: '100%' }}>
                                        <Form.Item name="ato_valoracion_cognitiva" noStyle>
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Card>
                                </Col>
                            </Row>

                            <Card size="small" title="Evaluación Funcional" style={{ marginTop: 16, marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name={['ato_evaluacion_funcional', 'avd_basicas']} label="AVD Básicas">
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <div style={{ fontWeight: 'bold', marginTop: 16, marginBottom: 16, borderBottom: '1px solid #f0f0f0', paddingBottom: 4 }}>
                                    AVD Instrumentales
                                </div>

                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['ato_evaluacion_funcional', 'uso_telefono']} label="Uso del teléfono">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['ato_evaluacion_funcional', 'manejo_dinero']} label="Manejo de dinero">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['ato_evaluacion_funcional', 'manejo_via_publica']} label="Manejo en la vía pública">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['ato_evaluacion_funcional', 'realiza_compras']} label="Realiza compras">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name={['ato_evaluacion_funcional', 'otros']} label="Otros">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Intereses de Tiempo Libre" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['ato_intereses_tiempo_libre', 'destreza_manual']} label="Actividades de destreza manual">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['ato_intereses_tiempo_libre', 'actividades_fisicas']} label="Actividades físicas">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name={['ato_intereses_tiempo_libre', 'actividades_intelectuales']} label="Actividades intelectuales">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name={['ato_intereses_tiempo_libre', 'actividades_socioculturales']} label="Actividades socioculturales">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name={['ato_intereses_tiempo_libre', 'otras']} label="Otras">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Rutina Diaria" style={{ marginBottom: 16 }}>
                                <Form.Item name="ato_rutina_diaria" noStyle>
                                    <TextArea rows={3} placeholder="Descripción de su rutina diaria" />
                                </Form.Item>
                            </Card>
                        </div>
                    )}

                    {/* AKI: Admisión Kinesiología */}
                    {admisionKinesiologia && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Admisión Kinesiología</Divider>
                                </Col>
                            </Row>

                            <Card size="small" title="Antecedentes Clínicos" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aki_antecedentes_quirurgicos" label="Quirúrgicos">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aki_antecedentes_traumatologicos" label="Traumatológicos (trastornos musculoesqueléticos)">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={24}>
                                        <Form.Item name="aki_antecedentes_patologicos" label="Patológicos (Ej: diabetes, HTA, obesidad)">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Grados de Dependencia" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name="aki_indice_katz" label="Índice de Katz" rules={[{ required: true }]}>
                                            <Select
                                                placeholder="Seleccione (A-G)"
                                                options={[
                                                    { label: 'A – Independiente en todas las actividades', value: 'A' },
                                                    { label: 'B – Independiente en todas las actividades, salvo una', value: 'B' },
                                                    { label: 'C – Independiente excepto bañarse y otra función adicional', value: 'C' },
                                                    { label: 'D – Independiente excepto bañarse, vestirse y otra función adicional', value: 'D' },
                                                    { label: 'E – Independiente excepto bañarse, vestirse, uso del retrete y otra función adicional', value: 'E' },
                                                    { label: 'F – Independiente excepto bañarse, vestirse, uso del retrete, movilidad y otra función adicional', value: 'F' },
                                                    { label: 'G – Dependiente en las seis funciones', value: 'G' },
                                                ]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="aki_observaciones_katz" label="Observaciones">
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Riesgo de Caídas (Escala de Tinetti)" style={{ marginBottom: 16 }}>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name="aki_tinetti_equilibrio" label="Equilibrio (0-16)" rules={[{ required: true }]}>
                                            <InputNumber min={0} max={16} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="aki_tinetti_marcha" label="Marcha (0-12)" rules={[{ required: true }]}>
                                            <InputNumber min={0} max={12} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[8,8]}>
                                    <Col span={12}>
                                        <Form.Item name="aki_tinetti_total" label="Puntaje total (0-28)">
                                            <InputNumber min={0} max={28} style={{ width: '100%' }} disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="aki_clasificacion_riesgo" label="Clasificación del riesgo de caída">
                                            <Select options={[
                                                { label: 'Alto riesgo de caída (<19)', value: 'Alto riesgo de caída (<19)' },
                                                { label: 'Riesgo de caída (19-24)', value: 'Riesgo de caída (19-24)' },
                                                { label: 'Bajo riesgo de caída (25-28)', value: 'Bajo riesgo de caída (25-28)' },
                                            ]} disabled />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    )}

                    {/* PAE: Proceso de Atención de Enfermería */}
                    {pae && (
                        <div>
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Proceso de Atención de Enfermería (PAE)</Divider>
                                </Col>
                            </Row>

                            <Card size="small" title="VALORACIÓN INICIAL" style={{ marginBottom: 16 }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Form.Item name="pae_autonomia" label="Nivel de autonomía">
                                            <Select options={PAE_AUTONOMIA_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_piel" label="Piel">
                                            <Select options={PAE_PIEL_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_lenguaje" label="Lenguaje">
                                            <Select options={PAE_LENGUAJE_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_audicion" label="Audición">
                                            <Select options={PAE_AUDICION_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_denticion" label="Dentición">
                                            <Select options={PAE_DENTICION_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_vision" label="Visión">
                                            <Select options={PAE_VISION_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={[8, 0]} align="middle">
                                            <Col span={10}>
                                                <Form.Item
                                                    name="pae_braden"
                                                    label="Escala de Riesgo de Úlceras por Presión"
                                                    extra="Resultado menor o igual a 14 → riesgo de UPP (rango válido: 5–20 puntos)"
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    {/* Solo números enteros entre 5 y 20 */}
                                                    <InputNumber
                                                        min={5}
                                                        max={20}
                                                        step={1}
                                                        style={{ width: '100%' }}
                                                        parser={(value) => {
                                                            if (value == null) return '';
                                                            // eliminar todo lo que no sea dígito
                                                            const onlyDigits = String(value).replace(/[^0-9]/g, '');
                                                            return onlyDigits;
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={14}>
                                                {/* Leyenda dinámica de riesgo al lado del campo */}
                                                <Form.Item shouldUpdate noStyle>
                                                    {({ getFieldValue }) => {
                                                        const raw = getFieldValue('pae_braden');
                                                        const num = typeof raw === 'number' ? raw : (raw === '' || raw == null ? null : Number(raw));
                                                        const show = !(num == null || Number.isNaN(num));
                                                        const riesgo = show ? num <= 14 : null;
                                                        return (
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                height: 48,
                                                                paddingLeft: 8,
                                                                color: riesgo === null ? '#888' : (riesgo ? '#cf1322' : '#389e0d')
                                                            }}>
                                                                {show ? (riesgo ? 'Riesgo de UPP' : 'Sin riesgo de UPP') : 'Ingrese un valor (5–20)'}
                                                            </div>
                                                        );
                                                    }}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_ambulacion" label="Escala de Ambulación">
                                            <Select options={PAE_AMBULACION_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_alimentacion" label="Alimentación">
                                            <Select options={PAE_ALIMENTACION_OPTIONS.map(opt => ({ label: opt, value: opt }))} allowClear />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_valoracion_otros" label="Otros detalles de valoración">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Diagnóstico de Enfermería (NANDA)" style={{ marginBottom: 16 }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Form.Item name="pae_nanda" label="Diagnósticos seleccionados">
                                            <Checkbox.Group>
                                                <Space direction="vertical">
                                                    {PAE_NANDA_OPTIONS.map(opt => <Checkbox key={opt} value={opt}>{opt}</Checkbox>)}
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_nanda_otros" label="Otros diagnósticos">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Planificación" style={{ marginBottom: 16 }}>
                                <Row gutter={[8, 8]}>
                                    <Form.Item noStyle dependencies={['pae_autonomia']}>
                                        {({ getFieldValue }) => {
                                            const autonomia = getFieldValue('pae_autonomia');
                                            if (autonomia === "Autoválido") {
                                                return (
                                                    <Col span={24}>
                                                        <Form.Item name="pae_plan_autovalido" label="Autoválido">
                                                            <Checkbox.Group>
                                                                <Space direction="vertical">
                                                                    {PAE_PLAN_AUTOVALIDO_OPTIONS.map(opt => <Checkbox key={opt} value={opt}>{opt}</Checkbox>)}
                                                                </Space>
                                                            </Checkbox.Group>
                                                        </Form.Item>
                                                    </Col>
                                                );
                                            }
                                            if (autonomia === "Ayuda parcial para la movilización") {
                                                return (
                                                    <Col span={24}>
                                                        <Form.Item name="pae_plan_ayuda_parcial" label="Ayuda parcial para la movilización">
                                                            <Checkbox.Group>
                                                                <Space direction="vertical">
                                                                    {PAE_PLAN_AYUDA_PARCIAL_OPTIONS.map(opt => <Checkbox key={opt} value={opt}>{opt}</Checkbox>)}
                                                                </Space>
                                                            </Checkbox.Group>
                                                        </Form.Item>
                                                    </Col>
                                                );
                                            }
                                            if (autonomia === "Dependencia total") {
                                                return (
                                                    <Col span={24}>
                                                        <Form.Item name="pae_plan_dependencia" label="Dependencia total">
                                                            <Checkbox.Group>
                                                                <Space direction="vertical">
                                                                    {PAE_PLAN_DEPENDENCIA_OPTIONS.map(opt => <Checkbox key={opt} value={opt}>{opt}</Checkbox>)}
                                                                </Space>
                                                            </Checkbox.Group>
                                                        </Form.Item>
                                                    </Col>
                                                );
                                            }
                                            return null;
                                        }}
                                    </Form.Item>
                                    <Col span={24}>
                                        <Form.Item name="pae_plan_otros" label="Otros planes">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            <Card size="small" title="Ejecución (según diagnóstico)" style={{ marginBottom: 16 }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Form.Item name="pae_intervenciones" label="Intervenciones">
                                            <Checkbox.Group>
                                                <Space direction="vertical">
                                                    {PAE_INTERVENCIONES_OPTIONS.map(opt => <Checkbox key={opt} value={opt}>{opt}</Checkbox>)}
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item name="pae_intervenciones_otros" label="Otros detalles de ejecución">
                                            <TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    )}

                    {/* PES: Peso Semanal */}
                    {pesoSemanal && (
                        <div>
                            <Row gutter={[8,8]}>
                                <Col span={24}>
                                    <Divider orientation="left">Control de Peso Semanal</Divider>
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col span={12}>
                                    <Form.Item name="pes_mes_anio" label="Mes y Año" rules={[{ required: true, message: 'Seleccione Mes y Año' }]}>
                                        <DatePicker picker="month" format={"MMMM YYYY"} style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item name="pes_talla" label="Talla (cm)">
                                        <InputNumber step={0.1} min={0} style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.List name="pes_registros">
                                {(fields, { add, remove }) => {
                                    const columns = [
                                        {
                                            title: 'Semana',
                                            key: 'semana',
                                            width: 120,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'semana']} rules={[{ required: true, message: 'Seleccione semana (1-4)' }]} style={{ marginBottom: 0 }}>
                                                    <Select options={[
                                                        { label: '1', value: 1 },
                                                        { label: '2', value: 2 },
                                                        { label: '3', value: 3 },
                                                        { label: '4', value: 4 },
                                                    ]} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Fecha',
                                            key: 'fecha',
                                            width: 160,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'fecha']} rules={[{ required: true, message: 'Ingrese la fecha' }]} style={{ marginBottom: 0 }}>
                                                    <DatePicker format={"DD/MM/YYYY"} style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Peso (kg)',
                                            key: 'peso',
                                            width: 140,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'peso']} rules={[{ required: true, message: 'Ingrese peso' }]} style={{ marginBottom: 0 }}>
                                                    <InputNumber step={0.1} min={0} style={{ width: '100%' }} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Notas',
                                            key: 'notas',
                                            width: 240,
                                            render: (_, field) => (
                                                <Form.Item name={[field.name, 'notas']} style={{ marginBottom: 0 }}>
                                                    <Input.TextArea rows={1} />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: 'Acciones',
                                            key: 'acciones',
                                            fixed: 'right',
                                            width: 100,
                                            render: (_, field) => (
                                                <Button danger onClick={() => remove(field.name)}>Eliminar</Button>
                                            )
                                        },
                                    ];
                                    const data = fields.map(f => ({ key: f.key, ...f }));
                                    const onAdd = () => {
                                        const today = moment();
                                        const day = today.date();
                                        let semana = Math.floor((day - 1) / 7) + 1; // 1-7:1, 8-14:2, 15-21:3, 22-31:4
                                        if (semana > 4) semana = 4;
                                        add({ semana, fecha: today });
                                    };
                                    const disabledAdd = (procedureForm.getFieldValue('pes_registros') || []).length >= 4;
                                    return (
                                        <div>
                                            {fields.length === 0 && (
                                                <Card size="small" style={{ marginBottom: 8 }}>
                                                    <em>No hay registros cargados.</em>
                                                </Card>
                                            )}
                                            {fields.map((field, idx) => (
                                                <Card
                                                    key={field.key}
                                                    size="small"
                                                    title={`Registro ${idx + 1}`}
                                                    extra={<Button danger onClick={() => remove(field.name)}>Eliminar</Button>}
                                                    style={{ marginBottom: 12 }}
                                                >
                                                    <Row gutter={[8,8]}>
                                                        <Col xs={12} sm={8} md={6} lg={4}>
                                                            <Form.Item name={[field.name, 'semana']} label="Semana" rules={[{ required: true, message: 'Seleccione semana (1-4)' }]}>
                                                                <Select options={[
                                                                    { label: '1', value: 1 },
                                                                    { label: '2', value: 2 },
                                                                    { label: '3', value: 3 },
                                                                    { label: '4', value: 4 },
                                                                ]} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xs={12} sm={8} md={6} lg={6}>
                                                            <Form.Item name={[field.name, 'fecha']} label="Fecha" rules={[{ required: true, message: 'Ingrese la fecha' }]}>
                                                                <DatePicker format={"DD/MM/YYYY"} style={{ width: '100%' }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xs={12} sm={8} md={6} lg={6}>
                                                            <Form.Item name={[field.name, 'peso']} label="Peso (kg)" rules={[{ required: true, message: 'Ingrese peso' }]}>
                                                                <InputNumber step={0.1} min={0} style={{ width: '100%' }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Form.Item name={[field.name, 'notas']} label="Notas">
                                                                <Input.TextArea rows={2} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            ))}
                                            <Button
                                                type="dashed"
                                                onClick={onAdd}
                                                disabled={disabledAdd}
                                                style={{ width: '100%', marginTop: 8 }}
                                            >
                                                Agregar registro
                                            </Button>
                                        </div>
                                    );
                                }}
                            </Form.List>
                        </div>
                    )}

                    {/* EIE: Evaluación de Enfermería al Ingreso */}
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_apellido_nombre" label="Apellido y Nombre"><Input /></Form.Item>*/}
                        {/*</Col>*/}
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_edad" label="Edad"><InputNumber style={{ width: '100%' }} /></Form.Item>*/}
                        {/*</Col>*/}
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_sexo" label="Sexo"><Input /></Form.Item>*/}
                        {/*</Col>*/}
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_obra_social" label="Obra Social"><Input /></Form.Item>*/}
                        {/*</Col>*/}
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_fecha" label="Día"><DatePicker format={"DD/MM/YYYY"} /></Form.Item>*/}
                        {/*</Col>*/}
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_hora" label="Hora"><TimePicker format={"HH:mm"} style={{ width: '100%' }} /></Form.Item>*/}
                        {/*</Col>*/}
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={nurseAdmissionEval ? {display: 'inline'} : {display: 'none'}}>
                            <Divider orientation="left">Localizaciones de úlceras / tatuajes / lesiones / cicatrices / hematomas</Divider>
                        </Col>
                    </Row>
                    {/* Nueva UI EIE: lista completa de localizaciones con checkbox y marcas */}
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        <Col span={24}>
                            {/* Campos ocultos para mantener el valor en el formulario */}
                            <Form.Item name="eie_localizaciones" style={{ display: 'none' }}>
                                <Input type="hidden" />
                            </Form.Item>
                            <Form.Item name="eie_localizaciones_detalle" style={{ display: 'none' }}>
                                <Input type="hidden" />
                            </Form.Item>
                            <Form.Item shouldUpdate noStyle>
                                {() => {
                                    const selected = procedureForm.getFieldValue('eie_localizaciones') || [];
                                    const detail = procedureForm.getFieldValue('eie_localizaciones_detalle') || {};

                                    const toggleLocation = (loc, checked) => {
                                        const setSel = new Set(selected);
                                        const nextSel = new Set(setSel);
                                        if (checked) nextSel.add(loc); else nextSel.delete(loc);
                                        // Sincronizar detalle: mantener solo claves seleccionadas
                                        const nextDetail = {};
                                        Array.from(nextSel).forEach(k => {
                                            nextDetail[k] = Array.isArray(detail[k]) ? detail[k] : [];
                                        });
                                        procedureForm.setFieldsValue({
                                            eie_localizaciones: Array.from(nextSel),
                                            eie_localizaciones_detalle: nextDetail,
                                        });
                                    };

                                    const onChangeTags = (loc, vals) => {
                                        const currSel = new Set(selected);
                                        // Si marca tags y la localización no está seleccionada, auto-seleccionar
                                        if (vals && vals.length > 0 && !currSel.has(loc)) {
                                            currSel.add(loc);
                                        }
                                        const nextDetail = { ...(detail || {}) };
                                        nextDetail[loc] = vals;
                                        // Asegurar consistencia de claves del detalle con seleccionados
                                        const filteredDetail = {};
                                        Array.from(currSel).forEach(k => { filteredDetail[k] = Array.isArray(nextDetail[k]) ? nextDetail[k] : []; });
                                        procedureForm.setFieldsValue({
                                            eie_localizaciones: Array.from(currSel),
                                            eie_localizaciones_detalle: filteredDetail,
                                        });
                                    };

                                    return (
                                        <div style={{ border: '1px dashed #d9d9d9', padding: 12, borderRadius: 4, marginTop: 0 }}>
                                            <div style={{ fontWeight: 500, marginBottom: 8 }}>Localizaciones y marcas</div>
                                            {EIE_LOCATIONS.map(loc => {
                                                const isChecked = Array.isArray(selected) ? selected.includes(loc) : false;
                                                const tagsVal = Array.isArray(detail[loc]) ? detail[loc] : [];
                                                return (
                                                    <div key={loc} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 8 }}>
                                                        <div style={{ width: 260 }}>
                                                            <Checkbox
                                                                checked={isChecked}
                                                                onChange={e => toggleLocation(loc, e.target.checked)}
                                                            >
                                                                {loc}
                                                            </Checkbox>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <Checkbox.Group
                                                                options={EIE_TAG_OPTIONS}
                                                                value={tagsVal}
                                                                onChange={(vals) => onChangeTags(loc, vals)}
                                                                disabled={!isChecked}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                }}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[8, 8]}>
                        <Col span={24} style={nurseAdmissionEval ? {display: 'inline'} : {display: 'none'}}>
                            <Divider orientation="left">Condiciones de Ingreso</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        <Col span={24}>
                            <Form.Item name="eie_procedencia" label="Lugar de procedencia"><Input /></Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="eie_ingresa" label="El paciente ingresa">
                                <Radio.Group>
                                    <Radio value="En camilla">En camilla</Radio>
                                    <Radio value="En silla">En silla</Radio>
                                    <Radio value="Deambula">Deambula</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_acompanado" label="Acompañado por familiar/responsable">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_conciencia" label="Está consciente">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_orientacion" label="Está ubicado en tiempo y espacio">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_higiene" label="Se encuentra en buenas condiciones de higiene">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_heridas" label="Tiene heridas">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_heridas_cuales" label="Cuáles">
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={nurseAdmissionEval ? {display: 'inline'} : {display: 'none'}}>
                            <Divider orientation="left">Antecedentes Clínicos</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eie_antecedentes"
                                label=""
                                style={nurseAdmissionEval ? {display: 'inline', marginRight: 8} : {display: 'none'}}
                            >
                                <Checkbox.Group options={["Diabetes", "Hipertensión Arterial", "Alergias", "Otras"]} />
                            </Form.Item>
                        </Col>
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name="eie_antecedentes_cuales" label="Cuálesss">*/}
                        {/*        <Input />*/}
                        {/*    </Form.Item>*/}
                        {/*</Col>*/}
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eie_antecedentes_detalle"
                                label="Detalles de antecedentes clínicos"
                                style={nurseAdmissionEval ? {display: 'inline', marginRight: 8} : {display: 'none'}}
                            >
                                <TextArea />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={nurseAdmissionEval ? {display: 'inline'} : {display: 'none'}}>
                            <Divider orientation="left">Constantes vitales</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        <Col span={8}>
                            <Form.Item name="eie_tension" label="TA"><Input /></Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="eie_fc" label="Frecuencia cardíaca (FC)"><Input /></Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="eie_fr" label="Frecuencia respiratoria (FR)"><Input /></Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="eie_temperatura" label="Temperatura (T°)"><Input /></Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="eie_peso" label="Peso"><Input /></Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="eie_saturacion" label="Saturación"><Input /></Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={nurseAdmissionEval ? {display: 'inline'} : {display: 'none'}}>
                            <Divider orientation="left">Ayudas técnicas</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        <Col span={12}>
                            <Form.Item name="eie_audifonos" label="Usa audífonos">
                                <Checkbox.Group options={["Sí - Izquierdo", "Sí - Derecho", "No"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_anteojos" label="Usa anteojos">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_protesis_dental" label="Prótesis dental">
                                <Checkbox.Group options={["Superior", "Inferior", "No"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_andador_baston" label="Usa andador o bastón">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_silla_ruedas" label="Usa silla de ruedas">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        <Col span={24}>
                            <Form.Item name="eie_dieta" label="Se indica dieta">
                                <Checkbox.Group options={["Hiposódica", "Blanda", "Hipocalórica", "Hipohidrocarbonada", "Gástrica", "Otra"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_dieta_cuales" label="Cuáles">
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]} style={nurseAdmissionEval ? {display: 'flex'} : {display: 'none'}}>
                        <Col span={12}>
                            <Form.Item name="eie_pertenencias" label="Se entregan pertenencias y valores al familiar responsable">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="eie_dinero" label="Ingresa con dinero">
                                <Radio.Group>
                                    <Radio value="Sí">Sí</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="eie_observaciones"*/}
                    {/*            label="Observaciones"*/}
                    {/*            style={nurseAdmissionEval ? {display: 'inline', marginRight: 8} : {display: 'none'}}*/}
                    {/*        >*/}
                    {/*            <TextArea />*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24} style={nurseAdmissionEval ? {display: 'inline'} : {display: 'none'}}>*/}
                    {/*        <Divider orientation="left">Datos del Paciente</Divider>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="notes"
                                label="Observaciones"
                                style={psicologicalAdmision || psiquitricNurse || simpleProcedure || admisionMusicoterapia || admisionAsisSocial ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*<Row gutter={[8, 8]}>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <Form.Item*/}
                    {/*            name="defense_mecanism"*/}
                    {/*            label="Mecanismos de defensa"*/}
                    {/*            style={*/}
                    {/*                psicologicalEvolution ? {display: "inline", marginRight: 8} : {display: "none"}*/}
                    {/*                // () => {*/}
                    {/*                //     if (psicologicalEvolution || psiquitricEvolution){*/}
                    {/*                //         return {display: "inline", marginRight: 8}*/}
                    {/*                //     }*/}
                    {/*                //     else{*/}
                    {/*                //         return {display: "none"}*/}
                    {/*                //     }*/}
                    {/*                // }*/}
                    {/*            }*/}
                    {/*        >*/}
                    {/*            <TextArea/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="next_appointment"
                                label="Proxima consulta"
                                style={
                                    psiquitricEvolution ? {
                                        display: "inline",
                                        marginRight: 8
                                    } : {display: "none"}
                                }
                            >
                                <DatePicker format={"DD/MM/YYYY"}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricExam ? {display: "inline"} : {display: "none"}}>
                            <Divider orientation="left">Aspectos Generales</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="actitud_aspecto"
                                label="Actitud y Aspecto"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder=""
                                    showArrow={false}
                                >
                                    <Option value="NO">Normal</Option>
                                    <Option value="EX">Estado</Option>
                                    <Option value="DE">Deprimido</Option>
                                    <Option value="AN">Ansioso</Option>
                                    <Option value="IN">Indiferente</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="sintomas_motores"
                                label="Sintomas Motores"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="sueno"
                                label="Sueño"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="NOC">No Concilia</Option>
                                    <Option value="DES">Despertar temprano</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="apetito"
                                label="Apetito"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="ANX">Anorexia</Option>
                                    <Option value="HIE">Hiperorexia</Option>
                                    <Option value="HIO">Hiporexia</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="marcha"
                                label="Marcha"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="NOD">No deambula</Option>
                                    <Option value="SOP">Usa soporte</Option>
                                    <Option value="CAY">Con ayuda</Option>

                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="incontinencia"
                                label="Incontinencia de esfinteres"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}>
                            <Divider orientation="left">Área Cognitiva</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="desorientacion"
                                label="Desorientacion"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="conciencia"
                                label="Conciencia de enfermedad mental"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder="si/no"
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="memoria"
                                label="Memoria"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="ALT">Alterada</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="sensopercepcion"
                                label="Sensopercepcion"
                                style={psiquitricExam ? {display: "inline", marginRight: 8} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="ALU">Alucinaciones</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="atencion"
                                label="Atencion"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="HPO">Hipoprosexia</Option>
                                    <Option value="PAR">Paraprosexia</Option>
                                    <Option value="HPE">Hiperprosexica</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="alteracion"
                                label="Alteraciones de Ideacion y Pensamiento"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="COH">Coherencia</Option>
                                    <Option value="INC">Incoherencia</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="capital"
                                label="Capital"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="NOR">Normal</Option>
                                    <Option value="DIS">Disminuido</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="ideas_patologicas"
                                label="Ideas Patologicas"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder={"si/no"}
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="ideas_persecutorias"
                                label="Ideas persecutorias"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="HIP">Hipocondriacas</Option>
                                    <Option value="MIS">Misticas</Option>
                                    <Option value="FOB">Fobicas</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="comprometen_conductas"
                                label="Comprometen conductas"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder={"si/no"}
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="juicio"
                                label="Juicio"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="CON">Conservado</Option>
                                    <Option value="DIS">Disminuido</Option>
                                    <Option value="INS">Insuficiente</Option>
                                    <Option value="DES">Desviado</Option>
                                    <Option value="SUS">Suspendido</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricExam ? {display: "inline"} : {display: "none"}}>
                            <Divider orientation="left">Área Volitiva</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="toc"
                                label="TOC"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder={"si/no"}
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricExam ? {display: "inline"} : {display: "none"}}>
                            <Divider orientation="left">Área Tímica</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="timismo_estable"
                                label="Timismo estable"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder={"si/no"}
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="afectividad_inapropiada"
                                label="Afectividad Inapropiada"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    placeholder={"si/no"}
                                    showArrow={false}
                                >
                                    <Option value="SI">Si</Option>
                                    <Option value="NO">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="hipertimia"
                                label="Hipertimia"
                                style={psiquitricExam ? {display: "inline"} : {display: "none"}}
                            >
                                <Select
                                    allowClear
                                    showArrow={false}
                                >
                                    <Option value="DIS">Displacentera</Option>
                                    <Option value="PLA">Placentera</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricExam ? {display: "inline"} : {display: "none"}}>
                            <Divider orientation="left">Diagnostico Psiquiatrico (DSM IV)</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eje_uno"
                                label="Eje I"
                                style={
                                    psiquitricExam ? {display: "inline"} : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eje_dos"
                                label="Eje II"
                                style={
                                    psiquitricExam ? {display: "inline"} : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eje_tres"
                                label="Eje III"
                                style={
                                    psiquitricExam ? {display: "inline"} : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eje_cuatro"
                                label="Eje IV"
                                style={
                                    psiquitricExam ? {display: "inline"} : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="eje_cinco"
                                label="Eje V"
                                style={
                                    psiquitricExam ? {display: "inline"} : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={psiquitricExam ? {display: "inline"} : {display: "none"}}>
                            <Divider orientation="left">Diagnostico Psiquiatrico (CIE 10)</Divider>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name="cie_10"
                                style={
                                    psiquitricExam ? {display: "inline"} : {display: "none"}
                                }
                            >
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        name="patient"
                        label="patient"
                        hidden
                    >
                        <Input hidden/>
                    </Form.Item>
                </Form>
                </Spin>
                <Divider orientation="left"></Divider>
                <Upload customRequest={uploadFile}
                        accept={'pdf'}
                        onChange={onChangeUploadFile}
                        key={procedureForm.getFieldValue('id')}
                >
                    <Button icon={<UploadOutlined/>} disabled={disbleUpload}>Subir archivo</Button>
                </Upload>
                <Divider orientation="left"></Divider>

                <List
                    header={"Archivos"}
                    itemLayout="horizontal"
                    dataSource={patientProgressFiles}
                    renderItem={item => (
                        <List.Item
                            actions={[<a onClick={() => onDeletePatientProgressFile(item)}>eliminar</a>]}
                        >
                            <List.Item.Meta
                                title={<a
                                    onClick={() => handleDownloadFile(item.id, item.filename)}>{item.filename}</a>}
                                //description= {item.username} {moment(item.create_date).format('DD-MM-YYYY')}
                                description={`Creado por ${item.username} el ${moment(item.create_date).format('DD-MM-YYYY')}`}
                            />
                        </List.Item>
                    )}
                />
            </Drawer>
        </>
    )
}

export default PatientProgress
